import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      nav: {
        home: "Home",
        properties: "Properties",
        agents: "Agents",
        tickets: "Tickets",
        investments: "Investments",
        lawyerDesk: "Lawyer desk",
        live: "Live",
        about: "About us",
        contact: "Help",
        dashboard: "Admin office",
        messages: "Inbox",
        alerts: "Alerts",
        billing: "Billing",
        agentDashboard: "Office",
        ownerDashboard: "My listings",
        login: "Sign in",
        register: "Join",
        myHomes: "My properties",
        saved: "Saved",
        offers: "Offers",
        navigation: "Navigation",
        menuTitle: "Menu",
        brandSubtitle: "Properties in Lebanon",
        beta: "Beta",
        darkMode: "Dark Mode",
        lightMode: "Light Mode",
        openProfile: "Open Profile",
        language: "AR",
        switchLanguage: "العربية",
      },
      app: {
        postNotFound: "This listing is not available.",
        generalError: "Something went wrong.",
      },
      helpChat: {
        open: "Help",
        close: "Close",
        back: "Back",
        startOver: "Start over",
        title: "Help",
        kicker: "ShoufBayt",
        steps: {
          start: "What do you need help with?",
          technical: "Choose the technical problem.",
          business: "Choose a business topic. Payment and the agent office are turned off for now.",
          techLogin: "Open Sign in. If you forgot the password, use Forgot password and follow the email.",
          techPhone: "Open phone verification and enter the code sent to your number.",
          techPage: "Refresh the page. For photos, use JPG, PNG, or WEBP, then try the upload again.",
          techAccount: "Open your profile to update your name, phone, and account details.",
          bizListings: "Browse properties on the listings page. To publish one, sign in and open List a property.",
          bizAgentContact: "Open a property. The agent phone and the contact button are on that page.",
          bizOther: "If this is not about a listing or an agent’s contact details, message the business team on WhatsApp.",
        },
        choices: {
          technical: "Technical problem",
          business: "Business problem",
          login: "Sign in or password",
          phone: "Phone verification",
          page: "Page or photos",
          account: "Account",
          listings: "Listings",
          agentContact: "Agent contact info",
          other: "Something else",
          notHelped: "This did not help",
          openLogin: "Go to sign in",
          forgot: "Forgot password",
          openPhone: "Verify phone",
          openProfile: "Open profile",
          browse: "Browse properties",
          listProperty: "List a property",
          whatsapp: "Message on WhatsApp",
        },
        whatsappText: {
          technical: "Hello, I need help with a technical issue on ShoufBayt.",
          business: "Hello, I need help with a business issue on ShoufBayt.",
        },
      },
      tickets: {
        badge: "Legal tickets",
        title: "Tickets",
        text: "",
        deskTitle: "Desk",
        deskText: "",
        cols: {
          number: "No.",
          case: "Case",
          client: "Client",
          lawyer: "Lawyer",
          phone: "Phone",
          status: "Status",
        },
        new: "New ticket",
        request: "Request a ticket",
        board: "In review",
        boardEmpty: "No tickets in review.",
        yourTickets: "Your tickets",
        newTitle: "New ticket",
        newText: "",
        back: "All tickets",
        filter: "Status",
        all: "All",
        loading: "Loading tickets…",
        emptyTitle: "No tickets yet",
        emptyText: "Open a ticket if you need legal help with a deal or dispute.",
        openCount: "{{count}} open",
        submit: "Open ticket",
        saving: "Saving…",
        reply: "Send reply",
        assign: "Assign lawyer",
        assignLawyer: "Assign to lawyer",
        chooseLawyer: "Choose a lawyer",
        unassigned: "Waiting for assignment",
        assignedTo: "Lawyer: {{name}}",
        lawyerPanel: "Assigned lawyer",
        waitingLawyer: "Not assigned yet",
        waitingLawyerText: "An admin will assign a lawyer.",
        workloadTitle: "Lawyers",
        workloadHeading: "Active tickets",
        activeCount: "{{count}} active",
        noLawyers: "No lawyers yet",
        noLawyersText: "Create a lawyer account, then assign tickets from here.",
        closed: "This ticket is closed.",
        someone: "User",
        imagesHint: "Optional. Up to 8 photos, JPG PNG or WEBP.",
        fields: {
          title: "Title",
          phone: "Phone number",
          category: "Category",
          description: "What happened",
          images: "Photos (optional)",
          reply: "Reply",
          status: "Status",
        },
        category: {
          REAL_ESTATE_DOCUMENTS: "Real estate documents",
          LAND_REGISTRY_CADASTRE: "Land Registry and Cadastre",
          CONSTRUCTION: "Construction",
          LAWYER_DEFENSE: "Lawyer defence",
          PAYMENT: "Payment",
          OTHER: "Other",
          CONTRACT: "Contract",
          NEIGHBOR: "Neighbor / building",
          DELAY: "Delay",
        },
        status: {
          OPEN: "Open",
          IN_REVIEW: "In review",
          WAITING_USER: "Waiting on you",
          WAITING_OTHER: "Waiting on other party",
          RESOLVED: "Resolved",
          CLOSED: "Closed",
        },
        errors: {
          load: "Could not load tickets.",
          loadOne: "Could not load this ticket.",
          create: "Could not create the ticket.",
          phone: "Enter a valid phone number.",
          reply: "Could not send the reply.",
          take: "Could not take the ticket.",
          assign: "Could not assign the lawyer.",
          status: "Could not update status.",
          remove: "Could not remove the ticket.",
        },
        remove: "Remove",
        removing: "Removing…",
        removeConfirm: "Remove ticket {{number}}? This cannot be undone.",
      },
      lawyerHub: {
        badge: "Lawyer desk",
        title: "Cases",
        text: "{{name}}",
        allTickets: "Board",
        emptyTitle: "No assigned cases",
        emptyText: "Assigned tickets appear here.",
        from: "{{name}}",
        cols: {
          number: "No.",
          case: "Case",
          client: "Client",
          phone: "Phone",
          status: "Status",
        },
        stats: {
          assigned: "Assigned",
          active: "Active",
          review: "In review",
          waiting: "Waiting",
        },
        errors: { load: "Could not load your desk." },
      },
      listingPlan: {
        launchBadge: "Launch month",
        launchNotice: "Premium is free for everyone until {{date}}. After that, 1 self-listing is free, then ${{price}}/month. Asking an agent to list stays free.",
        launchCard: "Complimentary Premium until {{date}}. After that, users get 1 free self-listing, then ${{price}}/month. Agent-managed listings stay free.",
        remaining: "{{remaining}} of {{limit}} free self-listing left. After that, Premium is ${{price}}/month. You can still ask an agent to list for you.",
        premiumActive: "Premium is active. You can list properties yourself without a free-listing limit.",
        limitBadge: "Premium required",
        limitTitle: "You've used your free listings.",
        limitText: "Subscribe to Premium for ${{price}}/month to list again yourself. You can still receive offers from agents at no extra cost.",
        limitError: "You've used your free self-listings. Subscribe to Premium or ask an agent to list for you.",
        upgrade: "Get Premium",
        useAgent: "Ask an agent instead",
        billing: {
          badge: "Your listings",
          agentBadge: "Agent billing",
          title: "ShoufBayt Premium",
          userDescription: "List 1 property yourself for free. After that, Premium is ${{price}}/month. Asking an agent to list and receive offers stays free.",
          agentDescription: "Verified agents get 30 days of Premium included, then ${{price}}/month. No commission on sales.",
          activeUser: "You can list properties yourself without the 1-listing limit. Send ${{price}} again before this period ends.",
          userNeedPay: "You've used your free self-listing. Subscribe for ${{price}}/month to keep listing yourself.",
        },
      },
      billingPage: {
        back: "Back to profile",
        loading: "Loading your plan…",
        snapshot: "Account snapshot",
        role: "Role",
        status: "Status",
        periodEnd: "Period ends",
        graceEnd: "Grace ends",
        trialUsed: "Trial used",
        renewal: "Renewal",
        listings: "Self-listings",
        complimentaryUntil: "Complimentary until",
        premiumEnds: "Premium ends",
        premiumEndsBanner: "Your Premium subscription ends {{date}}.",
        daysLeft: "{{count}} days left",
        unlimited: "Unlimited",
        yes: "Yes",
        no: "No",
        cancelled: "Cancelled",
        manual: "Manual",
        on: "On",
        none: "—",
        current: "Current plan",
        included: "Included now",
        afterLaunch: "After launch month",
        launchBanner: "Complimentary Premium is on until {{date}}. You have full Premium access at no charge. After that date, the Free and Premium rules below apply.",
        history: "Payment history",
        transactions: "{{count}} transaction(s)",
        noPayments: "No payments yet.",
        howToPay: "How to pay",
        sendTo: "Send ${{price}} to {{name}}",
        payCopy: "Use OMT, Whish Money, or BOB Finance. Send exactly ${{price}} USD, then upload a clear photo of the receipt. Premium turns on after confirmation.",
        recipient: "Recipient",
        number: "Number",
        amount: "Amount",
        copy: "Copy",
        copied: "Copied",
        payPremium: "Pay for Premium",
        renewPremium: "Renew Premium",
        amountDue: "Amount due: ${{price}} · receipt required",
        instant: "Instant",
        receiptReview: "Receipt review",
        submit: "Submit receipt",
        submitting: "Submitting…",
        receipt: "Receipt",
        chooseReceipt: "Choose receipt",
        changeReceipt: "Change receipt",
        receiptHint: "PNG or JPG — required",
        reference: "Transaction reference",
        referencePlaceholder: "Optional reference number",
        cardSoon: "Card payments are not available in Lebanon yet. Send ${{price}} to {{name}} and upload the receipt.",
        cancel: "Cancel subscription",
        confirmCancel: "Cancel now and you keep Premium until {{date}}. After that, a 7-day grace period applies. We will email a confirmation.",
        confirmCancellation: "Confirm cancellation",
        keepPlan: "Keep my plan",
        cancelling: "Cancelling…",
        resume: "Resume plan",
        resuming: "Resuming…",
        resumeCopy: "This plan will not renew. Access ends {{date}}. Resume to keep the remaining days, or pay below to start a new month.",
        roles: {
          USER: "User",
          AGENT: "Agent",
          ADMIN: "Administrator",
          APPLICANT: "Agent applicant",
        },
        statusLabels: {
          launch: "Complimentary Premium",
          trial: "30-day trial",
          premium: "Premium",
          grace: "Grace period",
          inactive: "Agent paused",
          none: "Free plan",
          cancels: "Cancels at period end",
        },
        hero: {
          userBadge: "Your plan",
          userTitle: "Choose how you list.",
          userText: "Browse, save, and message for free. List 1 property yourself at no charge. Premium is ${{price}}/month for unlimited self-listings. Asking an agent to list stays free.",
          agentBadge: "Agent plan",
          agentTitle: "Keep the office open.",
          agentText: "Verified agents get a {{trial}}-day trial after approval, then ${{price}}/month. Unlimited listings, requests, and dashboard — no commission.",
          adminBadge: "Platform billing",
          adminTitle: "Plans for every role.",
          adminText: "Staff accounts are not billed. Users and agents follow the Free and Premium rules below. Complimentary Premium stays on until {{date}}.",
          applicantBadge: "Agent unlock",
        },
        free: {
          tag: "Free",
          price: "$0",
          period: "always included",
          userTitle: "Free account",
          userLead: "Everything you need to find a property, plus 1 self-listing.",
          userPerks: [
            "Browse, save, and message listings",
            "Chat with the agent about any listing",
            "1 self-listed property",
            "Ask a verified agent to list — always free",
            "No card required",
          ],
          agentTitle: "Without Premium",
          agentLead: "The public profile can remain, but new office actions pause.",
          agentPerks: [
            "Public agent card may stay visible",
            "Existing listings stay online during grace",
            "New listings and request tools pause",
            "After grace the account returns to a regular user",
          ],
          adminTitle: "Staff access",
          adminLead: "Admin tools are included. There is no personal subscription.",
          adminPerks: [
            "Full office: users, listings, payments, support",
            "Not billed as Premium",
            "Review agent unlocks and receipts",
            "Send launch-month emails from this page",
          ],
        },
        premium: {
          tag: "Premium",
          period: "/ month",
          complimentary: "Complimentary this month",
          userTitle: "Premium",
          userLead: "Unlimited self-listings. Asking an agent remains free.",
          userPerks: [
            "Unlimited properties listed by you",
            "Priority placement tools",
            "Same messaging and saves",
            "Cancel anytime; access stays until period end",
          ],
          agentTitle: "Agent Premium",
          agentLead: "The full office: listings, requests, insights, no commission.",
          agentPerks: [
            "Unlimited listings",
            "Accept owner listing requests",
            "Dashboard and featured tools",
            "No commission on sales or rentals",
            "{{trial}}-day trial after verification",
          ],
          adminTitle: "Member Premium",
          adminLead: "What users and agents receive when Premium is active.",
          adminPerks: [
            "Users: unlimited self-listings",
            "Agents: office, requests, dashboard",
            "${{price}} / month after the complimentary window",
            "{{grace}}-day grace after a paid period ends",
          ],
        },
        campaign: {
          badge: "Launch emails",
          title: "End-of-month role emails",
          text: "When complimentary Premium ends, every member gets an email for their role: user, agent, or admin. Send a preview to your inbox now. The live send waits until the complimentary date passes, unless you force it.",
          active: "Complimentary Premium is ON until {{date}} ({{days}} days left).",
          ended: "Complimentary Premium has ended. The live campaign can send.",
          sent: "{{sent}} sent · {{pending}} waiting",
          email: "Test email",
          role: "Preview role",
          sendTest: "Send preview",
          sendingTest: "Sending preview…",
          sendAll: "Email everyone",
          sendingAll: "Sending…",
          force: "Send even if the complimentary month is still on",
        },
      },
      accountListings: {
        homesTitle: "Properties you listed.",
        ownerTitle: "Your properties.",
        savedTitle: "Properties you saved.",
        homesDescription: "Manage the listings in your office — photos, status, and edits in one place.",
        ownerDescription: "Listings created from your agent request. Status changes wait on admin review when they first go live.",
        savedDescription: "Properties you kept to revisit. Open one when you are ready to look closer.",
        count: "{{count}} properties",
        stats: { listed: "Listed", available: "Available", closed: "Sold or rented", saved: "Saved" },
      },
      live: {
        hero: { badge: "Live", title: "The market, live.", description: "Real numbers from ShoufBayt — listings, agents, and closed deals, updated as people use the site.", browse: "Browse properties" },
        updated: { live: "Live", now: "Updated {{time}}" },
        cards: { liveListings: "Live listings", closed: "Sold or rented", agents: "Verified agents", members: "People on ShoufBayt", cities: "Cities", onlineNow: "Online now" },
        mix: { badge: "Mix", title: "What is listed.", sale: "For sale", rent: "For rent", sold: "Sold", rented: "Rented" },
        cities: { badge: "Cities", title: "Where properties are listed.", empty: "No city data yet." },
        chart: { badge: "Growth", title: "New listings, six months.", description: "Properties added to the public market each month." },
        errors: { load: "Could not load live numbers." },
      },
      mapPlace: {
        placeholder: "Address, coordinates, or a Google Maps link",
        place: "Place on map",
        placing: "Finding…",
        upload: "Upload location photo",
        empty: "Paste an address, coordinates, or a maps link.",
        notFound: "Could not find that place. Try a maps link or click the map.",
        noGps: "This photo has no location. Turn location on in the camera, or paste a maps link.",
        badFile: "Upload a JPG photo taken with location on.",
      },
      investments: {
        eyebrow: "Investments",
        title: "Investments",
        add: "Add investment",
        addTitle: "Add an investment",
        addText: "This stays off the Properties page. It only appears in Investments.",
        loading: "Loading investments",
        emptyTitle: "Nothing listed yet.",
        back: "All investments",
        about: "About this investment",
        price: "Asking price",
        contact: "Message",
        call: "Call",
        opening: "Opening chat…",
        listedBy: "Listed by",
        inquiry: "I am interested in this investment.",
        saving: "Publishing…",
        publish: "Publish investment",
        savePin: "Save location",
        savingPin: "Saving location…",
        edit: "Edit",
        editTitle: "Edit investment",
        editText: "Update the details, photos, or map pin. This stays in Investments.",
        saveChanges: "Save changes",
        savingChanges: "Saving…",
        cancel: "Cancel",
        delete: "Delete",
        deleting: "Deleting…",
        confirmDelete: "Delete this investment? This cannot be undone.",
        backToItem: "Back to investment",
        notFound: "This investment is not available.",
        types: { building: "Building", land: "Land", office: "Office", shop: "Shop", warehouse: "Warehouse" },
        form: {
          title: "Title",
          price: "Price (USD)",
          city: "City",
          address: "Address",
          type: "Type",
          description: "Description",
          photos: "Photos",
          currentPhotos: "Current photos",
          removePhoto: "Remove",
        },
        errors: {
          load: "Could not load investments.",
          save: "Could not publish this investment.",
          update: "Could not save these changes.",
          delete: "Could not delete this investment.",
          description: "Write at least 20 characters.",
          location: "Click the map to drop a pin.",
          locationSave: "Could not save the location.",
          agentsOnly: "Only agents and admins can add an investment.",
          notAllowed: "You cannot change this investment.",
        },
      },
      footer: {
        brandSubtitle: "Properties in Lebanon",
        description: "Find apartments, houses, land, offices, shops, and more for sale and rent in Lebanon. Save listings, message owners, and list a property when you are ready.",
        socials: { facebook: "Facebook", instagram: "Instagram", linkedin: "LinkedIn" },
        explore: { title: "Explore", home: "Home", properties: "Properties", tickets: "Tickets", investments: "Investments", live: "Live", about: "About us", contact: "Help" },
        account: { title: "Account", profile: "My Profile", createListing: "Create Listing", requestListing: "List a property", updateProfile: "Update Profile", messages: "Messages", alerts: "Alerts", billing: "Billing", login: "Sign in" },
        contact: { title: "Contact", email: "Email", location: "Location", locationValue: "Beirut, Lebanon", hours: "Hours", hoursValue: "Mon - Sat, 9:00 AM - 6:00 PM" },
        bottom: { rights: "ShoufBayt. All rights reserved.", privacy: "Privacy Policy", support: "Support" },
      },
      supportChat: {
        fab: "Help",
        title: "Help",
        subtitle: "Chat with ShoufBayt",
        placeholder: "Write a message…",
        send: "Send",
        signIn: "Sign in to chat with us.",
        empty: "Ask us anything.",
        loading: "Opening chat…",
        error: "Could not start chat.",
      },
      auth: {
        google: {
          continue: "Continue with Google",
          connecting: "Connecting...",
          orEmail: "or continue with email",
          cancelled: "Google sign-in was cancelled.",
          failed: "Google sign-in failed. Please try again.",
          unavailable: "Google sign-in is unavailable right now.",
          notConfigured: "The API did not pick up a Google client ID. Use GOOGLE_CLIENT_ID in api/.env, then restart the API.",
          popupBlocked: "Google sign-in popup was blocked. Allow popups for this site and try again.",
          close: "Close",
          popupBadge: "ShoufBayt",
          popupTitle: "Continue with Google",
          popupDescription: "Choose a Google account to sign in to ShoufBayt.",
          popupHint: "Use the Google button below. Allow popups if your browser asks.",
        },
      },
      home: {
        hero: {
          label: "Properties in Lebanon",
          title: "Buy, sell, and rent every kind of property.",
          description: "Apartments, houses, villas, land, offices, shops, and warehouses — for sale or rent across Lebanon.",
          welcomeBack: "Welcome back",
          createAccount: "Create account",
          signIn: "Sign in",
          listProperty: "List a property",
          viewProfile: "Your profile",
          browseHomes: "Browse properties",
          searchPlaceholder: "City or area, like Beirut",
          searchButton: "Search",
          popular: "Popular",
        },
        search: { all: "All", buy: "Buy", rent: "Rent" },
        cities: { beirut: "Beirut", tripoli: "Tripoli", jounieh: "Jounieh", byblos: "Byblos" },
        types: {
          label: "By type",
          title: "Not only homes.",
          description: "Residential, land, and commercial listings in one marketplace.",
          apartment: "Apartments",
          house: "Houses",
          villa: "Villas",
          land: "Land",
          office: "Offices",
          shop: "Shops",
          warehouse: "Warehouses",
          building: "Buildings",
          hint: {
            apartment: "Flats and buildings",
            house: "Family houses",
            villa: "Standalone villas",
            land: "Plots and lots",
            office: "Workspaces",
            shop: "Retail spaces",
            warehouse: "Storage and industrial",
            building: "Whole buildings",
          },
        },
        roles: {
          ownerTitle: "I want to list",
          ownerText: "Share any property with buyers and renters.",
          buyerTitle: "I want a property",
          buyerText: "Browse listings and message the owner or agent.",
          agentTitle: "Agents",
          agentText: "Join as a verified agent, manage listings, and talk with clients from the platform.",
          helpTitle: "Support",
          helpText: "Questions about accounts, listings, or becoming an agent? Write to the ShoufBayt team.",
        },
        build: {
          label: "How it works",
          title: "Three steps. Nothing extra.",
          oneTitle: "Search",
          oneText: "Choose buy or rent, then pick a city and property type.",
          twoTitle: "Open a listing",
          twoText: "See photos, price, the map, and who listed it.",
          threeTitle: "Message the agent",
          threeText: "Ask questions or arrange a viewing in chat. No extra forms.",
        },
        invite: {
          title: "Ready to look around?",
          text: "Start with the listings. Create an account when you want to save a property or send a message.",
        },
        latest: {
          label: "Just listed",
          title: "Latest properties.",
          description: "Fresh published listings across Lebanon.",
          loading: "Loading properties…",
          empty: "No published properties match that search yet.",
        },
      },
      searchBar: {
        types: { all: "All", buy: "Buy", rent: "Rent" },
        labels: { location: "Location", property: "Property", bedrooms: "Bedrooms", bathrooms: "Bathrooms", minPrice: "Min Price", maxPrice: "Max Price" },
        placeholders: { city: "Search city...", minPrice: "$0", maxPrice: "$999999" },
        options: { any: "Any", apartment: "Apartment", house: "House", land: "Land", oneBedroom: "1 Bedroom", twoBedrooms: "2 Bedrooms", threeBedrooms: "3 Bedrooms", fourBedrooms: "4 Bedrooms", oneBathroom: "1 Bathroom", twoBathrooms: "2 Bathrooms", threeBathrooms: "3 Bathrooms" },
        buttons: { search: "Search", reset: "Reset" },
        errors: { minPriceGreater: "Min price cannot be greater than max price." },
        markets: {
          title: "Popular markets",
          "beirut-rent": "Beirut rentals",
          "beirut-buy": "Buy in Beirut",
          tripoli: "Tripoli",
          jounieh: "Jounieh",
          byblos: "Byblos",
          houses: "Residential for sale",
          land: "Land plots",
        },
        brief: {
          label: "Your search brief",
          empty: "Choose a market or set filters. Your brief will appear here before you search.",
          beds: "{{count}} beds",
          baths: "{{count}} baths",
          fromPrice: "from ${{price}}",
          upToPrice: "up to ${{price}}",
        },
      },
      smartSearchAssistant: {
        header: { badge: "Smart Search Assistant", title: "Describe what you are looking for", description: "Write your property needs in normal language and ShoufBayt will detect the most important search filters." },
        input: { placeholder: "Example: I want an apartment in Beirut for rent with 2 bedrooms under $800..." },
        buttons: { search: "Smart Search", clear: "Clear", loading: "Searching..." },
        examples: { one: "Apartment in Beirut for rent", two: "House for sale with 3 bedrooms", three: "Land in Byblos under $100000" },
        detected: { title: "Detected Filters", city: "City", type: "Type", property: "Property", bedrooms: "Bedrooms", minPrice: "Min Price", maxPrice: "Max Price" },
        errors: { empty: "Please describe what you are looking for.", failed: "Failed to process smart search." },
      },
      about: {
        hero: { badge: "About ShoufBayt", title: "A marketplace for every kind of property.", description: "ShoufBayt is built for apartments, houses, land, offices, shops, and warehouses — not only homes. Search, compare, list, and manage real estate in one place." },
        mission: { badge: "Our Mission", title: "Making every property type simple and clear.", description: "We connect buyers, renters, owners, and agents around residential and commercial listings, with a platform designed for trust, clarity, and speed." },
        values: { title: "Why ShoufBayt?", easySearch: "Easy Search", easySearchText: "Find apartments, houses, land, and commercial spaces by city, price, and type.", trustedAgents: "Trusted Agents", trustedAgentsText: "Connect with approved agents and professional property owners.", cleanManagement: "Clean Management", cleanManagementText: "Manage listings, messages, saved properties, and support requests easily." },
      },
      contact: {
        hero: { badge: "ShoufBayt Support", title: "Contact our support team.", description: "Send a general message, report a problem, and track admin replies from one clear and organized support page.", loginNoticeBefore: "You can view this page, but you must", signIn: "sign in", loginNoticeAfter: "before sending or tracking messages." },
        info: { badge: "Get in Touch", title: "We are ready to help.", description: "Contact ShoufBayt for questions, account help, property issues, reports, and general support requests.", email: "Email", phone: "Phone", location: "Location", locationValue: "Jib janine,WestBekaa, Lebanon", workingHours: "Working Hours", workingHoursValue: "Monday - Friday, 9:00 AM - 6:00 PM" },
        form: { badge: "Send Request", title: "Send a Message", description: "Choose whether you want to send a normal message or report a problem to the ShoufBayt team.", fullName: "Full Name", emailAddress: "Email Address", requestType: "Request Type", subject: "Subject", message: "Message", namePlaceholder: "Enter your name", emailPlaceholder: "Enter your email", subjectPlaceholder: "Enter subject", messagePlaceholder: "Write your message...", signInPlaceholder: "Please sign in to send a message", generalMessage: "General Message", reportProblem: "Report a Problem", signInToSend: "Sign in to Send", sending: "Sending...", sendReport: "Send Report", sendMessage: "Send Message" },
        validation: { nameRequired: "Full name is required.", emailRequired: "Email address is required.", subjectRequired: "Subject is required.", messageRequired: "Message is required.", invalidType: "Invalid message type." },
        success: { report: "Your report has been sent successfully. You can track its status below.", message: "Your message has been sent successfully. You can track the admin reply below." },
        errors: { failed: "Failed to send message." },
        track: { badge: "Track Your Messages", title: "Login to view your support history.", description: "Sign in to review your sent messages, reports, admin replies, and request status.", loginButton: "Login to Track Messages" },
      },
      contactStatus: {
        unknownDate: "Unknown date",
        sentOn: "Sent on",
        repliedOn: "Replied on",
        edited: "Edited",
        yourMessage: "Your Message",
        adminReply: "Admin Reply",
        noReply: "The ShoufBayt team is reviewing this request. You will see the reply here.",
        type: { message: "MESSAGE", report: "REPORT" },
        status: { new: "NEW", inReview: "IN REVIEW", answered: "ANSWERED" },
        guest: { badge: "Message Tracking", title: "Review Your Reports & Messages", description: "Login to view your submitted messages, report status, and admin replies.", button: "Login to Track Messages" },
        user: { badge: "Message Tracking", title: "Your Reports & Messages", description: "You can edit a request for 1 hour after sending. After the team replies, you may remove it from tracking." },
        states: { loading: "Loading your messages...", empty: "You have not sent any messages or reports yet." },
        actions: { delete: "Remove", deleting: "Removing...", clearAll: "Clear answered", clearing: "Clearing...", edit: "Edit", save: "Save changes", saving: "Saving...", cancel: "Cancel" },
        edit: {
          title: "Update your request",
          windowOpen: "Edit window: {{time}} remaining",
          windowClosed: "The 1-hour edit window has closed. This message is locked.",
          lockedAfterReply: "This request is locked because the team has already replied.",
          deleteHint: "Removal is available after the team replies.",
        },
        confirms: { delete: "Remove this answered request from your tracking list?", clearAll: "Remove every answered request from tracking? Open requests waiting for a reply will stay." },
        errors: { deleteFailed: "Failed to remove this request.", clearFailed: "Failed to clear answered requests.", updateFailed: "Failed to update this request.", deleteBlocked: "This request stays in tracking until the team replies.", editBlocked: "This request can no longer be edited." },
      },
      list: {
        hero: { badge: "Listings", title: "Properties for sale and rent.", description: "Filter by city, budget, and type — apartments, land, offices, shops, and more.", createListing: "Create listing", requestListing: "List a property" },
        tabs: { all: "All", buy: "Buy", rent: "Rent" },
        stats: { totalProperties: "Total Properties", available: "Available", forSale: "For Sale", forRent: "For Rent" },
        results: { propertyFound: "{{count}} property", propertiesFound: "{{count}} properties", descriptionWithResults: "Open a listing for photos, map, and contact.", descriptionEmpty: "Try another city or clear the filters." },
        pagination: { prev: "Previous", next: "Next", page: "Page {{page}} of {{pages}}" },
        empty: { title: "No properties found", message: "Nothing matches this search yet. Try another city, price, or property type.", button: "Clear search" },
        map: { badge: "Map", title: "On the map", oneListing: "{{count}} listing", manyListings: "{{count}} listings", mapView: "Map", satellite: "Satellite", emptyMessage: "No listing pins yet. Use satellite to inspect the area." },
      },
      listFilter: {
        header: { badge: "Search", title: "Find a property.", description: "City and property type first. More filters if you need them." },
        buttons: { resetFilters: "Clear", applyFilters: "Show properties", moreFilters: "More filters", fewerFilters: "Fewer filters" },
        labels: { city: "City / Area", type: "Listing Type", property: "Property", keyword: "Keyword", bedrooms: "Bedrooms", bathrooms: "Bathrooms", minPrice: "Min Price", maxPrice: "Max Price", minSize: "Min size m²", maxSize: "Max size m²", sort: "Sort", availability: "Availability" },
        placeholders: { city: "Beirut, Tripoli, Byblos...", keyword: "Title or street" },
        options: { any: "Any", anyType: "Any Type", rent: "Rent", buy: "Buy", anyProperty: "Any Property", apartment: "Apartment", house: "House", land: "Land", villa: "Villa", office: "Office", shop: "Shop", warehouse: "Warehouse", building: "Building", sortNewest: "Newest", sortOldest: "Oldest", sortPriceAsc: "Price: low to high", sortPriceDesc: "Price: high to low", sortPopular: "Most viewed", anyListed: "All listed", availableOnly: "Available only" },
        activeLabels: { city: "City", type: "Type", property: "Property", q: "Keyword", bedroom: "Bedrooms", bathroom: "Bathrooms", minPrice: "Min Price", maxPrice: "Max Price", minSize: "Min size", maxSize: "Max size", sort: "Sort", availability: "Availability" },
        values: { type: { rent: "Rent", buy: "Buy" }, property: { apartment: "Apartment", house: "House", land: "Land", villa: "Villa", office: "Office", shop: "Shop", warehouse: "Warehouse", building: "Building" }, sort: { newest: "Newest", oldest: "Oldest", price_asc: "Price ↑", price_desc: "Price ↓", popular: "Most viewed" }, availability: { available: "Available" } },
      },
      card: {
        fallback: { untitled: "Untitled Property", unknownCity: "Unknown City", noAddress: "No address available" },
        labels: { forRent: "For Rent", forSale: "For Sale", property: "Property", price: "Price" },
        propertyTypes: { apartment: "Apartment", house: "House", land: "Land", villa: "Villa", office: "Office", shop: "Shop", warehouse: "Warehouse", building: "Building" },
        status: { sold: "Sold", rented: "Rented" },
        messages: { sold: "This property has already been sold.", rented: "This property has already been rented." },
        features: { bedrooms: "Bedrooms", bathrooms: "Bathrooms", garage: "Garage", area: "m²" },
        buttons: { viewDetails: "View Details" },
        titles: { removeSaved: "Remove from saved", saveProperty: "Save property", sendMessage: "Send message", callAgent: "Call agent" },
        alerts: { saveFailed: "Failed to save property.", ownerNotFound: "Cannot find the owner of this property.", cannotMessageYourself: "You cannot send a message to yourself.", chatFailed: "Failed to open chat." },
      },
      pageState: {
        loading: { title: "Loading...", message: "Please wait while ShoufBayt prepares your data." },
        error: { title: "Something went wrong", message: "We could not complete this request. Please try again." },
        empty: { title: "No data found", message: "There is nothing to show right now." },
      },
      pageLoader: { label: "ShoufBayt" },
      statusBadge: { available: "Available", sold: "Sold", rented: "Rented", pending: "Pending review", rejected: "Not approved" },
      reviews: {
        propertyTitle: "Reviews",
        agentTitle: "Reviews",
        count: "{{count}} reviews",
        leave: "Leave a review",
        placeholder: "Write a short review",
        submit: "Post",
        save: "Save",
        sending: "…",
        login: "Sign in to leave a review.",
        empty: "No reviews yet.",
        loading: "Loading…",
        thanks: "Saved.",
        already: "You already left a review. Edit it, or read the others below.",
        yours: "Your review",
        edit: "Edit",
        cancel: "Cancel",
        loginError: "Please sign in first.",
        loadFailed: "Could not load reviews.",
        submitFailed: "Could not post review.",
        updateFailed: "Could not update review.",
        deleteFailed: "Could not delete review.",
        delete: "Remove",
      },
      single: {
        notFound: { title: "Property Not Found", message: "This property may have been deleted or is no longer available.", button: "Back to Properties" },
        nav: { backToProperties: "Back to Properties", editProperty: "Edit Property" },
        labels: { forRent: "For Rent", forSale: "For Sale", rent: "Rent", sale: "Sale", property: "Property" },
        propertyTypes: { apartment: "Apartment", house: "House", land: "Land", villa: "Villa", office: "Office", shop: "Shop", warehouse: "Warehouse", building: "Building" },
        fallback: { noTitle: "No Title", noAddress: "No address available", noDescription: "No description available.", noLocation: "No location available", unknownCity: "Unknown City", unknownUser: "Unknown User", unknown: "Unknown" },
        features: { totalSize: "Total Size", bedrooms: "Bedrooms", bathrooms: "Bathrooms", garage: "Garage", areaUnit: "m²" },
        summary: { propertyPrice: "Property Price", chatHint: "Contact the listing agent. The property owner is included in the chat automatically." },
        unavailable: { sold: "This property has been sold.", rented: "This property has been rented." },
        buttons: { propertySold: "Property Sold", propertyRented: "Property Rented", openingChat: "Opening Chat...", contactOwner: "Contact Agent", call: "Call agent", callAgent: "Call agent", callOwner: "Call owner", saved: "Saved", save: "Save" },
        sections: { overview: "Overview", propertyDescription: "Property Description", features: "Features", propertyDetails: "Property Details", location: "Location", propertyLocation: "Property Location" },
        info: { summary: "Summary", type: "Type", category: "Category", status: "Status", city: "City" },
        report: "Report listing",
        verification: {
          badge: "Admin only",
          title: "Verification photos",
          description: "Proof of ownership and إفادة عقارية. Hidden from the public listing.",
        },
        owner: { listedBy: "Listed By", listingAgent: "Listing Agent", propertyOwner: "Listing Agent", description: "This listing is managed by the listing agent. Contacting the listing sends a message to the agent and the property owner.", inquiry: "Inquiry", directChat: "Direct Chat", property: "Property", location: "Location", agentProfile: "View agent profile" },
        alerts: { saveFailed: "Failed to save property.", alreadySold: "This property is already sold.", alreadyRented: "This property is already rented.", ownerNotFound: "Cannot find the listing agent for this property.", cannotMessageYourself: "You cannot send a message to yourself.", chatFailed: "Failed to start chat.", notAllowedEdit: "You are not allowed to edit this property." },
        chatMessage: { greeting: "Hello, I am interested in this property.", heading: "Property Inquiry", title: "Title", price: "Price", deal: "Deal", category: "Category", city: "City", address: "Address", bedrooms: "Bedrooms", bathrooms: "Bathrooms", size: "Size", status: "Status", propertyLink: "Property Link", closing: "Please let me know if this property is still available." },
      },
      recommended: {
        header: { badge: "Nearby in this city", title: "Recommended Properties", description: "Other available listings in the same city, for the same sale or rent listing." },
        loading: { title: "Loading Recommendations", message: "Please wait while we find similar properties." },
        errorState: { title: "Recommendations Unavailable" },
        empty: { title: "No Recommendations Yet", message: "No other available listings in this city for the same sale or rent listing." },
        errors: { failed: "Failed to load recommended properties." },
      },
      slider: {
        badges: { paused: "Gallery Paused", auto: "Auto Gallery", gallery: "Property Gallery" },
        alt: { propertyPreview: "Property preview", mainProperty: "Main property", propertyNumber: "Property {{number}}" },
      },
      login: {
        login: { badge: "Welcome Back", title: "Sign in to ShoufBayt", description: "Login securely to manage your properties, saved listings, messages, and profile.", noAccount: "Don’t have an account?", createAccount: "Create Account", forgotPassword: "Forgot password?" },
        verify: { badge: "Security Check", title: "Verify Your Login", description: "We sent a 6-digit verification code to:", digitLabel: "Verification digit {{number}}", spamHint: "If you do not see the email, please check your spam folder. The code expires in 10 minutes." },
        form: { email: "Email Address", password: "Password", emailPlaceholder: "Enter your email", passwordPlaceholder: "Enter your password", show: "Show", hide: "Hide" },
        buttons: { checking: "Checking...", continue: "Continue", verifying: "Verifying...", verifyCode: "Verify Code", sending: "Sending...", resendIn: "Resend Code in {{seconds}}s", resendCode: "Resend Code", changeCredentials: "Change Email or Password" },
        validation: { emailRequired: "Email address is required.", emailInvalid: "Please enter a valid email address.", passwordRequired: "Password is required.", emailMissing: "Email is missing. Please login again.", codeRequired: "Please enter the 6-digit verification code." },
        success: { codeSent: "Verification code sent to your email.", newCodeSent: "A new code was sent." },
        errors: { loginFailed: "Login failed.", invalidCode: "Invalid verification code.", resendFailed: "Failed to resend code.", idle: "You were away for 1 hour, so we signed you out. Please sign in again.", sessionExpired: "Your session expired. Please sign in again." },
        visual: {
          title: "Find, save, and manage properties with confidence.",
          description: "A modern real estate platform built for buyers, renters, agents, and property owners.",
          journeyDiscover: "Discover",
          journeyShortlist: "Shortlist",
          journeyMove: "Move in",
          showcaseDiscoverTitle: "See properties that fit you",
          showcaseDiscoverText: "Search by city, type, and budget without the noise.",
          showcaseConnectTitle: "Talk before you visit",
          showcaseConnectText: "Message owners and agents from the listing itself.",
          showcaseSaveTitle: "Keep a private shortlist",
          showcaseSaveText: "Save properties and come back when you are ready.",
          chipBuy: "Buy",
          chipRent: "Rent",
          chipBeirut: "Beirut",
          chipApartments: "Apartments",
          chipVillas: "Villas",
          secureLogin: "Secure access",
          securityText: "Email verification and Google sign-in help protect your ShoufBayt account.",
        },
      },
      forgotPassword: {
        email: {
          badge: "Account Recovery",
          title: "Forgot your password?",
          description: "Enter your email and we’ll send a 6-digit verification code to reset your password.",
          remember: "Remembered it?",
          backToLogin: "Back to Login",
        },
        verify: {
          badge: "Verify Email",
          title: "Enter verification code",
          description: "We sent a 6-digit reset code to:",
          digitLabel: "Reset digit {{digit}}",
          spamHint: "Check Inbox and Spam/Junk. The code expires in 10 minutes.",
        },
        reset: {
          badge: "New Password",
          title: "Create a new password",
          description: "Choose a strong password for your ShoufBayt account.",
        },
        form: {
          email: "Email Address",
          emailPlaceholder: "Enter your email",
          newPassword: "New Password",
          confirmPassword: "Confirm Password",
          passwordPlaceholder: "Create a new password",
          confirmPlaceholder: "Confirm your new password",
          show: "Show",
          hide: "Hide",
        },
        buttons: {
          sending: "Sending...",
          sendCode: "Send Code",
          verifying: "Verifying...",
          verifyCode: "Verify Code",
          resendIn: "Resend Code in {{seconds}}s",
          resendCode: "Resend Code",
          changeEmail: "Change Email",
          saving: "Saving...",
          resetPassword: "Reset Password",
        },
        validation: {
          emailRequired: "Email address is required.",
          emailInvalid: "Please enter a valid email address.",
          codeRequired: "Please enter the 6-digit verification code.",
          passwordWeak:
            "Password must include uppercase, lowercase, number, and special character (min 6).",
          passwordMismatch: "Passwords do not match.",
        },
        success: {
          codeSent: "Verification code sent to your email.",
          newCodeSent: "A new verification code was sent.",
          codeVerified: "Code verified. You can set a new password.",
          resetDone: "Password updated. Redirecting to login…",
        },
        errors: {
          requestFailed: "Failed to send reset code.",
          emailNotFound: "No account found with this email address.",
          invalidCode: "Invalid verification code.",
          resendFailed: "Failed to resend code.",
          sessionExpired: "Reset session expired. Please start again.",
          resetFailed: "Failed to reset password.",
        },
        visual: {
          title: "Reset access in a few secure steps.",
          description:
            "Verify your email with a one-time code, then choose a new password for your account.",
          journeyEmail: "Email",
          journeyCode: "Verify",
          journeyPassword: "Reset",
          showcaseSafeTitle: "Protected recovery",
          showcaseSafeText: "Only your inbox can approve a password change.",
          showcaseKeyTitle: "A fresh start",
          showcaseKeyText: "Set a new password and get back to your listings.",
          secureTitle: "Secure recovery",
          secureText:
            "Reset codes expire in 10 minutes and can only be used once.",
        },
      },
      register: {
        header: { badge: "Create Account", title: "Join ShoufBayt", description: "Create your account to post properties, save favorites, message users, and manage your real estate activity." },
        form: { username: "Username", email: "Email Address", password: "Password", confirmPassword: "Confirm Password", usernamePlaceholder: "Enter your username", emailPlaceholder: "Enter your email", passwordPlaceholder: "Create a password", confirmPasswordPlaceholder: "Confirm your password", show: "Show", hide: "Hide" },
        passwordStrength: { title: "Password Strength" },
        strength: { weak: "Weak", medium: "Medium", strong: "Strong" },
        requirements: { title: "Password Requirements", length: "At least 6 characters", uppercase: "At least 1 uppercase letter", lowercase: "At least 1 lowercase letter", number: "At least 1 number", special: "At least 1 special character", match: "Passwords match" },
        validation: { usernameRequired: "Username is required.", usernameLength: "Username must be at least 3 characters.", emailRequired: "Email address is required.", emailInvalid: "Please enter a valid email address.", passwordFieldsRequired: "Please fill both password fields.", passwordRequirements: "Please complete all password requirements." },
        errors: {
          failed: "Registration failed.",
          useGoogle: "This email already has a Google account. Use Continue with Google.",
        },
        buttons: { creating: "Creating Account...", createAccount: "Create Account" },
        footer: { alreadyHaveAccount: "Already have an account?", signIn: "Sign In" },
        visual: {
          title: "Start your real estate journey professionally.",
          description: "Create an account and access property posting, saved listings, messages, profile management, and smart real estate tools.",
          journeyCreate: "Create",
          journeyList: "List",
          journeyGrow: "Grow",
          showcasePostTitle: "Publish with clarity",
          showcasePostText: "Add photos, details, and a map pin in one flow.",
          showcaseSaveTitle: "Follow properties you love",
          showcaseSaveText: "Build a shortlist while you compare options.",
          showcaseMessageTitle: "Reach people faster",
          showcaseMessageText: "Chat with owners, buyers, and agents in one place.",
          chipOwners: "Owners",
          chipBuyers: "Buyers",
          chipRenters: "Renters",
          chipAgents: "Agents",
        },
      },
      verifyPhone: {
        badge: "Phone number",
        title: "Add your phone number",
        text: "Users and agents add a number once so buyers can tap Call on listings.",
        changeTitle: "Change your phone number",
        changeText: "Enter the new number. It is saved on your account right away.",
        phoneLabel: "Phone number",
        phonePlaceholder: "71123456",
        phoneHint: "Pick your country key, then enter the local number only.",
        save: "Save number",
        saving: "Saving...",
        success: {
          saved: "Phone number saved.",
        },
        errors: {
          invalidPhone: "Enter the required digits for that country, without the country code.",
          phoneTaken: "This phone number is already used on another account.",
          saveFailed: "Could not save the phone number.",
        },
        visual: {
          title: "A number buyers can call.",
          text: "Add it once. You can change it later from your profile.",
        },
      },
      phoneField: {
        countryLabel: "Country code",
        searchCountry: "Search country or key",
        numberPlaceholder: "Local number",
        digitsHint: "Enter {{count}} digits without the country key.",
        digitsRangeHint: "Enter {{min}} to {{max}} digits without the country key.",
        errors: {
          invalid: "Enter the required digits for the selected country, without the country key.",
        },
      },
      profile: {
        fallback: { user: "User", noEmail: "No email" },
        loading: { title: "Loading Profile", message: "Please wait while we prepare your account information." },
        hero: { badge: "Account", updateProfile: "Edit account", editAgentCard: "Edit public card", logout: "Log out" },
        role: { owner: "Owner", agent: "Agent", admin: "Admin" },
        fields: { name: "Name", email: "Email", manageBilling: "Manage" },
        stats: { myPosts: "My Posts", myPostsText: "Properties you created", savedPosts: "Saved Posts", savedPostsText: "Your favorite properties", accountRole: "Account Role", accountRoleText: "Your current permission", fallbackTitle: "Stats", fallbackText: "Failed to load profile stats" },
        dashboard: { badge: "Account", title: "Your properties", description: "Listings you posted and properties you saved.", addNewProperty: "Add listing", requestListing: "List a property" },
        tabs: { myPosts: "My properties", savedPosts: "Saved", requests: "Offers" },
        requests: {
          loading: "Loading offers…",
          emptyTitle: "No offers yet",
          emptyText: "List a property and agents will send offers here.",
          pickTitle: "Pick an agent",
          dashboardHint: "Offers, visits, and your listings.",
          notifiedAgents: "Agents notified: {{count}}",
          proposalsCount: "{{count}} offers",
          proposalMeta: "{{percent}}% commission · ~{{days}} days · {{status}}",
          commission: "{{percent}}% commission",
          days: "about {{count}} days",
          agent: "Agent",
          verified: "Verified",
          viewAgent: "View profile",
          accept: "Accept",
          reject: "Reject",
          chooseAgent: "Accept",
          working: "Please wait…",
          openListing: "Open listing",
          cancel: "Cancel request",
          stateWaiting: "Waiting",
          stateChoose: "Choose one",
          stateDone: "Done",
          waitingHint: "Agents will appear here. You’ll also get an alert.",
          confirms: {
            cancel: "Cancel this listing request?",
            accept: "Hire {{name}} to list “{{title}}”?",
            reject: "Turn down {{name}}’s offer for “{{title}}”?",
          },
          dialog: {
            acceptTitle: "Hire this agent?",
            rejectTitle: "Decline this offer?",
            cancelTitle: "Cancel this request?",
            acceptText: "{{name}} will list “{{title}}”. Other offers on this property will close.",
            rejectText: "{{name}}’s offer for “{{title}}” will be declined. They can send another proposal until you hire someone.",
            cancelText: "Agents will stop receiving offers for “{{title}}”.",
            back: "Not now",
            confirmAccept: "Hire agent",
            confirmReject: "Decline offer",
            confirmCancel: "Cancel request",
            close: "Close",
          },
          success: { accepted: "Done. That agent will list this property. Other offers were closed.", rejected: "Offer declined. That agent can send a new proposal until you accept one." },
          errors: { load: "Could not load offers.", accept: "Could not accept this offer.", reject: "Could not reject this offer.", cancel: "Could not cancel." },
        },
        errors: { loadProperties: "Failed to load your properties." },
        messages: { badge: "Inbox", title: "Messages", viewAll: "View All", loading: "Loading messages...", failed: "Failed to load messages.", noMessages: "No messages", noMessagesText: "Your conversations will appear here.", noMessageYet: "No message yet" },
        shortcuts: { badge: "Shortcuts", title: "Quick Actions", browseProperties: "Browse Properties", findAgents: "Find Agents", contactSupport: "Contact Support", requestListing: "Request a listing", ownerDashboard: "Owner dashboard", agentDashboard: "Agent dashboard" },
        empty: { title: "No properties found", noMyPosts: "You did not add any property yet.", noMyPostsOwner: "No properties listed for you yet. Request a listing and hire an agent.", noSavedPosts: "You did not save any property yet.", createFirst: "Create Your First Property", requestFirst: "Request your first listing", exploreProperties: "Explore Properties" },
        delete: { badge: "Confirm Action", title: "Delete Property?", question: "Are you sure you want to delete", thisProperty: "this property", cancel: "Cancel", delete: "Delete", deleting: "Deleting...", cannotFind: "Could not find this property.", failed: "Failed to delete property." },
        alerts: { logoutFailed: "Failed to logout." },
      },
      profilePostCard: {
        fallback: { untitled: "Untitled Property", noAddress: "No address" },
        status: { available: "Available", rented: "Rented", sold: "Sold", pending: "Pending review", rejected: "Not approved" },
        labels: { propertyStatus: "Property Status", changeStatus: "Change status", updating: "Updating...", pendingNote: "Waiting for admin approval. It is not public yet.", agentManagedNote: "Your agent manages listing status. You can view and edit details." },
        features: { bedroom: "bedroom", bathroom: "bathroom" },
        managedBy: "Managed by {{name}}",
        managedByAgency: "Managed by {{name}} · {{agency}}",
        viewAgent: "View agent",
        buttons: { viewDetails: "View Details", editProperty: "Edit Property", delete: "Delete" },
        alt: { location: "Location", bedroom: "Bedroom", bathroom: "Bathroom" },
        alerts: { updateFailed: "Failed to update status." },
      },
      profileUpdate: {
        fallback: { user: "User", noEmail: "No email" },
        loading: { title: "Loading Profile", message: "Please wait while we prepare your account information." },
        header: { badge: "Account Settings", title: "Update your ShoufBayt profile.", description: "Manage your username, email, phone number, password, and profile image from one clean account settings page.", backToProfile: "Back to Profile" },
        formHeader: { badge: "Profile Details", title: "Personal Information", description: "You can change your username or email on their own. Phone is optional here unless you want to add or change the number. Leave the password empty if you do not want to change it." },
        form: { username: "Username", email: "Email Address", phone: "Phone number", newPassword: "New Password", confirmPassword: "Confirm Password", usernamePlaceholder: "Enter your username", emailPlaceholder: "Enter your email", phonePlaceholder: "+961 71 123 456", phoneHelp: "Optional. Buyers can tap Call on your listings after this number is saved. You can skip it when you only change your name or email.", noPhone: "No number yet", addPhone: "Add phone", changePhone: "Change number", passwordPlaceholder: "Leave empty to keep old password", confirmPasswordPlaceholder: "Confirm the new password", show: "Show", hide: "Hide", passwordHelp: "Only enter a password if you want to change it. It must include uppercase, lowercase, number, and special character (min 6)." },
        avatar: { badge: "Profile Image", title: "Account Picture", description: "Upload a clear profile image. This image appears on your profile, listings, agents page, and messages.", alt: "Profile", chooseImage: "Choose Image", reset: "Reset", accepted: "Accepted: JPG, PNG, WEBP", maxSize: "Maximum size: 5MB" },
        account: { title: "Current Account", username: "Username", email: "Email", role: "Role" },
        buttons: { updating: "Updating...", updateProfile: "Update Profile", cancel: "Cancel" },
        validation: { validImage: "Please choose a valid image file.", imageSize: "Image size must be less than 5MB.", usernameRequired: "Username is required.", emailRequired: "Email is required.", emailInvalid: "Please enter a valid email address.", phoneInvalid: "Enter a valid phone number.", phoneTaken: "This phone number is already used on another account.", usernameTaken: "This username is already taken.", emailTaken: "This email is already used on another account.", passwordRequirements: "Please complete all password requirements.", passwordMismatch: "Passwords do not match.", userNotFound: "Could not find your user account." },
        success: { updated: "Profile updated successfully." },
        errors: { failed: "Failed to update profile." },
        verify: {
          badge: "Confirm email",
          title: "Verify your new email.",
          description: "We sent a 6-digit code to",
          spamHint: "Check spam if it is not in your inbox. Your current email stays active until you enter the code.",
          digitLabel: "Digit {{number}}",
          verifyCode: "Confirm email",
          verifying: "Confirming...",
          resend: "Resend code",
          resendIn: "Resend in {{seconds}}s",
          keepCurrent: "Keep current email",
          backToForm: "Back to details",
          codeRequired: "Enter the 6-digit code.",
          codeSent: "A confirmation code was sent to your new email.",
          verified: "Your email has been updated.",
          cancelled: "Email change cancelled. Your current email is unchanged.",
          verifyFailed: "Could not verify that code.",
          resendFailed: "Could not resend the code.",
          cancelFailed: "Could not cancel the email change.",
        },
      },
      newPost: {
        hero: {
          badge: "Create listing",
          title: "Publish a property.",
          description: "Add the details, photos, and map pin. Review once, then go live.",
          myListings: "My listings",
        },
        stats: {
          brief: "Your listing",
          briefValue: "Details, photos, pin",
          review: "Review",
          reviewValue: "Check before it goes live",
          live: "Published",
          liveValue: "Visible on ShoufBayt",
        },
        steps: { details: "Property details", confirm: "Confirm & publish" },
        details: {
          badge: "Details",
          title: "Property information",
          description: "The facts buyers and renters will see on the listing.",
        },
        form: {
          title: "Title",
          price: "Price ($)",
          city: "City",
          address: "Address",
          listingType: "Listing type",
          category: "Category",
          bedrooms: "Bedrooms",
          bathrooms: "Bathrooms",
          garage: "Garage",
          size: "Size (m²)",
          description: "Description",
          titlePlaceholder: "Modern apartment in Zahle",
          cityPlaceholder: "e.g. Zahle",
          addressPlaceholder: "Street, building, area",
          descriptionPlaceholder: "Describe the property, finishes, neighborhood, and selling points…",
          landLocked: "Not used for land",
          buildingLocked: "Not used for buildings",
        },
        options: {
          sale: "Sale",
          rent: "Rent",
          apartment: "Apartment",
          house: "House",
          villa: "Villa",
          land: "Land",
          office: "Office",
          shop: "Shop",
          building: "Building",
        },
        location: {
          badge: "Location",
          title: "Pin the property",
          description: "Click the map, use your current location, paste an address or Google Maps link, or upload a photo that contains a location.",
          locating: "Locating…",
          useMyLocation: "Use my location",
          lat: "Lat",
          lng: "Lng",
          popup: "Selected property location",
          pinSet: "Location pinned",
          clickHint: "Click the map to drop a pin.",
        },
        media: {
          badge: "Media",
          title: "Property photos",
          description: "Clear photos help people decide. At least one image is required.",
          upload: "Click to upload images",
          hint: "JPG, PNG or WEBP · up to 20 photos · 20MB each",
          remove: "Remove",
        },
        verification: {
          badge: "Verification",
          title: "Two private proof photos",
          userDescription: "Upload a proof of ownership and an إفادة عقارية. An admin reviews these before the listing goes live. They are never shown on the public page.",
          agentDescription: "Upload a proof of ownership and an إفادة عقارية. Agents can publish without waiting for admin approval. These photos stay private to admins.",
          upload: "Add proof of ownership and إفادة عقارية",
          hint: "JPG, PNG or WEBP · 2 photos · ownership + إفادة عقارية · admin only",
        },
        confirm: {
          badge: "Ready",
          title: "Review before publishing",
          description: "This {{property}} in {{city}} will go live when you publish.",
          yourArea: "your area",
          deal: "Deal",
          layout: "Layout",
          bedsBaths: "{{beds}} beds · {{baths}} baths",
        },
        done: {
          badge: "Published",
          title: "Listing is live",
          description: "Your property is now on ShoufBayt. Open it to check photos, the map, and contact.",
        },
        actions: {
          continue: "Continue",
          cancel: "Cancel",
          submit: "Publish listing",
          submitting: "Publishing…",
          back: "Back to edit",
          viewListing: "View listing",
          home: "Home",
        },
        validation: {
          requiredFields: "Title, address, and city are required.",
          price: "Enter a valid price.",
          bedrooms: "Enter the number of bedrooms.",
          bathrooms: "Enter the number of bathrooms.",
          garage: "Enter the number of garages.",
          description: "Description must be at least 20 characters.",
          location: "Set a map location.",
          images: "Add at least one image.",
          verificationImages: "Upload a proof of ownership photo and an إفادة عقارية.",
          locationNotSupported: "Geolocation is not supported on this device.",
          locationFailed: "Could not get your location.",
        },
        success: { added: "Property added successfully." },
        errors: {
          addFailed: "Failed to add property.",
          apiOffline:
            "Cannot reach the server. Start the API on port 8800 and try again.",
        },
        moderation: {
          badge: "List yourself",
          title: "List this property yourself.",
          description: "Add the details, photos, and map pin. Your first self-listing is free. An admin reviews it before it appears on ShoufBayt.",
          review: "Admin review",
          reviewValue: "Required before it goes live",
          live: "Goes live",
          liveValue: "After approval",
          confirmStep: "Confirm & send",
          confirmTitle: "Review before sending",
          confirmDescription: "This {{property}} in {{city}} will wait for admin approval. It will not be public until then.",
          submit: "Send for review",
          submitting: "Sending…",
          doneBadge: "In review",
          doneTitle: "Waiting for admin approval",
          doneDescription: "Your listing is saved and stays private until an admin approves it. You will be notified.",
          success: "Listing submitted for review.",
          switchPath: "Prefer an agent?",
        },
      },
      editPost: {
        loading: { title: "Loading Property", message: "Please wait while we load the property information." },
        loadError: { title: "Could Not Load Property", backToProfile: "Back to Profile" },
        header: { badge: "Edit Property", title: "Update property details.", description: "Update the information, images, description, and map location of your listing.", viewProperty: "View Property" },
        main: { badge: "Main Information", title: "Property Details", description: "Update the main information users see on your listing." },
        form: { title: "Title", price: "Price", city: "City", address: "Address", bedrooms: "Bedrooms", bathrooms: "Bathrooms", size: "Size m²", type: "Type", property: "Property" },
        options: { buy: "Buy", rent: "Rent", apartment: "Apartment", house: "House", land: "Land" },
        description: { badge: "Description", title: "Property Overview", description: "Write the description buyers and renters will read on the listing.", manual: "Manual Description", ai: "ShoufBayt AI", manualPlaceholder: "Write property description...", aiPlaceholder: "Write property description..." },
        ai: { badge: "AI Assistant", title: "Regenerate Description", description: "ShoufBayt AI will use the updated details to generate a polished property description.", generating: "Generating...", generate: "Generate Description" },
        location: { badge: "Location", title: "Update Location", description: "Click the map, use your current location, paste an address or Google Maps link, or upload a photo that contains a location.", locating: "Locating...", useMyLocation: "Use My Location", latitude: "Latitude", longitude: "Longitude", popup: "Selected property location" },
        gallery: { badge: "Gallery", title: "Property Images", description: "Keep old images, remove unwanted ones, upload new photos, and choose the main preview.", totalImages: "Total Images", newImages: "New Images", mainPreviewAlt: "Main property preview", mainPreview: "Main Preview", noImage: "No Image", noImageText: "Upload or keep at least one image.", uploadNewImages: "Upload New Images", accepted: "JPG, PNG, JPEG, WEBP • Max 8MB each", propertyAlt: "Property", newPropertyAlt: "New property", old: "Old", new: "New", noImagesLeft: "No Images Left", noImagesLeftText: "Please keep or upload at least one image." },
        actions: { cancel: "Cancel", saving: "Saving...", saveChanges: "Save Changes" },
        validation: { locationNotSupported: "Your browser does not support location access.", locationFailed: "Failed to get your location. Please select it manually on the map.", titleFirst: "Please write the property title first.", cityFirst: "Please write the city first.", priceFirst: "Please write a valid price first.", maxImages: "You can keep/upload a maximum of {{max}} images.", imageType: "Only image files are allowed: JPG, PNG, JPEG, or WEBP.", imageSize: "Each image must be less than 8MB.", titleRequired: "Title is required.", priceRequired: "Price must be greater than 0.", cityRequired: "City is required.", addressRequired: "Address is required.", bedroomRequired: "Bedroom number is required.", bathroomRequired: "Bathroom number is required.", sizeNegative: "Size cannot be negative.", descriptionRequired: "Description is required.", imageRequired: "Please keep or upload at least one image.", locationRequired: "Please select the property location on the map." },
        success: { aiGenerated: "AI description generated successfully. You can edit it before saving." },
        errors: { notFound: "Property not found.", loadFailed: "Failed to load property.", aiFailed: "Failed to generate description.", updateFailed: "Failed to update property." },
        alerts: { notAllowedEdit: "You are not allowed to edit this property." },
      },
      agents: {
        hero: { badge: "ShoufBayt Agents", title: "Meet the real estate experts behind ShoufBayt.", description: "Browse approved agents, check their details, view their profiles, and connect with the right professional for your next property decision.", exploreProperties: "Explore Properties", refreshing: "Refreshing...", refreshAgents: "Refresh Agents" },
        stats: { verifiedAgents: "Verified Agents", activeListings: "Active Listings", propertySupport: "Property Support" },
        states: { loadingTitle: "Loading Agents", loadingMessage: "Please wait while we load verified ShoufBayt agents.", errorTitle: "Failed to Load Agents", tryAgain: "Try Again", emptyTitle: "No Agents Found", emptyMessage: "No approved agent accounts exist yet. Users can request to become agents, and admins can approve them from the admin dashboard." },
        directory: { badge: "Agents", title: "Agents.", description: "Browse people listing properties in Lebanon.", agents: "Agents", searchPlaceholder: "Search by name or city", count: "{{shown}} of {{total}}", noMatch: "No agents match that search." },
        card: { defaultName: "ShoufBayt Agent", defaultTitle: "Real Estate Agent", defaultBio: "Professional ShoufBayt real estate agent ready to help users find the right property.", verified: "Verified", role: "Role", listings: "Listings", listingsCount: "{{count}} listings", location: "Location", phone: "Phone", email: "Email", notProvided: "Not provided", viewProfile: "View profile" },
        bottom: { badge: "Why use an agent?", title: "Make better property decisions with professional support.", cardOneTitle: "Expert Guidance", cardOneText: "Agents help explain property details, pricing, location, and important listing information.", cardTwoTitle: "Faster Communication", cardTwoText: "Contact trusted agents directly to ask about visits, property availability, and next steps.", cardThreeTitle: "Better Choices", cardThreeText: "Compare options with professional help before choosing the right property." },
        errors: { loadFailed: "Failed to load agents." },
      },
      agentRequest: {
        guest: { badge: "Become an Agent", title: "Join ShoufBayt Agents", description: "Login to request becoming a verified ShoufBayt agent.", login: "Login First" },
        checking: { badge: "Checking Status", title: "Loading your agent status...", description: "Please wait while we check your latest account status." },
        verified: { badge: "Office open", title: "Your office is open", description: "Publish listings, take leads, and use the agent office.", profile: "Open your office" },
        pending: { badge: "Waiting for review", title: "Your request is with the admin", description: "Your profile is saved. An admin will review it and email you when it is approved or declined.", viewProfile: "View profile" },
        rejected: { badge: "Request Rejected", title: "Your previous request was rejected", description: "You can submit a new request with updated information for admin review." },
        default: { badge: "Become an Agent", title: "Tell us who you are.", description: "Complete your agent profile. An admin reviews the request, and your office opens after approval.", requestAgain: "Request Again", becomeAgent: "Start your profile" },
        modal: { badge: "Your profile", title: "Tell us who you are.", description: "This is the card admins will review. After you submit, the request goes to the admin office." },
        form: { fullName: "Full Name", agentTitle: "Agent Title", phoneNumber: "Phone Number", location: "Location", profileImage: "Agent Profile Image", bio: "Professional Bio", fullNamePlaceholder: "Your full name", agentTitlePlaceholder: "Real Estate Agent", locationPlaceholder: "Beirut, Lebanon", agentPreview: "Agent preview", uploadImage: "Upload Image", remove: "Remove", imageInfo: "JPG, PNG, WEBP • Max 5MB", bioPlaceholder: "Write a short professional bio about your real estate experience..." },
        buttons: { cancel: "Cancel", sending: "Sending Request...", submit: "Save profile" },
        validation: { validImage: "Please upload a valid image file.", imageSize: "Image size must be less than 5MB.", nameRequired: "Full name is required.", titleRequired: "Agent title is required.", phoneRequired: "Phone number is required.", phoneInvalid: "Phone number can only contain numbers and spaces.", locationRequired: "Location is required.", bioRequired: "Bio is required.", bioLength: "Bio must be at least 20 characters." },
        success: { sent: "Profile saved. An admin will review your request." },
        errors: { failed: "Failed to send agent request.", phoneTaken: "This phone number is already used by another agent.", nameTaken: "This full name is already used by another agent." },
      },
      agentUnlock: {
        pathLabel: "Agent unlock path",
        steps: { profile: "Profile", review: "Review", live: "You’re live" },
        card: { badge: "Your agent card", fallbackName: "ShoufBayt Agent", fallbackTitle: "Real Estate Agent" },
        handoff: {
          badge: "Sent for review",
          title: "Your request is with the admin.",
          description: "An admin will review this card. Your office opens after approval.",
          continue: "Done",
          later: "Stay on this page",
        },
        live: { title: "Your office is open" },
      },
      agentDetails: {
        states: { loadingTitle: "Loading Agent", loadingMessage: "Please wait while we load this agent profile.", errorTitle: "Agent Not Available", notFoundTitle: "Agent Not Found", notFoundMessage: "This agent profile does not exist or may have been removed.", backToAgents: "Back to Agents" },
        hero: { badge: "Verified ShoufBayt Agent" },
        info: { location: "Location", phone: "Phone", email: "Email", activeListings: "Active Listings" },
        listings: { badge: "Listings", title: "Agent Listings", description: "Real properties published by this agent.", emptyTitle: "No Listings Yet", emptyMessage: "This agent has not published any properties yet." },
        chat: { badge: "Direct Chat", title: "Chat With Agent", description: "Start a direct conversation with {{name}}.", startDescription: "Open a private chat with this verified agent to ask about listings, visits, pricing, or property details.", noMessagesTitle: "No Messages Yet", noMessagesText: "Start the conversation by sending a message.", placeholder: "Type your message...", justNow: "Just now" },
        buttons: { openingChat: "Opening Chat...", contactAgent: "Contact Agent", backToAgents: "Back to Agents", startChat: "Start Chat", sending: "Sending...", send: "Send" },
        fallback: { agent: "Agent", thisAgent: "this agent", smartEstateAgent: "ShoufBayt Agent", realEstateAgent: "Real Estate Agent", agentBio: "Professional ShoufBayt real estate agent.", noLocation: "No location", noPhone: "No phone", noEmail: "No email", property: "Property", unknownCity: "Unknown city", na: "N/A" },
        values: { buy: "Buy", rent: "Rent", apartment: "Apartment", house: "House", land: "Land" },
        errors: { loadFailed: "Failed to load agent.", agentNotConnected: "This agent account is not connected correctly.", chatYourself: "You cannot chat with yourself.", chatFailed: "Failed to start chat.", sendFailed: "Failed to send message." },
      },
      agentHub: {
        hero: { badge: "Private office", title: "The desk is yours.", description: "Leads, listings, and your public card in one room — propose, publish, and keep clients moving." },
        links: { addListing: "Add listing", billing: "Billing", profile: "Profile", messages: "Messages", editCard: "Edit public card" },
        tabs: { overview: "Overview", leads: "Leads", listings: "Listings", visits: "Visits", profile: "Public card" },
        stats: { views: "Property views", saves: "Saves", inquiries: "Inquiries", openLeads: "Open leads" },
        statsHint: { views: "All-time views on your listings", saves: "People who saved your listings", inquiries: "Messages in the last 30 days", openLeads: "Owner requests waiting for a proposal" },
        subscription: {
          label: "Premium",
          trial: "30-day Premium trial",
          premium: "Premium active",
          grace: "Grace period",
          inactive: "Inactive — renew to restore",
          none: "No Premium yet",
          hasAccess: "Full access to leads and proposals. Then ${{price}}/month — no commission on sales.",
          locked: "Premium is required to receive listing leads and send proposals.",
          manage: "Manage billing",
        },
        overview: {
          desk: "Today in your office",
          nextVisit: "Next visit",
          noVisit: "No upcoming visit on the calendar.",
          schedule: "Schedule a visit",
          openLeads: "Leads waiting",
          noLeads: "No open owner requests right now.",
          reviewLeads: "Review leads",
          liveListings: "Live listings",
          noListings: "You have not published a listing yet.",
          addListing: "Add a listing",
          pipeline: "Pipeline",
          stageLeads: "Open to propose",
          stageProposed: "Proposed",
          stageListings: "Your listings",
          stageVisits: "Upcoming visits",
        },
        leads: {
          filterAll: "All",
          filterOpen: "Ready to propose",
          filterProposed: "Already proposed",
          empty: "No matching listing requests.",
          emptyHint: "When owners request a listing, verified agents see them here.",
          from: "From",
          proposals: "{{count}} / 10 proposals",
          beds: "{{count}} beds",
          baths: "{{count}} baths",
          noAddress: "No address",
          propose: "Write proposal",
          hideForm: "Close form",
          pitch: "Pitch to the owner",
          pitchPlaceholder: "I'll market this property in the area, arrange visits, and keep you updated…",
          days: "Estimated days",
          commission: "Commission %",
          send: "Send proposal",
          sending: "Sending…",
          yourProposal: "Your proposal",
          daysShort: "{{count}} days",
          withdraw: "Withdraw",
          withdrawing: "Withdrawing…",
          declinedHint: "The owner declined this offer. You can send a new proposal until they accept an agent.",
          proposeAgain: "Send a new proposal",
          statusSent: "Sent",
          statusAccepted: "Accepted",
          statusDeclined: "Declined",
          statusWithdrawn: "Withdrawn",
          viewListing: "Open listing",
          requestPreview: "Preview",
          previewHint: "This listing is not live yet. This is a private preview of the owner request.",
          previewNotFound: "This listing request is not available.",
          backToLeads: "Back to leads",
        },
        listings: {
          title: "Your listings",
          count: "{{count}} properties on your desk",
          empty: "No listings yet.",
          emptyHint: "Win a lead or publish a property of your own.",
          emptyFilter: "Nothing in this filter.",
          emptyFilterHint: "Try another status, or add a new listing.",
          ownerManaged: "Owner-managed",
          pending: "Pending",
          available: "Available",
          sold: "Sold",
          rented: "Rented",
          markSold: "Mark as sold",
          markRented: "Mark as rented",
          markAvailable: "Mark available",
          updating: "Updating…",
          view: "View",
          edit: "Edit",
          filterAll: "All",
          filterClosed: "Closed",
        },
        visits: {
          scheduleTitle: "Schedule a visit",
          scheduleText: "Log a viewing you arranged in chat. Buyers message you from the listing — there is no public visit form.",
          noListings: "Add a listing before you can schedule visits.",
          property: "Property",
          datetime: "Date & time",
          visitorName: "Visitor name",
          visitorPhone: "Visitor phone",
          status: "Status",
          notes: "Notes",
          optional: "Optional",
          notesPlaceholder: "Meeting point, keys, access notes…",
          pending: "Pending",
          confirmed: "Confirmed",
          schedule: "Schedule visit",
          scheduling: "Scheduling…",
          listTitle: "Calendar",
          filterUpcoming: "Upcoming",
          filterPending: "Pending",
          filterConfirmed: "Confirmed",
          filterCompleted: "Completed",
          filterCancelled: "Cancelled",
          filterAll: "All",
          empty: "No visits in this view.",
          confirm: "Confirm",
          reschedule: "Reschedule",
          complete: "Complete",
          cancel: "Cancel",
          save: "Save",
          ownerManaged: "owner-managed",
        },
        profile: {
          badge: "Public card",
          title: "Edit your agent profile",
          description: "This is what buyers and owners see on your public agent page.",
          photo: "Profile photo",
          chooseImage: "Choose image",
          reset: "Reset",
          name: "Full name",
          jobTitle: "Title",
          agency: "Agency",
          phone: "Phone",
          location: "Location",
          website: "Website",
          bio: "Professional bio",
          namePlaceholder: "Your full name",
          jobTitlePlaceholder: "Real Estate Agent",
          agencyPlaceholder: "Agency or office name",
          phonePlaceholder: "+961 …",
          locationPlaceholder: "Beirut, Lebanon",
          websitePlaceholder: "https://",
          bioPlaceholder: "Write a short professional bio about your real estate experience…",
          save: "Save public card",
          saving: "Saving…",
          viewPublic: "View public page",
          missing: "Your public agent card is not ready yet.",
          validation: {
            validImage: "Please choose a valid image file.",
            imageSize: "Image size must be less than 5MB.",
            required: "Full name, phone, location, and bio are required.",
            nameLength: "Full name must be at least 3 characters.",
            phone: "Phone number can only contain numbers, spaces, +, -, and parentheses.",
            location: "Location is required.",
            bio: "Bio must be at least 20 characters.",
          },
        },
        states: { loading: "Preparing your office…" },
        success: {
          proposed: "Proposal sent to the owner.",
          withdrawn: "Proposal withdrawn.",
          visitScheduled: "Visit scheduled.",
          visitUpdated: "Visit marked {{status}}.",
          visitRescheduled: "Visit rescheduled.",
          sold: "Property marked as sold.",
          rented: "Property marked as rented.",
          available: "Property marked available again.",
          cardUpdated: "Public agent card updated.",
        },
        errors: {
          load: "Failed to load Agent Hub.",
          premium: "Could not load leads.",
          propose: "Failed to submit proposal.",
          withdraw: "Failed to withdraw proposal.",
          visit: "Failed to schedule visit.",
          visitUpdate: "Failed to update visit.",
          rescheduleMissing: "Choose a new date and time to reschedule.",
          reschedule: "Failed to reschedule visit.",
          listing: "Failed to update listing status.",
          card: "Failed to update your public agent card.",
        },
      },
      requestListing: {
        hero: {
          badge: "Request a listing",
          title: "List with a verified agent.",
          description: "Submit one request. Agents send proposals, you pick an agent, and an admin must approve before the listing goes live. Each listing gets a unique number.",
          myRequests: "Offers",
        },
        path: {
          badge: "New listing",
          title: "How do you want to list this property?",
          description: "Choose an agent and receive offers for free, or list 1 property yourself. After that, Premium is required to self-list again.",
          agentBadge: "Recommended",
          agentTitle: "Managed by an agent",
          agentText: "Verified agents send proposals. You compare offers and pick who represents the property. This path stays free.",
          agentCta: "Receive offers",
          selfBadge: "Self-list",
          selfTitle: "List it myself",
          selfText: "You submit the listing. The first one is free. After that you need Premium. It stays private until an admin approves it, then it goes live under your name.",
          selfCta: "List myself",
          back: "Change how this is listed",
        },
        stats: {
          brief: "Your brief",
          briefValue: "Details, photos, pin",
          agents: "Matching agents",
          agentsValue: "Verified Premium only",
          choice: "Goes live",
          choiceValue: "After admin approval",
        },
        steps: { details: "Property details", confirm: "Confirm & submit" },
        details: {
          badge: "Details",
          title: "Property information",
          description: "The facts agents need to decide if they can represent this listing.",
        },
        form: {
          title: "Title",
          price: "Price ($)",
          city: "City",
          address: "Address",
          listingType: "Listing type",
          category: "Category",
          bedrooms: "Bedrooms",
          bathrooms: "Bathrooms",
          garage: "Garage",
          size: "Size (m²)",
          phone: "Your phone",
          description: "Description",
          titlePlaceholder: "Modern apartment in Zahle",
          cityPlaceholder: "e.g. Zahle",
          addressPlaceholder: "Street, building, area",
          descriptionPlaceholder: "Describe the property, finishes, neighborhood, and selling points…",
          landLocked: "Not used for land",
          buildingLocked: "Not used for buildings",
        },
        options: {
          sale: "Sale",
          rent: "Rent",
          apartment: "Apartment",
          house: "House",
          villa: "Villa",
          land: "Land",
          office: "Office",
          shop: "Shop",
          building: "Building",
        },
        location: {
          badge: "Location",
          title: "Pin the property",
          description: "Click the map, use your current location, paste an address or Google Maps link, or upload a photo that contains a location.",
          locating: "Locating…",
          useMyLocation: "Use my location",
          lat: "Lat",
          lng: "Lng",
          popup: "Selected property location",
          pinSet: "Location pinned",
          clickHint: "Click the map to drop a pin.",
        },
        media: {
          badge: "Media",
          title: "Property photos",
          description: "Clear photos help agents respond. At least one image is required.",
          upload: "Click to upload images",
          hint: "JPG, PNG or WEBP · up to 20 photos · 20MB each",
          remove: "Remove",
        },
        verification: {
          badge: "Verification",
          title: "Two private proof photos",
          description: "Upload a proof of ownership and an إفادة عقارية. An admin reviews these before the listing can go live. They are never shown on the public page.",
          upload: "Add proof of ownership and إفادة عقارية",
          hint: "JPG, PNG or WEBP · 2 photos · ownership + إفادة عقارية · admin only",
        },
        confirm: {
          badge: "Ready",
          title: "Review before sending",
          description: "Matching verified Premium agents who cover {{city}} and handle {{property}} listings will be invited. You can compare up to 10 proposals.",
          yourArea: "your area",
          deal: "Deal",
          layout: "Layout",
          bedsBaths: "{{beds}} beds · {{baths}} baths",
        },
        done: {
          badge: "Submitted",
          title: "Request sent",
          description: "Notified agents: {{count}}. Track proposals from your profile when they arrive.",
        },
        actions: {
          continue: "Continue",
          cancel: "Cancel",
          submit: "Submit to matching agents",
          submitting: "Submitting…",
          back: "Back to edit",
          viewRequests: "View offers",
          home: "Home",
        },
        validation: {
          requiredFields: "Title, address, and city are required.",
          price: "Enter a valid price.",
          bedrooms: "Enter the number of bedrooms.",
          bathrooms: "Enter the number of bathrooms.",
          garage: "Enter the number of garages.",
          description: "Description must be at least 20 characters.",
          location: "Set a map location.",
          images: "Add at least one image.",
          verificationImages: "Upload a proof of ownership photo and an إفادة عقارية.",
          locationNotSupported: "Geolocation is not supported on this device.",
          locationFailed: "Could not get your location.",
        },
        success: { submitted: "Property submitted. Matching verified agents can send proposals (max 10)." },
        errors: {
          submit: "Failed to send listing request.",
          apiOffline:
            "Cannot reach the server. Start the API on port 8800 and try again.",
        },
      },
      chatPage: {
        hero: { badge: "Messages", title: "Real-time conversations.", description: "Chat with listing agents about properties from one clean ShoufBayt inbox.", totalConversations: "Total Conversations", unreadChats: "Unread Chats" },
        sidebar: { badge: "Inbox", title: "Conversations", startNewConversation: "Start New Conversation", searchPlaceholder: "Search conversations...", noMessagesYet: "No messages yet" },
        userPicker: { title: "Choose an agent", description: "Search verified listing agents by name or email.", searchPlaceholder: "Search agents...", loading: "Loading agents...", noUsers: "No agents found.", opening: "Opening...", open: "Open", new: "New" },
        emptyChats: { title: "No conversations", message: "Your chats will appear here when you message someone." },
        chatMain: { activeConversation: "Active conversation", secureChat: "Secure Chat", loadingMessages: "Loading messages...", messagePlaceholder: "Write your message...", sending: "Sending...", send: "Send", clearChat: "Clear chat", clearing: "Clearing…", backToInbox: "Inbox", attach: "Attach image or PDF", recordVoice: "Record voice note", stopRecording: "Stop recording", recording: "Recording…", deleteVoice: "Delete voice note", sendVoice: "Send voice note", voiceNote: "Voice note", downloadFile: "Download file", deleteMessage: "Message options", deleteForMe: "Delete for me", deleteForEveryone: "Delete for everyone", messageDeleted: "This message was deleted" },
        emptyMessages: { title: "No messages yet", message: "Send a message to start the conversation." },
        noChat: { title: "Select or start a conversation", message: "Choose a chat from the inbox or start a new conversation with an agent." },
        fallback: { user: "User", receiver: "Receiver", noEmail: "No email", listingInquiry: "Listing inquiry" },
        confirms: { clearChat: "Clear all messages in this conversation? This cannot be undone.", deleteForEveryone: "Delete this message for everyone? They will see that it was deleted." },
        errors: { openChat: "Failed to open chat.", loadChats: "Failed to load chats.", loadUsers: "Failed to load agents.", openSelectedChat: "Failed to open selected chat.", chatNotCreated: "Chat was not created.", startConversation: "Failed to start conversation.", sendMessage: "Failed to send message.", sendAttachment: "Failed to send attachment.", clearChat: "Failed to clear chat.", microphone: "Microphone access is required for voice notes.", voiceTooShort: "Hold a little longer, then send or delete the voice note.", deleteMessage: "Failed to delete message." },
      },
      notificationsPage: {
        hero: { badge: "Alerts", title: "Stay on top of your account.", description: "Approvals, payments, listing updates, and account activity in one inbox." },
        stats: { total: "Total", unread: "Unread" },
        actions: { markAll: "Mark all read", deleteAll: "Delete all", confirmDeleteAll: "Confirm delete", cancel: "Cancel", openChat: "Open inbox", open: "Open", markRead: "Mark read", delete: "Delete" },
        empty: { title: "You're all caught up", message: "New updates about listings, payments, and chats will appear here.", filteredTitle: "Nothing in this view", filteredMessage: "Try another filter to see the rest of your alerts." },
        states: { loading: "Loading notifications…", deletingAll: "Deleting…" },
        errors: { load: "Failed to load notifications", markAll: "Failed to mark all as read", update: "Failed to update notification", delete: "Failed to delete notification", deleteAll: "Failed to delete notifications" },
        inbox: { title: "Notifications", live: "Live", empty: "No notifications yet", viewAll: "View all notifications", newAlert: "New notification" },
        filters: { all: "All", unread: "Unread", messages: "Messages", account: "Account" },
        groups: { today: "Today", yesterday: "Yesterday", earlier: "Earlier" },
        types: { NEW_MESSAGE: "Message", CONTACT_REPLY: "Support", PROPERTY_APPROVED: "Listing approved", PROPERTY_REJECTED: "Listing update", AGENT_APPLICATION_APPROVED: "Agent application", AGENT_APPLICATION_REJECTED: "Agent application", LISTING_REQUEST: "Listing request", LISTING_REQUEST_ACCEPTED: "Listing request", LISTING_REQUEST_REJECTED: "Listing request", LISTING_LEAD: "New lead", LISTING_PROPOSAL: "Proposal", LISTING_PROPOSAL_ACCEPTED: "Proposal", LISTING_PROPOSAL_REJECTED: "Proposal", APPOINTMENT_SCHEDULED: "Visit", APPOINTMENT_UPDATED: "Visit", APPOINTMENT_REQUESTED: "Visit", APPOINTMENT_REMINDER: "Visit", GENERAL: "Update" },
      },
      admin: {
        loading: { title: "Loading the admin office", message: "Pulling users, listings, and requests." },
        errorState: { title: "Could not load the office" },
        header: { badge: "Admin office", title: "Review what needs you.", description: "Agent unlocks, listings, and support in one queue — the same language as the rest of ShoufBayt." },
        buttons: { tryAgain: "Try again", refreshing: "Refreshing...", refreshData: "Refresh", view: "View", edit: "Edit", delete: "Delete", generating: "Generating...", generateAIReply: "Draft with AI", sending: "Sending...", sendReply: "Send reply", markAnswered: "Mark answered", approve: "Approve", approveAgain: "Change to approved", reject: "Reject", rejectApproved: "Change to rejected", working: "Working..." },
        notifications: { title: "Notifications", clear: "Clear", empty: "No notifications yet.", now: "Now", newSupportTitle: "New support message", newSupportMessage: "{{count}} new message or report received.", newAgentRequestTitle: "New agent request", newAgentRequestMessage: "{{count}} new agent request waiting for review.", pendingAgentRequests: "Pending agent requests", pendingAgentRequestsMessage: "{{count}} request waiting for approval.", pendingListings: "Listings waiting for review", pendingListingsMessage: "{{count}} listing waiting for approval.", listingApprovedTitle: "Listing approved", listingApprovedMessage: "{{title}} is now live.", listingRejectedTitle: "Listing not approved", listingRejectedMessage: "{{title}} was not approved.", newMessagesReports: "New messages / reports", newMessagesReportsMessage: "{{count}} message needs admin review.", replySentTitle: "Reply sent", replySentMessage: "Your reply to {{name}} was saved successfully.", agentAddedTitle: "Agent added", agentAddedMessage: "A new agent was created successfully.", agentRemovedTitle: "Agent removed", agentRemovedMessage: "{{name}} was removed successfully." },
        alertCards: { pendingAgentRequests: "Pending Agent Requests", pendingAgentRequestsText: "Review users waiting for agent approval.", newMessagesReports: "New Messages / Reports", newMessagesReportsText: "Reply to users and update support statuses." },
        stats: { totalUsers: "Users", totalAgents: "Agents", totalPosts: "Listings", totalChats: "Chats", totalMessages: "Messages", savedPosts: "Saved", contactMessages: "Support", newSupport: "Open support", subscriptions: "Premium plans" },
        tabs: { desk: "Office", people: "People", users: "Accounts", posts: "Listings", listings: "Listings", listingRequests: "Requests", agents: "Agents", unlock: "Unlock", agentRequests: "Agent requests", messagesReports: "Inbox", billing: "Billing", support: "Support", payments: "Payments", subscriptions: "Subscriptions", propertyReports: "Listing reports" },
        liveChat: { badge: "Live chat", title: "Help chats", description: "Reply to people using the help box.", empty: "No live chats yet.", pick: "Select a conversation.", loading: "Loading chats…", noMessage: "No messages yet", error: "Could not load live chat." },
        desk: {
          unlock: "Agent unlock",
          unlockHint: "Profiles waiting for review.",
          payments: "Payments",
          paymentsHint: "Receipts to approve or reject.",
          support: "Inbox",
          supportHint: "Messages and contact reports.",
          reports: "Listing reports",
          reportsHint: "Flags on live properties.",
          listings: "Listing review",
          listingsHint: "Owner listing requests. Agent listings go live without admin approval.",
          subscriptionsHint: "Active Premium plans and expired access.",
        },
        overview: { latestUsers: "Latest accounts", latestPosts: "Latest listings", noLatestUsers: "No recent accounts.", noLatestPosts: "No recent listings." },
        users: { badge: "People", title: "Accounts", description: "Search, change roles, and remove accounts.", count: "{{count}} accounts", searchPlaceholder: "Search by username or email...", allRoles: "All roles", usersOnly: "Users", agentsOnly: "Agents", lawyersOnly: "Lawyers", adminsOnly: "Admins", noUsers: "No accounts found.", table: { user: "User", email: "Email", role: "Role", posts: "Listings", saved: "Saved", messages: "Messages", actions: "Actions" } },
        posts: { badge: "Listings", title: "Listings", description: "Agent listings go live immediately. Open, edit, or remove published properties.", count: "{{count}} listings", searchPlaceholder: "Search by title, city, address, or owner...", allTypes: "All types", allProperties: "All categories", allStatuses: "All statuses", noPosts: "No listings found.", status: { pending: "Pending", published: "Live", rejected: "Rejected", sold: "Sold", rented: "Rented" }, table: { property: "Property", owner: "Listed by", city: "City", price: "Price", type: "Type", category: "Category", status: "Status", verification: "Proof photos", none: "None", actions: "Actions" }, prompts: { rejectReason: "Why are you not approving \"{{title}}\"?" }, alerts: { reasonRequired: "Please add a short reason." } },
        listingRequests: {
          badge: "Requests",
          title: "Listing requests",
          description: "Every user request to list through an agent. Open one to add a private admin comment.",
          count: "{{count}} requests",
          searchPlaceholder: "Search by number, title, city, or owner...",
          empty: "No listing requests yet.",
          back: "Back to admin",
          openListing: "Open listing",
          table: { number: "Number", property: "Property", owner: "Owner", city: "City", price: "Price", status: "Status", notes: "Comments" },
          notesCount: "{{count}} comments",
          unnumbered: "No number yet",
          clear: "Clear requests",
          clearing: "Clearing…",
          confirms: {
            clear:
              "Remove every listing request from this list? Live properties stay. This cannot be undone.",
          },
          errors: {
            load: "Could not load listing requests.",
            clear: "Could not clear listing requests.",
          },
          status: {
            OPEN: "Open",
            PENDING: "Pending",
            AWARDED: "Awarded",
            ACCEPTED: "Awarded",
            CANCELLED: "Cancelled",
            EXPIRED: "Expired",
            REJECTED: "Rejected",
          },
        },
        listingNotes: {
          badge: "Admin only",
          title: "Internal comments",
          description: "These notes stay on this request. They are not shown to the owner or the agent.",
          field: "Add a comment",
          placeholder: "Write a note for other admins…",
          add: "Save comment",
          saving: "Saving…",
          loading: "Loading comments…",
          empty: "No comments yet.",
          errors: { load: "Could not load comments.", save: "Could not save this comment." },
        },
        agents: { badge: "Agents", title: "Agent office", description: "Promote an existing account, or remove agent access.", count: "{{count}} agents", addNewAgent: "Add an agent by hand", selectExistingUser: "Select an existing account", agentFullName: "Full name", agentTitle: "Title", phoneNumber: "Phone", location: "Location", imageUrl: "Image URL optional", agentBio: "Bio", addAgent: "Make agent", email: "Email", phone: "Phone", locationLabel: "Location", listings: "Listings", removeAgent: "Remove agent", noAgents: "No agents yet." },
        agentRequests: { badge: "Unlock", title: "Agent unlock", description: "Review applicants, then open the office.", pending: "{{count}} waiting" },
        messages: { badge: "Support", title: "Inbox", description: "Read messages and reports, reply, and close the ticket.", count: "{{count}} threads", totalMessages: "All", new: "Open", reports: "Reports", messages: "Messages", message: "Message", report: "Report", searchPlaceholder: "Search name, email, subject, or reply...", allTypes: "All types", allStatus: "All status", from: "From", adminReply: "Admin reply", repliedOn: "Replied", replyToUser: "Reply", replyPlaceholder: "Write a reply...", linkedAccount: "Linked account", noMessages: "No threads found." },
        messageStatus: { new: "NEW", inReview: "IN REVIEW", answered: "ANSWERED" },
        values: { buy: "Buy", rent: "Rent", apartment: "Apartment", house: "House", land: "Land", villa: "Villa", office: "Office", shop: "Shop", warehouse: "Warehouse", building: "Building" },
        fallback: { user: "User", agent: "Agent", property: "Property", unknown: "Unknown", unknownDate: "Unknown date", noEmail: "No email", noPhone: "No phone", noLocation: "No location", na: "N/A" },
        alt: { userAvatar: "User avatar", property: "Property" },
        alerts: { cannotDeleteSelf: "You cannot delete your own admin account.", writeReplyFirst: "Please write a reply first." },
        confirms: { deleteUser: "Are you sure you want to delete {{username}}? This will delete their posts, saved posts, chats, and messages.", deletePost: "Are you sure you want to delete \"{{title}}\"?", deleteMessage: "Are you sure you want to delete this message from {{name}}?", removeAgent: "Are you sure you want to remove {{name}} from agents? The user account will stay, but role will become USER." },
        errors: { loadData: "Failed to load admin data", deleteUser: "Failed to delete user", deletePost: "Failed to delete post", deleteMessage: "Failed to delete message", updateRole: "Failed to update role", updateMessageStatus: "Failed to update message status", generateAIReply: "Failed to generate AI reply", sendReply: "Failed to send reply", createAgent: "Failed to create agent", removeAgent: "Failed to remove agent", updateListingStatus: "Failed to update listing status" },
      },
      adminAgentRequests: {
        header: { badge: "Admin Review", title: "Agent Requests", description: "Review users who want to become verified ShoufBayt agents. Approving a request creates an agent profile, changes the role to AGENT, and emails the user." },
        stats: { total: "Total", pending: "Pending", approved: "Approved", rejected: "Rejected" },
        filters: { all: "All", pending: "Pending", approved: "Approved", rejected: "Rejected" },
        buttons: { clearProcessed: "Clear Processed", restoreCleared: "Restore Cleared", tryAgain: "Try Again", working: "Working...", approve: "Approve", reject: "Reject", waitForPayment: "Waiting for payment" },
        states: { loading: "Loading agent requests...", empty: "No agent requests found." },
        labels: { title: "Title", payment: "Payment", phone: "Phone", location: "Location", bio: "Bio", message: "Message", adminNote: "Admin Note" },
        status: { pending: "PENDING", approved: "APPROVED", rejected: "REJECTED", processed: "Processed", unpaid: "UNPAID", paid: "PAID", paymentPending: "PAYMENT PENDING", failed: "FAILED" },
        fallback: { thisUser: "this user", unknownAgent: "Unknown Agent", unknown: "unknown", noEmail: "No email", noTitle: "No title", noPhone: "No phone", noLocation: "No location", noBio: "No bio provided." },
        alt: { agentRequest: "Agent request" },
        notes: { approvedByAdmin: "Approved by admin", rejectedByAdmin: "Rejected by admin" },
        confirms: { approve: "Approve {{name}} as a verified agent and send an email?", clearProcessed: "Clear all approved and rejected agent requests from this page?", restoreCleared: "Restore cleared agent requests on this page?" },
        prompts: { rejectReason: "Why are you rejecting {{name}}'s request?" },
        alerts: { noProcessed: "There are no processed requests to clear." },
        success: { statusUpdated: "Agent status updated.", approvedEmailSent: "Agent approved and email sent successfully.", approvedEmailNotSent: "Agent approved, but email was not sent. Check backend terminal.", rejectedEmailSent: "Agent rejected and email sent successfully.", rejectedEmailNotSent: "Agent rejected, but email was not sent. Check backend terminal." },
        errors: { loadFailed: "Failed to load agent requests", userIdMissing: "User ID missing, email route was not called.", approveFailed: "Failed to approve request", rejectFailed: "Failed to reject request", paymentRequired: "This applicant has not completed payment yet. Approve their payment on the Payments tab first." },
      },
      adminAnalytics: {
        header: { badge: "Analytics", title: "Platform Insights", description: "Review ShoufBayt performance, activity, property distribution, and support status in one professional analytics panel." },
        metrics: { averagePrice: "Average Property Price", highestPrice: "Highest Property Price", verifiedAgents: "Verified Agents", openReports: "Open Reports" },
        cards: { usersByRole: "Users by Role", postsByType: "Posts by Type", propertiesByCategory: "Properties by Category", messagesByStatus: "Messages by Status" },
        roles: { admins: "Admins", agents: "Agents", users: "Users" },
        values: { buy: "Buy", rent: "Rent", apartment: "Apartment", house: "House", land: "Land", villa: "Villa", office: "Office", shop: "Shop", warehouse: "Warehouse", building: "Building" },
        status: { open: "Open", read: "Read", resolved: "Resolved" },
        locations: { badge: "Locations", title: "Top Property Cities", listings: "{{count}} listing(s)", empty: "No city data available." },
        growth: { badge: "Growth", title: "Monthly Activity", users: "Users", posts: "Posts" },
        fallback: { unknown: "Unknown" },
      },
    },
  },
  ar: {
    translation: {
      nav: {
        home: "الرئيسية",
        properties: "العقارات",
        agents: "الوكلاء",
        tickets: "التذاكر",
        investments: "الاستثمارات",
        lawyerDesk: "مكتب المحامي",
        live: "مباشر",
        about: "من نحن",
        contact: "مساعدة",
        dashboard: "مكتب الإدارة",
        messages: "الوارد",
        alerts: "التنبيهات",
        billing: "الفوترة",
        agentDashboard: "المكتب",
        ownerDashboard: "إعلاناتي",
        login: "تسجيل الدخول",
        register: "انضم",
        myHomes: "عقاراتي",
        saved: "المحفوظات",
        offers: "العروض",
        navigation: "القائمة",
        menuTitle: "القائمة",
        brandSubtitle: "عقارات في لبنان",
        beta: "Beta",
        darkMode: "الوضع الداكن",
        lightMode: "الوضع الفاتح",
        openProfile: "فتح الملف الشخصي",
        language: "EN",
        switchLanguage: "English",
      },
      app: {
        postNotFound: "هذا الإعلان غير متاح.",
        generalError: "حدث خطأ ما.",
      },
      helpChat: {
        open: "مساعدة",
        close: "إغلاق",
        back: "رجوع",
        startOver: "البداية",
        title: "مساعدة",
        kicker: "ShoufBayt",
        steps: {
          start: "بماذا تحتاج المساعدة؟",
          technical: "اختر المشكلة التقنية.",
          business: "اختر موضوع العمل. الدفع ومكتب الوكيل متوقفان مؤقتاً.",
          techLogin: "افتح تسجيل الدخول. إذا نسيت كلمة المرور، استخدم نسيت كلمة المرور واتبع رسالة البريد.",
          techPhone: "افتح التحقق من الهاتف وأدخل الرمز المرسل إلى رقمك.",
          techPage: "حدّث الصفحة. للصور استخدم JPG أو PNG أو WEBP ثم أعد الرفع.",
          techAccount: "افتح ملفك لتحديث الاسم والهاتف وتفاصيل الحساب.",
          bizListings: "تصفح العقارات من صفحة الإعلانات. للنشر، سجّل الدخول ثم افتح اطلب إعلاناً.",
          bizAgentContact: "افتح صفحة العقار. رقم الوكيل وزر التواصل موجودان هناك.",
          bizOther: "إذا لم يكن الأمر عن إعلان أو بيانات تواصل الوكيل، راسل فريق العمل على واتساب.",
        },
        choices: {
          technical: "مشكلة تقنية",
          business: "مشكلة عمل",
          login: "تسجيل الدخول أو كلمة المرور",
          phone: "التحقق من الهاتف",
          page: "الصفحة أو الصور",
          account: "الحساب",
          listings: "الإعلانات",
          agentContact: "بيانات تواصل الوكيل",
          other: "شيء آخر",
          notHelped: "هذا لم يساعدني",
          openLogin: "الذهاب لتسجيل الدخول",
          forgot: "نسيت كلمة المرور",
          openPhone: "التحقق من الهاتف",
          openProfile: "فتح الملف",
          browse: "تصفح العقارات",
          listProperty: "اطلب إعلاناً",
          whatsapp: "مراسلة واتساب",
        },
        whatsappText: {
          technical: "مرحباً، أحتاج مساعدة في مشكلة تقنية على ShoufBayt.",
          business: "مرحباً، أحتاج مساعدة في مسألة عمل على ShoufBayt.",
        },
      },
      tickets: {
        badge: "تذاكر قانونية",
        title: "التذاكر",
        text: "",
        deskTitle: "المكتب",
        deskText: "",
        cols: {
          number: "الرقم",
          case: "القضية",
          client: "العميل",
          lawyer: "المحامي",
          phone: "الهاتف",
          status: "الحالة",
        },
        new: "تذكرة جديدة",
        request: "اطلب تذكرة",
        board: "قيد المراجعة",
        boardEmpty: "لا توجد تذاكر قيد المراجعة.",
        yourTickets: "تذاكرك",
        newTitle: "تذكرة جديدة",
        newText: "",
        back: "كل التذاكر",
        filter: "الحالة",
        all: "الكل",
        loading: "جارٍ تحميل التذاكر…",
        emptyTitle: "لا توجد تذاكر بعد",
        emptyText: "افتح تذكرة إذا كنت تحتاج مساعدة قانونية في صفقة أو نزاع.",
        openCount: "{{count}} مفتوحة",
        submit: "فتح التذكرة",
        saving: "جارٍ الحفظ…",
        reply: "إرسال الرد",
        assign: "تعيين محامٍ",
        assignLawyer: "تعيين للمحامي",
        chooseLawyer: "اختر محامياً",
        unassigned: "بانتظار التعيين",
        assignedTo: "المحامي: {{name}}",
        lawyerPanel: "المحامي المعيّن",
        waitingLawyer: "لم يُعيَّن بعد",
        waitingLawyerText: "سيعيّن المشرف محامياً.",
        workloadTitle: "المحامون",
        workloadHeading: "التذاكر النشطة",
        activeCount: "{{count}} نشطة",
        noLawyers: "لا يوجد محامون بعد",
        noLawyersText: "أنشئ حساب محامٍ ثم عيّن التذاكر من هنا.",
        closed: "هذه التذكرة مغلقة.",
        someone: "مستخدم",
        imagesHint: "اختياري. حتى 8 صور، JPG أو PNG أو WEBP.",
        fields: {
          title: "العنوان",
          phone: "رقم الهاتف",
          category: "التصنيف",
          description: "ماذا حصل",
          images: "صور (اختياري)",
          reply: "الرد",
          status: "الحالة",
        },
        category: {
          REAL_ESTATE_DOCUMENTS: "أوراق عقارية",
          LAND_REGISTRY_CADASTRE: "السجل العقاري والمساحة",
          CONSTRUCTION: "البناء",
          LAWYER_DEFENSE: "دفاع محامٍ",
          PAYMENT: "الدفع",
          OTHER: "أخرى",
          CONTRACT: "عقد",
          NEIGHBOR: "جار / مبنى",
          DELAY: "تأخير",
        },
        status: {
          OPEN: "مفتوحة",
          IN_REVIEW: "قيد المراجعة",
          WAITING_USER: "بانتظارك",
          WAITING_OTHER: "بانتظار طرف آخر",
          RESOLVED: "تم الحل",
          CLOSED: "مغلقة",
        },
        errors: {
          load: "تعذر تحميل التذاكر.",
          loadOne: "تعذر تحميل هذه التذكرة.",
          create: "تعذر إنشاء التذكرة.",
          phone: "أدخل رقم هاتف صالح.",
          reply: "تعذر إرسال الرد.",
          take: "تعذر استلام التذكرة.",
          assign: "تعذر تعيين المحامي.",
          status: "تعذر تحديث الحالة.",
          remove: "تعذر حذف التذكرة.",
        },
        remove: "حذف",
        removing: "جارٍ الحذف…",
        removeConfirm: "حذف التذكرة {{number}}؟ لا يمكن التراجع عن ذلك.",
      },
      lawyerHub: {
        badge: "مكتب المحامي",
        title: "القضايا",
        text: "{{name}}",
        allTickets: "اللوحة",
        emptyTitle: "لا توجد قضايا معيّنة",
        emptyText: "تظهر التذاكر المعيّنة هنا.",
        from: "{{name}}",
        cols: {
          number: "الرقم",
          case: "القضية",
          client: "العميل",
          phone: "الهاتف",
          status: "الحالة",
        },
        stats: {
          assigned: "معيّنة",
          active: "نشطة",
          review: "قيد المراجعة",
          waiting: "بانتظار",
        },
        errors: { load: "تعذر تحميل المكتب." },
      },
      listingPlan: {
        launchBadge: "شهر الإطلاق",
        launchNotice: "Premium مجاني للجميع حتى {{date}}. بعد ذلك، إعلان ذاتي واحد مجاني ثم ${{price}} شهرياً. طلب وكيل لإدراج العقار يبقى مجانياً.",
        launchCard: "Premium مجاني حتى {{date}}. بعد ذلك يحصل المستخدمون على إعلان ذاتي مجاني واحد ثم ${{price}} شهرياً. الإدراج عبر وكيل يبقى مجانياً.",
        remaining: "تبقى {{remaining}} من {{limit}} إعلان ذاتي مجاني. بعد ذلك Premium بـ ${{price}} شهرياً. يمكنك دائماً طلب وكيل لإدراج العقار.",
        premiumActive: "Premium نشط. يمكنك إدراج العقارات بنفسك دون حد الإعلانات المجانية.",
        limitBadge: "Premium مطلوب",
        limitTitle: "لقد استخدمت إعلاناتك المجانية.",
        limitText: "اشترك في Premium مقابل ${{price}} شهرياً لتدرج بنفسك مجدداً. ما زال بإمكانك استقبال عروض الوكلاء دون تكلفة إضافية.",
        limitError: "لقد استخدمت إعلاناتك الذاتية المجانية. اشترك في Premium أو اطلب من وكيل إدراج العقار.",
        upgrade: "احصل على Premium",
        useAgent: "اطلب وكيلاً بدلاً من ذلك",
        billing: {
          badge: "إعلاناتك",
          agentBadge: "فوترة الوكيل",
          title: "ShoufBayt Premium",
          userDescription: "أدرج عقاراً واحداً بنفسك مجاناً. بعد ذلك Premium بـ ${{price}} شهرياً. طلب وكيل واستقبال العروض يبقى مجانياً.",
          agentDescription: "يحصل الوكلاء الموثوقون على 30 يوماً من Premium، ثم ${{price}} شهرياً. بدون عمولة على المبيعات.",
          activeUser: "يمكنك إدراج العقارات بنفسك دون حد الإعلان المجاني الواحد. أرسل ${{price}} قبل انتهاء الفترة.",
          userNeedPay: "لقد استخدمت إعلانك الذاتي المجاني. اشترك مقابل ${{price}} شهرياً لمتابعة الإدراج بنفسك.",
        },
      },
      billingPage: {
        back: "العودة إلى الملف",
        loading: "جارٍ تحميل خطتك…",
        snapshot: "ملخص الحساب",
        role: "الدور",
        status: "الحالة",
        periodEnd: "نهاية الفترة",
        graceEnd: "نهاية المهلة",
        trialUsed: "استُخدمت الفترة التجريبية",
        renewal: "التجديد",
        listings: "الإعلانات الذاتية",
        complimentaryUntil: "مجاني حتى",
        premiumEnds: "ينتهي Premium",
        premiumEndsBanner: "ينتهي اشتراك Premium في {{date}}.",
        daysLeft: "تبقى {{count}} يوماً",
        unlimited: "غير محدود",
        yes: "نعم",
        no: "لا",
        cancelled: "ملغى",
        manual: "يدوي",
        on: "مفعّل",
        none: "—",
        current: "خطتك الحالية",
        included: "مشمول الآن",
        afterLaunch: "بعد شهر الإطلاق",
        launchBanner: "Premium مجاني حتى {{date}}. لديك كامل مزايا Premium دون رسوم. بعد هذا التاريخ تُطبَّق قواعد الباقة المجانية وPremium أدناه.",
        history: "سجل المدفوعات",
        transactions: "{{count}} عملية",
        noPayments: "لا توجد مدفوعات بعد.",
        howToPay: "طريقة الدفع",
        sendTo: "أرسل ${{price}} إلى {{name}}",
        payCopy: "استخدم OMT أو Whish Money أو BOB Finance. أرسل ${{price}} دولاراً بالضبط ثم ارفع صورة واضحة للإيصال. يُفعَّل Premium بعد التأكيد.",
        recipient: "المستلم",
        number: "الرقم",
        amount: "المبلغ",
        copy: "نسخ",
        copied: "تم النسخ",
        payPremium: "ادفع مقابل Premium",
        renewPremium: "جدّد Premium",
        amountDue: "المبلغ المستحق: ${{price}} · الإيصال مطلوب",
        instant: "فوري",
        receiptReview: "مراجعة الإيصال",
        submit: "إرسال الإيصال",
        submitting: "جارٍ الإرسال…",
        receipt: "الإيصال",
        chooseReceipt: "اختر الإيصال",
        changeReceipt: "تغيير الإيصال",
        receiptHint: "PNG أو JPG — مطلوب",
        reference: "مرجع العملية",
        referencePlaceholder: "رقم مرجعي اختياري",
        cardSoon: "دفع البطاقة غير متاح في لبنان بعد. أرسل ${{price}} إلى {{name}} وارفع الإيصال.",
        cancel: "إلغاء الاشتراك",
        confirmCancel: "إذا ألغيت الآن تبقى Premium حتى {{date}}. بعدها مهلة 7 أيام. سنرسل تأكيداً بالبريد.",
        confirmCancellation: "تأكيد الإلغاء",
        keepPlan: "الإبقاء على الخطة",
        cancelling: "جارٍ الإلغاء…",
        resume: "استئناف الخطة",
        resuming: "جارٍ الاستئناف…",
        resumeCopy: "لن تُجدَّد هذه الخطة. ينتهي الوصول في {{date}}. استأنف للاحتفاظ بالأيام المتبقية، أو ادفع أدناه لبدء شهر جديد.",
        roles: {
          USER: "مستخدم",
          AGENT: "وكيل",
          ADMIN: "مسؤول",
          APPLICANT: "طلب وكيل",
        },
        statusLabels: {
          launch: "Premium مجاني",
          trial: "تجربة 30 يوماً",
          premium: "Premium",
          grace: "فترة مهلة",
          inactive: "حساب الوكيل متوقف",
          none: "الباقة المجانية",
          cancels: "يُلغى في نهاية الفترة",
        },
        hero: {
          userBadge: "خطتك",
          userTitle: "اختر طريقة الإدراج.",
          userText: "تصفح واحفظ وتواصل مجاناً. أدرج عقاراً واحداً بنفسك دون رسوم. Premium بـ ${{price}} شهرياً للإدراج الذاتي غير المحدود. طلب وكيل للإدراج يبقى مجانياً.",
          agentBadge: "خطة الوكيل",
          agentTitle: "أبقِ المكتب مفتوحاً.",
          agentText: "يحصل الوكيل الموثوق على تجربة {{trial}} يوماً بعد الموافقة، ثم ${{price}} شهرياً. إعلانات وطلبات ولوحة دون عمولة.",
          adminBadge: "فوترة المنصة",
          adminTitle: "خطط لكل دور.",
          adminText: "حسابات الفريق غير مفوترة. يتبع المستخدمون والوكلاء قواعد المجاني وPremium أدناه. يبقى Premium مجانياً حتى {{date}}.",
          applicantBadge: "فتح حساب الوكيل",
        },
        free: {
          tag: "مجاني",
          price: "$0",
          period: "مشمول دائماً",
          userTitle: "حساب مجاني",
          userLead: "كل ما تحتاجه لإيجاد عقار، مع إعلان ذاتي واحد.",
          userPerks: [
            "تصفح واحفظ وتواصل بشأن الإعلانات",
            "راسل الوكيل بشأن أي إعلان",
            "عقار واحد تدرجه بنفسك",
            "اطلب من وكيل موثوق الإدراج — دائماً مجاناً",
            "لا حاجة لبطاقة",
          ],
          agentTitle: "بدون Premium",
          agentLead: "قد تبقى البطاقة العامة ظاهرة، لكن إجراءات المكتب الجديدة تتوقف.",
          agentPerks: [
            "قد تبقى بطاقة الوكيل العامة ظاهرة",
            "تبقى الإعلانات الحالية خلال المهلة",
            "تتوقف الإعلانات الجديدة وأدوات الطلبات",
            "بعد المهلة يعود الحساب إلى مستخدم عادي",
          ],
          adminTitle: "وصول الفريق",
          adminLead: "أدوات المسؤول مشمولة. لا اشتراك شخصي.",
          adminPerks: [
            "المكتب الكامل: المستخدمون والإعلانات والمدفوعات والدعم",
            "غير مفوتر كـ Premium",
            "راجع طلبات الوكلاء والإيصالات",
            "أرسل رسائل شهر الإطلاق من هذه الصفحة",
          ],
        },
        premium: {
          tag: "Premium",
          period: "/ شهرياً",
          complimentary: "مجاني هذا الشهر",
          userTitle: "Premium",
          userLead: "إعلانات ذاتية غير محدودة. طلب وكيل يبقى مجانياً.",
          userPerks: [
            "عقارات غير محدودة تدرجها بنفسك",
            "أدوات ظهور أوضح",
            "نفس المراسلة والحفظ",
            "ألغِ في أي وقت؛ يبقى الوصول حتى نهاية الفترة",
          ],
          agentTitle: "Premium للوكيل",
          agentLead: "المكتب الكامل: الإعلانات والطلبات والتحليلات دون عمولة.",
          agentPerks: [
            "إعلانات غير محدودة",
            "قبول طلبات الإدراج من المالكين",
            "لوحة وأدوات مميزة",
            "بدون عمولة على البيع أو الإيجار",
            "تجربة {{trial}} يوماً بعد التوثيق",
          ],
          adminTitle: "Premium للأعضاء",
          adminLead: "ما يحصل عليه المستخدمون والوكلاء عندما يكون Premium نشطاً.",
          adminPerks: [
            "المستخدمون: إعلانات ذاتية غير محدودة",
            "الوكلاء: المكتب والطلبات واللوحة",
            "${{price}} شهرياً بعد نافذة الإطلاق المجانية",
            "مهلة {{grace}} أيام بعد انتهاء فترة مدفوعة",
          ],
        },
        campaign: {
          badge: "رسائل الإطلاق",
          title: "رسائل نهاية الشهر حسب الدور",
          text: "عند انتهاء Premium المجاني يصل كل عضو إلى رسالة تناسب دوره: مستخدم أو وكيل أو مسؤول. أرسل معاينة إلى بريدك الآن. الإرسال الفعلي ينتظر انتهاء التاريخ المجاني ما لم تفرضه.",
          active: "Premium المجاني مفعّل حتى {{date}} (تبقى {{days}} يوماً).",
          ended: "انتهى Premium المجاني. يمكن إرسال الحملة.",
          sent: "{{sent}} أُرسلت · {{pending}} بانتظار",
          email: "بريد التجربة",
          role: "دور المعاينة",
          sendTest: "إرسال معاينة",
          sendingTest: "جارٍ إرسال المعاينة…",
          sendAll: "مراسلة الجميع",
          sendingAll: "جارٍ الإرسال…",
          force: "أرسل حتى لو كان شهر الإطلاق المجاني ما زال سارياً",
        },
      },
      accountListings: {
        homesTitle: "العقارات التي أدرجتها.",
        ownerTitle: "عقاراتك.",
        savedTitle: "العقارات التي حفظتها.",
        homesDescription: "أدر إعلانات مكتبك — الصور والحالة والتعديلات في مكان واحد.",
        ownerDescription: "الإعلانات الناتجة عن طلبك عبر وكيل. النشر الأول ينتظر مراجعة الإدارة.",
        savedDescription: "عقارات أبقيتها للعودة إليها. افتح واحداً عندما تكون جاهزاً للنظر عن قرب.",
        count: "{{count}} عقارات",
        stats: { listed: "مدرجة", available: "متاحة", closed: "مباعة أو مؤجّرة", saved: "محفوظة" },
      },
      live: {
        hero: { badge: "مباشر", title: "السوق، مباشرة.", description: "أرقام حقيقية من ShoufBayt — الإعلانات والوكلاء والصفقات المغلقة، تتحدّث مع استخدام الموقع.", browse: "تصفح العقارات" },
        updated: { live: "مباشر", now: "آخر تحديث {{time}}" },
        cards: { liveListings: "إعلانات نشطة", closed: "مباع أو مؤجّر", agents: "وكلاء موثوقون", members: "أشخاص على ShoufBayt", cities: "مدن", onlineNow: "متصل الآن" },
        mix: { badge: "التوزيع", title: "ما هو معروض.", sale: "للبيع", rent: "للإيجار", sold: "تم البيع", rented: "تم التأجير" },
        cities: { badge: "المدن", title: "أين تُدرج العقارات.", empty: "لا توجد بيانات مدن بعد." },
        chart: { badge: "النمو", title: "إعلانات جديدة، ستة أشهر.", description: "العقارات المضافة إلى السوق العام في كل شهر." },
        errors: { load: "تعذر تحميل الأرقام المباشرة." },
      },
      mapPlace: {
        placeholder: "عنوان، إحداثيات، أو رابط خرائط غوغل",
        place: "ضعه على الخريطة",
        placing: "جارٍ البحث…",
        upload: "ارفع صورة الموقع",
        empty: "الصق عنواناً أو إحداثيات أو رابط خرائط.",
        notFound: "تعذر العثور على هذا المكان. جرّب رابط خرائط أو انقر على الخريطة.",
        noGps: "هذه الصورة لا تحتوي على موقع. فعّل الموقع في الكاميرا، أو الصق رابط خرائط.",
        badFile: "ارفع صورة JPG ملتقطة مع تفعيل الموقع.",
      },
      investments: {
        eyebrow: "الاستثمارات",
        title: "الاستثمارات",
        add: "إضافة استثمار",
        addTitle: "إضافة استثمار",
        addText: "يبقى هذا خارج صفحة العقارات. يظهر فقط في الاستثمارات.",
        loading: "جارٍ تحميل الاستثمارات",
        emptyTitle: "لا توجد استثمارات بعد.",
        emptyText: "عندما ينشر وكيل مبنى أو أرضاً أو مكتباً أو محلاً أو مستودعاً، سيظهر هنا.",
        back: "كل الاستثمارات",
        about: "عن هذا الاستثمار",
        price: "السعر المطلوب",
        contact: "مراسلة",
        call: "اتصال",
        opening: "جارٍ فتح المحادثة…",
        listedBy: "أدرج بواسطة",
        inquiry: "أنا مهتم بهذا الاستثمار.",
        saving: "جارٍ النشر…",
        publish: "نشر الاستثمار",
        savePin: "حفظ الموقع",
        savingPin: "جارٍ حفظ الموقع…",
        edit: "تعديل",
        editTitle: "تعديل الاستثمار",
        editText: "حدّث التفاصيل أو الصور أو دبوس الخريطة. يبقى هذا ضمن الاستثمارات.",
        saveChanges: "حفظ التغييرات",
        savingChanges: "جارٍ الحفظ…",
        cancel: "إلغاء",
        delete: "حذف",
        deleting: "جارٍ الحذف…",
        confirmDelete: "حذف هذا الاستثمار؟ لا يمكن التراجع عن ذلك.",
        backToItem: "العودة إلى الاستثمار",
        notFound: "هذا الاستثمار غير متاح.",
        types: { building: "مبنى", land: "أرض", office: "مكتب", shop: "محل", warehouse: "مستودع" },
        form: {
          title: "العنوان",
          price: "السعر (دولار)",
          city: "المدينة",
          address: "العنوان",
          type: "النوع",
          description: "الوصف",
          photos: "الصور",
          currentPhotos: "الصور الحالية",
          removePhoto: "إزالة",
        },
        errors: {
          load: "تعذر تحميل الاستثمارات.",
          save: "تعذر نشر هذا الاستثمار.",
          update: "تعذر حفظ هذه التغييرات.",
          delete: "تعذر حذف هذا الاستثمار.",
          description: "اكتب 20 حرفاً على الأقل.",
          location: "اضغط على الخريطة لوضع الدبوس.",
          locationSave: "تعذر حفظ الموقع.",
          agentsOnly: "يمكن للوكلاء والمسؤولين فقط إضافة استثمار.",
          notAllowed: "لا يمكنك تعديل هذا الاستثمار.",
        },
      },
      footer: {
        brandSubtitle: "عقارات في لبنان",
        description: "اعثر على شقق ومنازل وأراضٍ ومكاتب ومحلات وأكثر للبيع والإيجار في لبنان. احفظ الإعلانات، راسل المالكين، وأدرج عقاراً عندما تكون جاهزاً.",
        socials: { facebook: "فيسبوك", instagram: "إنستغرام", linkedin: "لينكدإن" },
        explore: { title: "استكشاف", home: "الرئيسية", properties: "العقارات", tickets: "التذاكر", investments: "الاستثمارات", live: "مباشر", about: "من نحن", contact: "مساعدة" },
        account: { title: "الحساب", profile: "ملفي الشخصي", createListing: "إنشاء إعلان", requestListing: "اطلب إعلانًا", updateProfile: "تحديث الملف الشخصي", messages: "الرسائل", alerts: "التنبيهات", billing: "الفوترة", login: "تسجيل الدخول" },
        contact: { title: "التواصل", email: "البريد الإلكتروني", location: "الموقع", locationValue: "بيروت، لبنان", hours: "ساعات العمل", hoursValue: "الإثنين - السبت، 9:00 صباحاً - 6:00 مساءً" },
        bottom: { rights: "ShoufBayt. جميع الحقوق محفوظة.", privacy: "سياسة الخصوصية", support: "الدعم" },
      },
      supportChat: {
        fab: "مساعدة",
        title: "مساعدة",
        subtitle: "محادثة مع ShoufBayt",
        placeholder: "اكتب رسالة…",
        send: "إرسال",
        signIn: "سجّل الدخول للدردشة معنا.",
        empty: "اسألنا عن أي شيء.",
        loading: "جارٍ فتح المحادثة…",
        error: "تعذر بدء المحادثة.",
      },
      auth: {
        google: {
          continue: "المتابعة باستخدام Google",
          connecting: "جارٍ الاتصال...",
          orEmail: "أو المتابعة بالبريد الإلكتروني",
          cancelled: "تم إلغاء تسجيل الدخول بجوجل.",
          failed: "فشل تسجيل الدخول بجوجل. يرجى المحاولة مرة أخرى.",
          unavailable: "تسجيل الدخول بجوجل غير متاح حالياً.",
          notConfigured: "أضف GOOGLE_CLIENT_ID إلى ملف api/.env ثم أعد تشغيل الـ API.",
          popupBlocked: "تم حظر نافذة تسجيل الدخول بجوجل. اسمح بالنوافذ المنبثقة ثم أعد المحاولة.",
          close: "إغلاق",
          popupBadge: "ShoufBayt",
          popupTitle: "المتابعة باستخدام Google",
          popupDescription: "اختر حساب Google لتسجيل الدخول إلى ShoufBayt.",
          popupHint: "استخدم زر Google أدناه. اسمح بالنوافذ المنبثقة إذا طلب المتصفح ذلك.",
        },
      },
      home: {
        hero: {
          label: "عقارات في لبنان",
          title: "اشترِ وبِع وأجّر كل أنواع العقارات.",
          description: "شقق، منازل، فلل، أراضٍ، مكاتب، محلات، ومستودعات — للبيع أو الإيجار في لبنان.",
          welcomeBack: "مرحباً بعودتك",
          createAccount: "إنشاء حساب",
          signIn: "تسجيل الدخول",
          listProperty: "أدرج عقاراً",
          viewProfile: "ملفك",
          browseHomes: "تصفح العقارات",
          searchPlaceholder: "المدينة أو المنطقة، مثل بيروت",
          searchButton: "بحث",
          popular: "شائع",
        },
        search: { all: "الكل", buy: "شراء", rent: "إيجار" },
        cities: { beirut: "بيروت", tripoli: "طرابلس", jounieh: "جونية", byblos: "جبيل" },
        types: {
          label: "حسب النوع",
          title: "ليست المنازل فقط.",
          description: "سكني وأراضٍ وتجاري في سوق واحد.",
          apartment: "شقق",
          house: "منازل",
          villa: "فلل",
          land: "أراضٍ",
          office: "مكاتب",
          shop: "محلات",
          warehouse: "مستودعات",
          building: "مبانٍ",
          hint: {
            apartment: "شقق ومبانٍ",
            house: "منازل عائلية",
            villa: "فلل مستقلة",
            land: "قطع وأراضٍ",
            office: "مساحات عمل",
            shop: "محلات تجارية",
            warehouse: "تخزين وصناعي",
            building: "مبانٍ كاملة",
          },
        },
        roles: {
          ownerTitle: "أريد أن أدرج عقاراً",
          ownerText: "شارك أي عقار مع المشترين والمستأجرين.",
          buyerTitle: "أريد عقاراً",
          buyerText: "تصفح الإعلانات وتواصل مع المالك أو الوكيل.",
          agentTitle: "الوكلاء",
          agentText: "انضم كوكيل موثوق، أدر الإعلانات، وتحدث مع العملاء من المنصة.",
          helpTitle: "الدعم",
          helpText: "أسئلة عن الحسابات أو الإعلانات أو أن تصبح وكيلاً؟ راسل فريق ShoufBayt.",
        },
        build: {
          label: "كيف تعمل",
          title: "ثلاث خطوات. بدون تعقيد.",
          oneTitle: "ابحث",
          oneText: "اختر شراء أو إيجار، ثم حدّد المدينة ونوع العقار.",
          twoTitle: "افتح إعلاناً",
          twoText: "شاهد الصور والسعر والخريطة ومن نشر الإعلان.",
          threeTitle: "راسل الوكيل",
          threeText: "اسأل أو رتّب معاينة في المحادثة. بدون نماذج إضافية.",
        },
        invite: {
          title: "جاهز للتصفح؟",
          text: "ابدأ بالإعلانات. أنشئ حساباً عندما تريد حفظ عقار أو إرسال رسالة.",
        },
        latest: {
          label: "أحدث الإعلانات",
          title: "أحدث العقارات.",
          description: "إعلانات منشورة جديدة في لبنان.",
          loading: "جارٍ تحميل العقارات…",
          empty: "لا توجد عقارات منشورة تطابق هذا البحث بعد.",
        },
      },
      searchBar: {
        types: { all: "الكل", buy: "شراء", rent: "إيجار" },
        labels: { location: "الموقع", property: "العقار", bedrooms: "غرف النوم", bathrooms: "الحمامات", minPrice: "أقل سعر", maxPrice: "أعلى سعر" },
        placeholders: { city: "ابحث عن مدينة...", minPrice: "$0", maxPrice: "$999999" },
        options: { any: "أي", apartment: "شقة", house: "منزل", land: "أرض", oneBedroom: "غرفة نوم واحدة", twoBedrooms: "غرفتا نوم", threeBedrooms: "3 غرف نوم", fourBedrooms: "4 غرف نوم", oneBathroom: "حمام واحد", twoBathrooms: "حمامان", threeBathrooms: "3 حمامات" },
        buttons: { search: "بحث", reset: "إعادة ضبط" },
        errors: { minPriceGreater: "لا يمكن أن يكون أقل سعر أكبر من أعلى سعر." },
        markets: {
          title: "أسواق شائعة",
          "beirut-rent": "إيجار في بيروت",
          "beirut-buy": "شراء في بيروت",
          tripoli: "طرابلس",
          jounieh: "جونية",
          byblos: "جبيل",
          houses: "سكني للبيع",
          land: "أراضٍ",
        },
        brief: {
          label: "ملخص بحثك",
          empty: "اختر سوقاً أو حدّد الفلاتر. سيظهر الملخص هنا قبل البحث.",
          beds: "{{count}} غرف",
          baths: "{{count}} حمامات",
          fromPrice: "من ${{price}}",
          upToPrice: "حتى ${{price}}",
        },
      },
      smartSearchAssistant: {
        header: { badge: "مساعد البحث الذكي", title: "صف العقار الذي تبحث عنه", description: "اكتب احتياجاتك العقارية بلغة عادية وسيقوم ShoufBayt باكتشاف أهم فلاتر البحث." },
        input: { placeholder: "مثال: أريد شقة في بيروت للإيجار مع غرفتي نوم بسعر أقل من 800 دولار..." },
        buttons: { search: "بحث ذكي", clear: "مسح", loading: "جارٍ البحث..." },
        examples: { one: "شقة في بيروت للإيجار", two: "منزل للبيع مع 3 غرف نوم", three: "أرض في جبيل أقل من $100000" },
        detected: { title: "الفلاتر المكتشفة", city: "المدينة", type: "النوع", property: "العقار", bedrooms: "غرف النوم", minPrice: "أقل سعر", maxPrice: "أعلى سعر" },
        errors: { empty: "يرجى وصف العقار الذي تبحث عنه.", failed: "فشل تنفيذ البحث الذكي." },
      },
      about: {
        hero: { badge: "عن ShoufBayt", title: "سوق لكل أنواع العقارات.", description: "ShoufBayt للشقق والمنازل والأراضي والمكاتب والمحلات والمستودعات — وليس للمنازل فقط. ابحث وقارن وأدرج وأدر العقارات في مكان واحد." },
        mission: { badge: "مهمتنا", title: "جعل كل نوع عقار بسيطاً وواضحاً.", description: "نربط المشترين والمستأجرين والمالكين والوكلاء حول الإعلانات السكنية والتجارية، بمنصة مصممة للثقة والوضوح والسرعة." },
        values: { title: "لماذا ShoufBayt؟", easySearch: "بحث سهل", easySearchText: "اعثر على الشقق والمنازل والأراضي والمساحات التجارية حسب المدينة والسعر والنوع.", trustedAgents: "وكلاء موثوقون", trustedAgentsText: "تواصل مع وكلاء معتمدين ومالكي عقارات محترفين.", cleanManagement: "إدارة منظمة", cleanManagementText: "أدر الإعلانات والرسائل والعقارات المحفوظة وطلبات الدعم بسهولة." },
      },
      contact: {
        hero: { badge: "دعم ShoufBayt", title: "تواصل مع فريق الدعم.", description: "أرسل رسالة عامة أو بلّغ عن مشكلة وتابع ردود الإدارة من صفحة دعم واضحة ومنظمة.", loginNoticeBefore: "يمكنك عرض هذه الصفحة، لكن يجب عليك", signIn: "تسجيل الدخول", loginNoticeAfter: "قبل إرسال الرسائل أو متابعتها." },
        info: { badge: "تواصل معنا", title: "نحن جاهزون للمساعدة.", description: "تواصل مع ShoufBayt للاستفسارات، مساعدة الحساب، مشاكل العقارات، التقارير، وطلبات الدعم العامة.", email: "البريد الإلكتروني", phone: "الهاتف", location: "الموقع", locationValue: "جب جنين،البقاع الغربي، لبنان", workingHours: "ساعات العمل", workingHoursValue: "الإثنين - الجمعة، 9:00 صباحاً - 6:00 مساءً" },
        form: { badge: "إرسال طلب", title: "إرسال رسالة", description: "اختر ما إذا كنت تريد إرسال رسالة عادية أو الإبلاغ عن مشكلة إلى فريق ShoufBayt.", fullName: "الاسم الكامل", emailAddress: "البريد الإلكتروني", requestType: "نوع الطلب", subject: "الموضوع", message: "الرسالة", namePlaceholder: "أدخل اسمك", emailPlaceholder: "أدخل بريدك الإلكتروني", subjectPlaceholder: "أدخل الموضوع", messagePlaceholder: "اكتب رسالتك...", signInPlaceholder: "يرجى تسجيل الدخول لإرسال رسالة", generalMessage: "رسالة عامة", reportProblem: "الإبلاغ عن مشكلة", signInToSend: "سجّل الدخول للإرسال", sending: "جارٍ الإرسال...", sendReport: "إرسال التقرير", sendMessage: "إرسال الرسالة" },
        validation: { nameRequired: "الاسم الكامل مطلوب.", emailRequired: "البريد الإلكتروني مطلوب.", subjectRequired: "الموضوع مطلوب.", messageRequired: "الرسالة مطلوبة.", invalidType: "نوع الرسالة غير صالح." },
        success: { report: "تم إرسال تقريرك بنجاح. يمكنك متابعة حالته في الأسفل.", message: "تم إرسال رسالتك بنجاح. يمكنك متابعة رد الإدارة في الأسفل." },
        errors: { failed: "فشل إرسال الرسالة." },
        track: { badge: "تتبع رسائلك", title: "سجّل الدخول لعرض سجل الدعم الخاص بك.", description: "سجّل الدخول لمراجعة رسائلك وتقاريرك وردود الإدارة وحالة الطلب.", loginButton: "تسجيل الدخول لتتبع الرسائل" },
      },
      contactStatus: {
        unknownDate: "تاريخ غير معروف", sentOn: "تم الإرسال في", repliedOn: "تم الرد في", edited: "تم التعديل", yourMessage: "رسالتك", adminReply: "رد الإدارة", noReply: "فريق ShoufBayt يراجع هذا الطلب. سيظهر الرد هنا.",
        type: { message: "رسالة", report: "تقرير" }, status: { new: "جديد", inReview: "قيد المراجعة", answered: "تم الرد" },
        guest: { badge: "تتبع الرسائل", title: "راجع تقاريرك ورسائلك", description: "سجّل الدخول لعرض رسائلك المرسلة وحالة التقارير وردود الإدارة.", button: "تسجيل الدخول لتتبع الرسائل" },
        user: { badge: "تتبع الرسائل", title: "تقاريرك ورسائلك", description: "يمكنك تعديل الطلب خلال ساعة من الإرسال. بعد رد الفريق يمكنك إزالته من التتبع." },
        states: { loading: "جارٍ تحميل رسائلك...", empty: "لم ترسل أي رسائل أو تقارير بعد." },
        actions: { delete: "إزالة", deleting: "جارٍ الإزالة...", clearAll: "مسح المُجاب عليها", clearing: "جارٍ المسح...", edit: "تعديل", save: "حفظ التغييرات", saving: "جارٍ الحفظ...", cancel: "إلغاء" },
        edit: { title: "تحديث طلبك", windowOpen: "نافذة التعديل: متبقّى {{time}}", windowClosed: "أُغلقت نافذة التعديل لمدة ساعة. هذه الرسالة مقفلة الآن.", lockedAfterReply: "هذا الطلب مقفل لأن الفريق قد رد عليه.", deleteHint: "الإزالة متاحة بعد رد الفريق." },
        confirms: { delete: "إزالة هذا الطلب المُجاب عليه من قائمة التتبع؟", clearAll: "إزالة كل الطلبات المُجاب عليها من التتبع؟ الطلبات التي تنتظر الرد ستبقى." },
        errors: { deleteFailed: "فشل إزالة هذا الطلب.", clearFailed: "فشل مسح الطلبات المُجاب عليها.", updateFailed: "فشل تحديث هذا الطلب.", deleteBlocked: "يبقى هذا الطلب في التتبع حتى يرد الفريق.", editBlocked: "لم يعد بالإمكان تعديل هذا الطلب." },
      },
      list: {
        hero: { badge: "الإعلانات", title: "عقارات للبيع والإيجار.", description: "فلتر حسب المدينة والميزانية والنوع — شقق وأراضٍ ومكاتب ومحلات وأكثر.", createListing: "إنشاء إعلان", requestListing: "أدرج عقاراً" },
        tabs: { all: "الكل", buy: "شراء", rent: "إيجار" },
        stats: { totalProperties: "إجمالي العقارات", available: "متاح", forSale: "للبيع", forRent: "للإيجار" },
        results: { propertyFound: "عقار واحد", propertiesFound: "{{count}} عقار", descriptionWithResults: "افتح الإعلان للصور والخريطة والتواصل.", descriptionEmpty: "جرّب مدينة أخرى أو امسح الفلاتر." },
        pagination: { prev: "السابق", next: "التالي", page: "صفحة {{page}} من {{pages}}" },
        empty: { title: "لا توجد عقارات", message: "لا يوجد ما يطابق هذا البحث بعد. جرّب مدينة أو سعراً أو نوع عقار آخر.", button: "مسح البحث" },
        map: { badge: "الخريطة", title: "على الخريطة", oneListing: "{{count}} إعلان", manyListings: "{{count}} إعلان", mapView: "خريطة", satellite: "قمر صناعي", emptyMessage: "لا توجد مواقع بعد. استخدم وضع القمر الصناعي لمعاينة المنطقة." },
      },
      listFilter: {
        header: { badge: "بحث", title: "اعثر على عقار.", description: "المدينة ونوع العقار أولاً. المزيد من الفلاتر عند الحاجة." },
        buttons: { resetFilters: "مسح", applyFilters: "عرض العقارات", moreFilters: "المزيد من الفلاتر", fewerFilters: "فلاتر أقل" },
        labels: { city: "المدينة / المنطقة", type: "نوع الإعلان", property: "العقار", keyword: "كلمة مفتاحية", bedrooms: "غرف النوم", bathrooms: "الحمامات", minPrice: "أقل سعر", maxPrice: "أعلى سعر", minSize: "أقل مساحة م²", maxSize: "أكبر مساحة م²", sort: "الترتيب", availability: "التوفر" },
        placeholders: { city: "بيروت، طرابلس، جبيل...", keyword: "العنوان أو الشارع" },
        options: { any: "أي", anyType: "أي نوع", rent: "إيجار", buy: "شراء", anyProperty: "أي عقار", apartment: "شقة", house: "منزل", land: "أرض", villa: "فيلا", office: "مكتب", shop: "محل", warehouse: "مستودع", building: "مبنى", sortNewest: "الأحدث", sortOldest: "الأقدم", sortPriceAsc: "السعر: من الأقل", sortPriceDesc: "السعر: من الأعلى", sortPopular: "الأكثر مشاهدة", anyListed: "كل المعروض", availableOnly: "المتاح فقط" },
        activeLabels: { city: "المدينة", type: "النوع", property: "العقار", q: "كلمة مفتاحية", bedroom: "غرف النوم", bathroom: "الحمامات", minPrice: "أقل سعر", maxPrice: "أعلى سعر", minSize: "أقل مساحة", maxSize: "أكبر مساحة", sort: "الترتيب", availability: "التوفر" },
        values: { type: { rent: "إيجار", buy: "شراء" }, property: { apartment: "شقة", house: "منزل", land: "أرض", villa: "فيلا", office: "مكتب", shop: "محل", warehouse: "مستودع", building: "مبنى" }, sort: { newest: "الأحدث", oldest: "الأقدم", price_asc: "السعر ↑", price_desc: "السعر ↓", popular: "الأكثر مشاهدة" }, availability: { available: "متاح" } },
      },
      card: {
        fallback: { untitled: "عقار بدون عنوان", unknownCity: "مدينة غير معروفة", noAddress: "لا يوجد عنوان متاح" },
        labels: { forRent: "للإيجار", forSale: "للبيع", property: "عقار", price: "السعر" },
        propertyTypes: { apartment: "شقة", house: "منزل", land: "أرض", villa: "فيلا", office: "مكتب", shop: "محل", warehouse: "مستودع", building: "مبنى" },
        status: { sold: "تم البيع", rented: "تم التأجير" },
        messages: { sold: "تم بيع هذا العقار بالفعل.", rented: "تم تأجير هذا العقار بالفعل." },
        features: { bedrooms: "غرف نوم", bathrooms: "حمامات", garage: "كراج", area: "م²" },
        buttons: { viewDetails: "عرض التفاصيل" },
        titles: { removeSaved: "إزالة من المحفوظات", saveProperty: "حفظ العقار", sendMessage: "إرسال رسالة", callAgent: "اتصل بالوكيل" },
        alerts: { saveFailed: "فشل حفظ العقار.", ownerNotFound: "لا يمكن العثور على مالك هذا العقار.", cannotMessageYourself: "لا يمكنك إرسال رسالة إلى نفسك.", chatFailed: "فشل فتح المحادثة." },
      },
      pageState: { loading: { title: "جارٍ التحميل...", message: "يرجى الانتظار بينما يقوم ShoufBayt بتجهيز البيانات." }, error: { title: "حدث خطأ ما", message: "لم نتمكن من إكمال هذا الطلب. يرجى المحاولة مرة أخرى." }, empty: { title: "لا توجد بيانات", message: "لا يوجد شيء لعرضه حالياً." } },
      pageLoader: { label: "ShoufBayt" },
      statusBadge: { available: "متاح", sold: "تم البيع", rented: "تم التأجير", pending: "قيد المراجعة", rejected: "غير موافق عليه" },
      reviews: {
        propertyTitle: "التقييمات",
        agentTitle: "التقييمات",
        count: "{{count}} تقييمات",
        leave: "اترك تقييماً",
        placeholder: "اكتب تقييماً مختصراً",
        submit: "نشر",
        save: "حفظ",
        sending: "…",
        login: "سجّل الدخول لترك تقييم.",
        empty: "لا توجد تقييمات بعد.",
        loading: "جارٍ التحميل…",
        thanks: "تم الحفظ.",
        already: "لقد تركت تقييماً مسبقاً. عدّله أو اقرأ تقييمات الآخرين.",
        yours: "تقييمك",
        edit: "تعديل",
        cancel: "إلغاء",
        loginError: "يرجى تسجيل الدخول أولاً.",
        loadFailed: "تعذر تحميل التقييمات.",
        submitFailed: "تعذر نشر التقييم.",
        updateFailed: "تعذر تحديث التقييم.",
        deleteFailed: "تعذر حذف التقييم.",
        delete: "حذف",
      },
      single: {
        notFound: { title: "لم يتم العثور على العقار", message: "ربما تم حذف هذا العقار أو لم يعد متاحاً.", button: "العودة إلى العقارات" },
        nav: { backToProperties: "العودة إلى العقارات", editProperty: "تعديل العقار" },
        labels: { forRent: "للإيجار", forSale: "للبيع", rent: "إيجار", sale: "بيع", property: "عقار" },
        propertyTypes: { apartment: "شقة", house: "منزل", land: "أرض", villa: "فيلا", office: "مكتب", shop: "محل", warehouse: "مستودع", building: "مبنى" },
        fallback: { noTitle: "بدون عنوان", noAddress: "لا يوجد عنوان متاح", noDescription: "لا يوجد وصف متاح.", noLocation: "لا يوجد موقع متاح", unknownCity: "مدينة غير معروفة", unknownUser: "مستخدم غير معروف", unknown: "غير معروف" },
        features: { totalSize: "المساحة الكلية", bedrooms: "غرف نوم", bathrooms: "حمامات", garage: "كراج", areaUnit: "م²" },
        summary: { propertyPrice: "سعر العقار", chatHint: "تواصل مع الوكيل. يتم تضمين مالك العقار في المحادثة تلقائياً." },
        unavailable: { sold: "تم بيع هذا العقار.", rented: "تم تأجير هذا العقار." },
        buttons: { propertySold: "تم بيع العقار", propertyRented: "تم تأجير العقار", openingChat: "جارٍ فتح المحادثة...", contactOwner: "تواصل مع الوكيل", call: "اتصل بالوكيل", callAgent: "اتصل بالوكيل", callOwner: "اتصل بالمالك", saved: "محفوظ", save: "حفظ" },
        sections: { overview: "نظرة عامة", propertyDescription: "وصف العقار", features: "المميزات", propertyDetails: "تفاصيل العقار", location: "الموقع", propertyLocation: "موقع العقار" },
        info: { summary: "الملخص", type: "النوع", category: "الفئة", status: "الحالة", city: "المدينة" },
        report: "الإبلاغ عن الإعلان",
        verification: {
          badge: "للمسؤول فقط",
          title: "صور التحقق",
          description: "إثبات ملكية وإفادة عقارية. مخفيتان عن صفحة الإعلان العامة.",
        },
        owner: { listedBy: "تم النشر بواسطة", listingAgent: "الوكيل العقاري", propertyOwner: "الوكيل العقاري", description: "تتم إدارة هذا الإعلان بواسطة الوكيل العقاري. التواصل يرسل الرسالة إلى الوكيل ومالك العقار.", inquiry: "استفسار", directChat: "محادثة مباشرة", property: "العقار", location: "الموقع", agentProfile: "عرض ملف الوكيل" },
        alerts: { saveFailed: "فشل حفظ العقار.", alreadySold: "تم بيع هذا العقار بالفعل.", alreadyRented: "تم تأجير هذا العقار بالفعل.", ownerNotFound: "لا يمكن العثور على الوكيل المسؤول عن هذا العقار.", cannotMessageYourself: "لا يمكنك إرسال رسالة إلى نفسك.", chatFailed: "فشل بدء المحادثة.", notAllowedEdit: "غير مسموح لك بتعديل هذا العقار." },
        chatMessage: { greeting: "مرحباً، أنا مهتم بهذا العقار.", heading: "استفسار عن عقار", title: "العنوان", price: "السعر", deal: "نوع الصفقة", category: "الفئة", city: "المدينة", address: "العنوان", bedrooms: "غرف النوم", bathrooms: "الحمامات", size: "المساحة", status: "الحالة", propertyLink: "رابط العقار", closing: "يرجى إعلامي إذا كان هذا العقار لا يزال متاحاً." },
      },
      recommended: { header: { badge: "في هذه المدينة", title: "عقارات مقترحة", description: "إعلانات أخرى متاحة في المدينة نفسها، للبيع أو للإيجار حسب هذا الإعلان." }, loading: { title: "جارٍ تحميل التوصيات", message: "يرجى الانتظار بينما نبحث عن عقارات مشابهة." }, errorState: { title: "التوصيات غير متاحة" }, empty: { title: "لا توجد توصيات بعد", message: "لا توجد عقارات متاحة أخرى في هذه المدينة لنفس نوع البيع أو الإيجار." }, errors: { failed: "فشل تحميل العقارات المقترحة." } },
      slider: { badges: { paused: "تم إيقاف المعرض", auto: "معرض تلقائي", gallery: "معرض العقار" }, alt: { propertyPreview: "معاينة العقار", mainProperty: "العقار الرئيسي", propertyNumber: "العقار {{number}}" } },
      login: {
        login: { badge: "مرحباً بعودتك", title: "تسجيل الدخول إلى ShoufBayt", description: "سجّل الدخول بأمان لإدارة عقاراتك والمحفوظات والرسائل والملف الشخصي.", noAccount: "ليس لديك حساب؟", createAccount: "إنشاء حساب", forgotPassword: "نسيت كلمة المرور؟" },
        verify: { badge: "فحص أمني", title: "تحقق من تسجيل الدخول", description: "أرسلنا رمز تحقق مكوّن من 6 أرقام إلى:", digitLabel: "رقم التحقق {{number}}", spamHint: "إذا لم يصلك البريد، يرجى التحقق من مجلد الرسائل غير المرغوب فيها. ينتهي الرمز خلال 10 دقائق." },
        form: { email: "البريد الإلكتروني", password: "كلمة المرور", emailPlaceholder: "أدخل بريدك الإلكتروني", passwordPlaceholder: "أدخل كلمة المرور", show: "إظهار", hide: "إخفاء" },
        buttons: { checking: "جارٍ التحقق...", continue: "متابعة", verifying: "جارٍ التحقق...", verifyCode: "تحقق من الرمز", sending: "جارٍ الإرسال...", resendIn: "إعادة إرسال الرمز خلال {{seconds}}ث", resendCode: "إعادة إرسال الرمز", changeCredentials: "تغيير البريد الإلكتروني أو كلمة المرور" },
        validation: { emailRequired: "البريد الإلكتروني مطلوب.", emailInvalid: "يرجى إدخال بريد إلكتروني صالح.", passwordRequired: "كلمة المرور مطلوبة.", emailMissing: "البريد الإلكتروني مفقود. يرجى تسجيل الدخول مرة أخرى.", codeRequired: "يرجى إدخال رمز التحقق المكوّن من 6 أرقام." },
        success: { codeSent: "تم إرسال رمز التحقق إلى بريدك الإلكتروني.", newCodeSent: "تم إرسال رمز جديد." },
        errors: { loginFailed: "فشل تسجيل الدخول.", invalidCode: "رمز التحقق غير صالح.", resendFailed: "فشل إعادة إرسال الرمز.", idle: "كنت بعيداً لمدة ساعة، لذلك تم تسجيل خروجك. يرجى تسجيل الدخول مرة أخرى.", sessionExpired: "انتهت جلستك. يرجى تسجيل الدخول مرة أخرى." },
        visual: {
          title: "اعثر على العقارات واحفظها وأدرها بثقة.",
          description: "منصة عقارية حديثة مصممة للمشترين والمستأجرين والوكلاء ومالكي العقارات.",
          journeyDiscover: "اكتشف",
          journeyShortlist: "اختَر",
          journeyMove: "انتقل",
          showcaseDiscoverTitle: "عقارات تناسبك",
          showcaseDiscoverText: "ابحث حسب المدينة والنوع والميزانية بلا ضوضاء.",
          showcaseConnectTitle: "تحدث قبل الزيارة",
          showcaseConnectText: "راسل المالك أو الوكيل مباشرة من الإعلان.",
          showcaseSaveTitle: "قائمة مختصرة خاصة",
          showcaseSaveText: "احفظ العقارات وعد إليها عندما تكون جاهزاً.",
          chipBuy: "شراء",
          chipRent: "إيجار",
          chipBeirut: "بيروت",
          chipApartments: "شقق",
          chipVillas: "فلل",
          secureLogin: "دخول آمن",
          securityText: "يساعد التحقق عبر البريد وتسجيل الدخول بجوجل على حماية حسابك.",
        },
      },
      forgotPassword: {
        email: {
          badge: "استعادة الحساب",
          title: "نسيت كلمة المرور؟",
          description: "أدخل بريدك الإلكتروني وسنرسل رمز تحقق مكوّن من 6 أرقام لإعادة تعيين كلمة المرور.",
          remember: "تذكرتها؟",
          backToLogin: "العودة لتسجيل الدخول",
        },
        verify: {
          badge: "تأكيد البريد",
          title: "أدخل رمز التحقق",
          description: "أرسلنا رمز إعادة التعيين إلى:",
          digitLabel: "رقم الرمز {{digit}}",
          spamHint: "تحقق من الوارد والرسائل غير المرغوب فيها. ينتهي الرمز خلال 10 دقائق.",
        },
        reset: {
          badge: "كلمة مرور جديدة",
          title: "أنشئ كلمة مرور جديدة",
          description: "اختر كلمة مرور قوية لحسابك في ShoufBayt.",
        },
        form: {
          email: "البريد الإلكتروني",
          emailPlaceholder: "أدخل بريدك الإلكتروني",
          newPassword: "كلمة المرور الجديدة",
          confirmPassword: "تأكيد كلمة المرور",
          passwordPlaceholder: "أنشئ كلمة مرور جديدة",
          confirmPlaceholder: "أكد كلمة المرور الجديدة",
          show: "إظهار",
          hide: "إخفاء",
        },
        buttons: {
          sending: "جارٍ الإرسال...",
          sendCode: "إرسال الرمز",
          verifying: "جارٍ التحقق...",
          verifyCode: "تحقق من الرمز",
          resendIn: "إعادة الإرسال خلال {{seconds}}ث",
          resendCode: "إعادة إرسال الرمز",
          changeEmail: "تغيير البريد",
          saving: "جارٍ الحفظ...",
          resetPassword: "إعادة تعيين كلمة المرور",
        },
        validation: {
          emailRequired: "البريد الإلكتروني مطلوب.",
          emailInvalid: "يرجى إدخال بريد إلكتروني صالح.",
          codeRequired: "يرجى إدخال رمز التحقق المكوّن من 6 أرقام.",
          passwordWeak:
            "يجب أن تتضمن كلمة المرور أحرفًا كبيرة وصغيرة ورقمًا ورمزًا خاصًا (6 على الأقل).",
          passwordMismatch: "كلمتا المرور غير متطابقتين.",
        },
        success: {
          codeSent: "تم إرسال رمز التحقق إلى بريدك الإلكتروني.",
          newCodeSent: "تم إرسال رمز تحقق جديد.",
          codeVerified: "تم التحقق من الرمز. يمكنك تعيين كلمة مرور جديدة.",
          resetDone: "تم تحديث كلمة المرور. جارٍ التحويل لتسجيل الدخول…",
        },
        errors: {
          requestFailed: "فشل إرسال رمز إعادة التعيين.",
          emailNotFound: "لا يوجد حساب مرتبط بهذا البريد الإلكتروني.",
          invalidCode: "رمز التحقق غير صالح.",
          resendFailed: "فشل إعادة إرسال الرمز.",
          sessionExpired: "انتهت جلسة إعادة التعيين. يرجى البدء من جديد.",
          resetFailed: "فشل إعادة تعيين كلمة المرور.",
        },
        visual: {
          title: "استعد الوصول بخطوات آمنة.",
          description:
            "أكد بريدك برمز لمرة واحدة، ثم اختر كلمة مرور جديدة لحسابك.",
          journeyEmail: "البريد",
          journeyCode: "تحقق",
          journeyPassword: "تعيين",
          showcaseSafeTitle: "استعادة محمية",
          showcaseSafeText: "لا يمكن تغيير كلمة المرور إلا من خلال بريدك.",
          showcaseKeyTitle: "بداية جديدة",
          showcaseKeyText: "عيّن كلمة مرور جديدة وعد إلى إعلاناتك.",
          secureTitle: "استعادة آمنة",
          secureText: "تنتهي صلاحية رموز إعادة التعيين خلال 10 دقائق وتُستخدم مرة واحدة فقط.",
        },
      },
      register: {
        header: { badge: "إنشاء حساب", title: "انضم إلى ShoufBayt", description: "أنشئ حسابك لنشر العقارات وحفظ المفضلة ومراسلة المستخدمين وإدارة نشاطك العقاري." },
        form: { username: "اسم المستخدم", email: "البريد الإلكتروني", password: "كلمة المرور", confirmPassword: "تأكيد كلمة المرور", usernamePlaceholder: "أدخل اسم المستخدم", emailPlaceholder: "أدخل بريدك الإلكتروني", passwordPlaceholder: "أنشئ كلمة مرور", confirmPasswordPlaceholder: "أكد كلمة المرور", show: "إظهار", hide: "إخفاء" },
        passwordStrength: { title: "قوة كلمة المرور" }, strength: { weak: "ضعيفة", medium: "متوسطة", strong: "قوية" },
        requirements: { title: "متطلبات كلمة المرور", length: "على الأقل 6 أحرف", uppercase: "حرف كبير واحد على الأقل", lowercase: "حرف صغير واحد على الأقل", number: "رقم واحد على الأقل", special: "رمز خاص واحد على الأقل", match: "كلمتا المرور متطابقتان" },
        validation: { usernameRequired: "اسم المستخدم مطلوب.", usernameLength: "يجب أن يكون اسم المستخدم 3 أحرف على الأقل.", emailRequired: "البريد الإلكتروني مطلوب.", emailInvalid: "يرجى إدخال بريد إلكتروني صالح.", passwordFieldsRequired: "يرجى تعبئة حقلي كلمة المرور.", passwordRequirements: "يرجى إكمال جميع متطلبات كلمة المرور." },
        errors: { failed: "فشل إنشاء الحساب.", useGoogle: "هذا البريد مرتبط بحساب Google. استخدم متابعة مع Google." }, buttons: { creating: "جارٍ إنشاء الحساب...", createAccount: "إنشاء حساب" }, footer: { alreadyHaveAccount: "لديك حساب بالفعل؟", signIn: "تسجيل الدخول" },
        visual: {
          title: "ابدأ رحلتك العقارية باحترافية.",
          description: "أنشئ حساباً للوصول إلى نشر العقارات والمحفوظات والرسائل وإدارة الملف الشخصي وأدوات العقارات الذكية.",
          journeyCreate: "أنشئ",
          journeyList: "أعلن",
          journeyGrow: "نمُ",
          showcasePostTitle: "انشر بوضوح",
          showcasePostText: "أضف الصور والتفاصيل والموقع في مسار واحد.",
          showcaseSaveTitle: "تابع ما يعجبك",
          showcaseSaveText: "ابنِ قائمة مختصرة بينما تقارن الخيارات.",
          showcaseMessageTitle: "تواصل أسرع",
          showcaseMessageText: "راسل الملاك والمشترين والوكلاء من مكان واحد.",
          chipOwners: "ملاك",
          chipBuyers: "مشترون",
          chipRenters: "مستأجرون",
          chipAgents: "وكلاء",
        },
      },
      verifyPhone: {
        badge: "رقم الهاتف",
        title: "أضف رقم هاتفك",
        text: "المستخدمون والوكلاء يضيفون الرقم مرة واحدة حتى يتمكن المشترون من الاتصال من الإعلان.",
        changeTitle: "غيّر رقم هاتفك",
        changeText: "أدخل الرقم الجديد. سيتم حفظه على حسابك مباشرة.",
        phoneLabel: "رقم الهاتف",
        phonePlaceholder: "71123456",
        phoneHint: "اختر مفتاح الدولة ثم أدخل الرقم المحلي فقط.",
        save: "حفظ الرقم",
        saving: "جارٍ الحفظ...",
        success: {
          saved: "تم حفظ رقم الهاتف.",
        },
        errors: {
          invalidPhone: "أدخل عدد الأرقام المطلوب لهذه الدولة دون مفتاح الدولة.",
          phoneTaken: "رقم الهاتف هذا مستخدم على حساب آخر.",
          saveFailed: "تعذر حفظ رقم الهاتف.",
        },
        visual: {
          title: "رقم يمكن للمشترين الاتصال به.",
          text: "أضفه مرة واحدة. يمكنك تغييره لاحقاً من ملفك.",
        },
      },
      phoneField: {
        countryLabel: "مفتاح الدولة",
        searchCountry: "ابحث عن الدولة أو المفتاح",
        numberPlaceholder: "الرقم المحلي",
        digitsHint: "أدخل {{count}} أرقام دون مفتاح الدولة.",
        digitsRangeHint: "أدخل من {{min}} إلى {{max}} أرقام دون مفتاح الدولة.",
        errors: {
          invalid: "أدخل عدد الأرقام المطلوب للدولة المختارة دون مفتاح الدولة.",
        },
      },
      profile: {
        fallback: { user: "المستخدم", noEmail: "لا يوجد بريد إلكتروني" }, loading: { title: "جارٍ تحميل الملف الشخصي", message: "يرجى الانتظار بينما نقوم بتجهيز معلومات حسابك." }, hero: { badge: "حسابي", updateProfile: "تعديل الحساب", editAgentCard: "تعديل البطاقة العامة", logout: "تسجيل الخروج" },
        role: { owner: "مالك", agent: "وكيل", admin: "مسؤول" },
        fields: { name: "الاسم", email: "البريد", manageBilling: "إدارة" },
        stats: { myPosts: "منشوراتي", myPostsText: "العقارات التي أنشأتها", savedPosts: "العقارات المحفوظة", savedPostsText: "عقاراتك المفضلة", accountRole: "دور الحساب", accountRoleText: "صلاحيتك الحالية", fallbackTitle: "الإحصائيات", fallbackText: "فشل تحميل إحصائيات الملف الشخصي" },
        dashboard: { badge: "الحساب", title: "عقاراتك", description: "إعلاناتك والعقارات التي حفظتها.", addNewProperty: "إضافة إعلان", requestListing: "أدرج عقاراً" }, tabs: { myPosts: "عقاراتي", savedPosts: "المحفوظات", requests: "العروض" },
        requests: { loading: "جارٍ تحميل العروض…", emptyTitle: "لا توجد عروض بعد", emptyText: "أدرج عقاراً وسيظهر عروض الوكلاء هنا.", pickTitle: "اختر وكيلاً", dashboardHint: "العروض والزيارات وإعلاناتك.", notifiedAgents: "الوكلاء المُبلَّغون: {{count}}", proposalsCount: "{{count}} عروض", proposalMeta: "{{percent}}% عمولة · ~{{days}} أيام · {{status}}", commission: "{{percent}}% عمولة", days: "حوالي {{count}} أيام", agent: "وكيل", verified: "موثوق", viewAgent: "عرض الملف", accept: "قبول", reject: "رفض", chooseAgent: "قبول", working: "يرجى الانتظار…", openListing: "فتح الإعلان", cancel: "إلغاء الطلب", stateWaiting: "بانتظار", stateChoose: "اختر واحداً", stateDone: "تم", waitingHint: "سيظهر الوكلاء هنا. سيصلك تنبيه أيضاً.", confirms: { cancel: "هل تريد إلغاء طلب الإعلان هذا؟", accept: "هل تريد اختيار {{name}} لإدراج «{{title}}»؟", reject: "هل تريد رفض عرض {{name}} لـ «{{title}}»؟" }, dialog: { acceptTitle: "توظيف هذا الوكيل؟", rejectTitle: "رفض هذا العرض؟", cancelTitle: "إلغاء هذا الطلب؟", acceptText: "سيتولى {{name}} إدراج «{{title}}». سيتم إغلاق العروض الأخرى.", rejectText: "سيتم رفض عرض {{name}} لـ «{{title}}». يمكنك اختيار وكيل آخر.", cancelText: "سيتوقف استلام العروض لـ «{{title}}».", back: "رجوع", confirmAccept: "توظيف الوكيل", confirmReject: "رفض العرض", confirmCancel: "إلغاء الطلب", close: "إغلاق" }, success: { accepted: "تم. سيتولى هذا الوكيل إدراج العقار.", rejected: "تم رفض العرض." }, errors: { load: "تعذر تحميل العروض.", accept: "تعذر قبول هذا العرض.", reject: "تعذر رفض هذا العرض.", cancel: "تعذر الإلغاء." } },
        errors: { loadProperties: "فشل تحميل عقاراتك." },
        messages: { badge: "صندوق الوارد", title: "الرسائل", viewAll: "عرض الكل", loading: "جارٍ تحميل الرسائل...", failed: "فشل تحميل الرسائل.", noMessages: "لا توجد رسائل", noMessagesText: "ستظهر محادثاتك هنا.", noMessageYet: "لا توجد رسالة بعد" },
        shortcuts: { badge: "اختصارات", title: "إجراءات سريعة", browseProperties: "تصفح العقارات", findAgents: "العثور على وكلاء", contactSupport: "تواصل مع الدعم", requestListing: "طلب إعلان", ownerDashboard: "لوحة المالك", agentDashboard: "لوحة الوكيل" },
        empty: { title: "لم يتم العثور على عقارات", noMyPosts: "لم تقم بإضافة أي عقار بعد.", noMyPostsOwner: "لا توجد عقارات مدرجة لك بعد. اطلب إعلاناً واختر وكيلاً.", noSavedPosts: "لم تقم بحفظ أي عقار بعد.", createFirst: "أنشئ أول عقار لك", requestFirst: "اطلب أول إعلان لك", exploreProperties: "استكشف العقارات" },
        delete: { badge: "تأكيد الإجراء", title: "حذف العقار؟", question: "هل أنت متأكد أنك تريد حذف", thisProperty: "هذا العقار", cancel: "إلغاء", delete: "حذف", deleting: "جارٍ الحذف...", cannotFind: "تعذر العثور على هذا العقار.", failed: "فشل حذف العقار." }, alerts: { logoutFailed: "فشل تسجيل الخروج." },
      },
      profilePostCard: { fallback: { untitled: "عقار بدون عنوان", noAddress: "لا يوجد عنوان" }, status: { available: "متاح", rented: "تم التأجير", sold: "تم البيع", pending: "قيد المراجعة", rejected: "غير موافق عليه" }, labels: { propertyStatus: "حالة العقار", changeStatus: "تغيير الحالة", updating: "جارٍ التحديث...", pendingNote: "بانتظار موافقة الإدارة. الإعلان غير ظاهر للعامة بعد.", agentManagedNote: "وكيلك يدير حالة الإعلان. يمكنك عرض التفاصيل وتعديلها." }, features: { bedroom: "غرفة نوم", bathroom: "حمام" }, managedBy: "يديره {{name}}", managedByAgency: "يديره {{name}} · {{agency}}", viewAgent: "عرض الوكيل", buttons: { viewDetails: "عرض التفاصيل", editProperty: "تعديل العقار", delete: "حذف" }, alt: { location: "الموقع", bedroom: "غرفة النوم", bathroom: "الحمام" }, alerts: { updateFailed: "فشل تحديث الحالة." } },
      profileUpdate: {
        fallback: { user: "المستخدم", noEmail: "لا يوجد بريد إلكتروني" }, loading: { title: "جارٍ تحميل الملف الشخصي", message: "يرجى الانتظار بينما نقوم بتجهيز معلومات حسابك." },         header: { badge: "إعدادات الحساب", title: "تحديث ملفك الشخصي في ShoufBayt.", description: "أدر اسم المستخدم والبريد الإلكتروني ورقم الهاتف وكلمة المرور وصورة الملف الشخصي من صفحة إعدادات حساب منظمة.", backToProfile: "العودة إلى الملف الشخصي" },
        formHeader: { badge: "تفاصيل الملف الشخصي", title: "المعلومات الشخصية", description: "يمكنك تغيير اسم المستخدم أو البريد الإلكتروني وحدهما. رقم الهاتف اختياري هنا إلا إذا أردت إضافته أو تغييره. اترك كلمة المرور فارغة إذا كنت لا تريد تغييرها." },
        form: { username: "اسم المستخدم", email: "البريد الإلكتروني", phone: "رقم الهاتف", newPassword: "كلمة مرور جديدة", confirmPassword: "تأكيد كلمة المرور", usernamePlaceholder: "أدخل اسم المستخدم", emailPlaceholder: "أدخل بريدك الإلكتروني", phonePlaceholder: "+961 71 123 456", phoneHelp: "اختياري. يمكن للمشترين الضغط على اتصال من إعلانك بعد حفظ هذا الرقم. يمكنك تخطيه عند تغيير الاسم أو البريد فقط.", noPhone: "لا يوجد رقم بعد", addPhone: "أضف رقم الهاتف", changePhone: "تغيير الرقم", passwordPlaceholder: "اتركه فارغاً للاحتفاظ بكلمة المرور القديمة", confirmPasswordPlaceholder: "أكد كلمة المرور الجديدة", show: "إظهار", hide: "إخفاء", passwordHelp: "أدخل كلمة مرور فقط إذا كنت تريد تغييرها. يجب أن تتضمن حرفاً كبيراً وصغيراً ورقماً ورمزاً خاصاً (الحد الأدنى 6 أحرف)." },
        avatar: { badge: "صورة الملف الشخصي", title: "صورة الحساب", description: "قم بتحميل صورة واضحة للملف الشخصي. تظهر هذه الصورة في ملفك الشخصي والإعلانات وصفحة الوكلاء والرسائل.", alt: "الملف الشخصي", chooseImage: "اختيار صورة", reset: "إعادة تعيين", accepted: "المقبول: JPG, PNG, WEBP", maxSize: "الحجم الأقصى: 5MB" },
        account: { title: "الحساب الحالي", username: "اسم المستخدم", email: "البريد الإلكتروني", role: "الدور" }, buttons: { updating: "جارٍ التحديث...", updateProfile: "تحديث الملف الشخصي", cancel: "إلغاء" },
        validation: { validImage: "يرجى اختيار ملف صورة صالح.", imageSize: "يجب أن يكون حجم الصورة أقل من 5MB.", usernameRequired: "اسم المستخدم مطلوب.", emailRequired: "البريد الإلكتروني مطلوب.", emailInvalid: "يرجى إدخال بريد إلكتروني صالح.", phoneInvalid: "أدخل رقم هاتف صالح.", phoneTaken: "رقم الهاتف هذا مستخدم على حساب آخر.", usernameTaken: "اسم المستخدم هذا مستخدم بالفعل.", emailTaken: "البريد الإلكتروني هذا مستخدم على حساب آخر.", passwordRequirements: "يرجى إكمال جميع متطلبات كلمة المرور.", passwordMismatch: "كلمتا المرور غير متطابقتين.", userNotFound: "تعذر العثور على حساب المستخدم الخاص بك." },         success: { updated: "تم تحديث الملف الشخصي بنجاح." }, errors: { failed: "فشل تحديث الملف الشخصي." },
        verify: {
          badge: "تأكيد البريد",
          title: "أكد بريدك الإلكتروني الجديد.",
          description: "أرسلنا رمزاً من 6 أرقام إلى",
          spamHint: "تحقق من البريد غير المرغوب إذا لم يصل. يبقى بريدك الحالي فعالاً حتى تدخل الرمز.",
          digitLabel: "الرقم {{number}}",
          verifyCode: "تأكيد البريد",
          verifying: "جارٍ التأكيد...",
          resend: "إعادة إرسال الرمز",
          resendIn: "إعادة الإرسال خلال {{seconds}} ث",
          keepCurrent: "الإبقاء على البريد الحالي",
          backToForm: "العودة إلى التفاصيل",
          codeRequired: "أدخل الرمز المكوّن من 6 أرقام.",
          codeSent: "تم إرسال رمز التأكيد إلى بريدك الجديد.",
          verified: "تم تحديث بريدك الإلكتروني.",
          cancelled: "تم إلغاء تغيير البريد. بريدك الحالي لم يتغير.",
          verifyFailed: "تعذر التحقق من هذا الرمز.",
          resendFailed: "تعذر إعادة إرسال الرمز.",
          cancelFailed: "تعذر إلغاء تغيير البريد.",
        },
      },
      newPost: {
        hero: {
          badge: "إنشاء إعلان",
          title: "انشر عقاراً.",
          description: "أضف التفاصيل والصور ودبوس الخريطة. راجع مرة واحدة ثم انشر.",
          myListings: "إعلاناتي",
        },
        stats: {
          brief: "إعلانك",
          briefValue: "التفاصيل والصور والموقع",
          review: "المراجعة",
          reviewValue: "تحقق قبل النشر",
          live: "منشور",
          liveValue: "ظاهر على ShoufBayt",
        },
        steps: { details: "تفاصيل العقار", confirm: "تأكيد ونشر" },
        details: {
          badge: "التفاصيل",
          title: "معلومات العقار",
          description: "الحقائق التي سيراها المشترون والمستأجرون في الإعلان.",
        },
        form: {
          title: "العنوان",
          price: "السعر ($)",
          city: "المدينة",
          address: "العنوان",
          listingType: "نوع الإعلان",
          category: "الفئة",
          bedrooms: "غرف النوم",
          bathrooms: "الحمامات",
          garage: "كراج",
          size: "المساحة (م²)",
          description: "الوصف",
          titlePlaceholder: "شقة حديثة في زحلة",
          cityPlaceholder: "مثال: زحلة",
          addressPlaceholder: "الشارع، المبنى، المنطقة",
          descriptionPlaceholder: "صف العقار والتشطيبات والحي ونقاط البيع…",
          landLocked: "غير مستخدم للأراضي",
          buildingLocked: "غير مستخدم للمباني",
        },
        options: {
          sale: "بيع",
          rent: "إيجار",
          apartment: "شقة",
          house: "منزل",
          villa: "فيلا",
          land: "أرض",
          office: "مكتب",
          shop: "محل",
          building: "مبنى",
        },
        location: {
          badge: "الموقع",
          title: "ثبّت موقع العقار",
          description: "انقر على الخريطة، أو استخدم موقعك الحالي، أو الصق عنواناً أو رابط خرائط غوغل، أو ارفع صورة تحتوي على الموقع.",
          locating: "جارٍ تحديد الموقع…",
          useMyLocation: "استخدم موقعي",
          lat: "خط العرض",
          lng: "خط الطول",
          popup: "موقع العقار المحدد",
          pinSet: "تم تثبيت الموقع",
          clickHint: "انقر على الخريطة لوضع الدبوس.",
        },
        media: {
          badge: "الوسائط",
          title: "صور العقار",
          description: "الصور الواضحة تساعد الناس على القرار. صورة واحدة على الأقل مطلوبة.",
          upload: "انقر لرفع الصور",
          hint: "JPG أو PNG أو WEBP · حتى 20 صورة · 20MB للصورة",
          remove: "إزالة",
        },
        verification: {
          badge: "التحقق",
          title: "صورتان خاصتان للإثبات",
          userDescription: "ارفع صورة إثبات ملكية وإفادة عقارية. يراجعها المسؤول قبل ظهور الإعلان. لن تظهر في الصفحة العامة.",
          agentDescription: "ارفع صورة إثبات ملكية وإفادة عقارية. يمكن للوكيل النشر دون انتظار موافقة. تبقى الصور خاصة للمسؤول.",
          upload: "أضف إثبات ملكية وإفادة عقارية",
          hint: "JPG أو PNG أو WEBP · صورتان · ملكية + إفادة عقارية · للمسؤول فقط",
        },
        confirm: {
          badge: "جاهز",
          title: "راجع قبل النشر",
          description: "سيظهر هذا العقار من نوع {{property}} في {{city}} عند النشر.",
          yourArea: "منطقتك",
          deal: "الصفقة",
          layout: "التوزيع",
          bedsBaths: "{{beds}} غرف · {{baths}} حمامات",
        },
        done: {
          badge: "تم النشر",
          title: "الإعلان ظاهر الآن",
          description: "عقارك أصبح على ShoufBayt. افتحه للتحقق من الصور والخريطة والتواصل.",
        },
        actions: {
          continue: "متابعة",
          cancel: "إلغاء",
          submit: "نشر الإعلان",
          submitting: "جارٍ النشر…",
          back: "العودة للتعديل",
          viewListing: "عرض الإعلان",
          home: "الرئيسية",
        },
        validation: {
          requiredFields: "العنوان والعنوان التفصيلي والمدينة مطلوبة.",
          price: "أدخل سعراً صالحاً.",
          bedrooms: "أدخل عدد غرف النوم.",
          bathrooms: "أدخل عدد الحمامات.",
          garage: "أدخل عدد الكراجات.",
          description: "يجب أن يكون الوصف 20 حرفاً على الأقل.",
          location: "حدّد موقعاً على الخريطة.",
          images: "أضف صورة واحدة على الأقل.",
          verificationImages: "ارفع صورة إثبات ملكية وإفادة عقارية.",
          locationNotSupported: "تحديد الموقع غير مدعوم على هذا الجهاز.",
          locationFailed: "تعذر الحصول على موقعك.",
        },
        success: { added: "تمت إضافة العقار بنجاح." },
        errors: {
          addFailed: "فشل إضافة العقار.",
          apiOffline:
            "تعذر الوصول إلى الخادم. شغّل واجهة الـ API على المنفذ 8800 ثم أعد المحاولة.",
        },
        moderation: {
          badge: "أدرج بنفسك",
          title: "أدرج هذا العقار بنفسك.",
          description: "أضف التفاصيل والصور ودبوس الخريطة. إعلانك الذاتي الأول مجاني. يراجعه مسؤول قبل أن يظهر على شوف بيت.",
          review: "مراجعة الإدارة",
          reviewValue: "مطلوبة قبل الظهور",
          live: "يظهر للعامة",
          liveValue: "بعد الموافقة",
          confirmStep: "تأكيد وإرسال",
          confirmTitle: "راجع قبل الإرسال",
          confirmDescription: "سيبقى هذا العقار من نوع {{property}} في {{city}} بانتظار موافقة الإدارة. لن يكون عاماً حتى ذلك الحين.",
          submit: "إرسال للمراجعة",
          submitting: "جارٍ الإرسال…",
          doneBadge: "قيد المراجعة",
          doneTitle: "بانتظار موافقة الإدارة",
          doneDescription: "تم حفظ إعلانك وسيبقى خاصاً حتى توافق الإدارة. سيتم إشعارك.",
          success: "تم إرسال الإعلان للمراجعة.",
          switchPath: "تفضّل وكيلاً؟",
        },
      },
      editPost: {
        loading: { title: "جارٍ تحميل العقار", message: "يرجى الانتظار بينما نقوم بتحميل معلومات العقار." }, loadError: { title: "تعذر تحميل العقار", backToProfile: "العودة إلى الملف الشخصي" }, header: { badge: "تعديل العقار", title: "تحديث تفاصيل العقار.", description: "حدّث المعلومات والصور والوصف وموقع الخريطة الخاص بإعلانك.", viewProperty: "عرض العقار" }, main: { badge: "المعلومات الرئيسية", title: "تفاصيل العقار", description: "حدّث المعلومات الرئيسية التي يراها المستخدمون في إعلانك." }, form: { title: "العنوان", price: "السعر", city: "المدينة", address: "العنوان", bedrooms: "غرف النوم", bathrooms: "الحمامات", size: "المساحة م²", type: "النوع", property: "العقار" }, options: { buy: "شراء", rent: "إيجار", apartment: "شقة", house: "منزل", land: "أرض" }, description: { badge: "الوصف", title: "نظرة عامة على العقار", description: "اكتب الوصف الذي سيقرأه المشترون والمستأجرون في الإعلان.", manual: "وصف يدوي", ai: "ذكاء ShoufBayt", manualPlaceholder: "اكتب وصف العقار يدوياً...", aiPlaceholder: "اضغط على إنشاء الوصف، ثم عدّل النتيجة إذا احتجت..." }, ai: { badge: "مساعد الذكاء الاصطناعي", title: "إعادة إنشاء الوصف", description: "سيستخدم ذكاء ShoufBayt التفاصيل المحدّثة لإنشاء وصف عقاري احترافي.", generating: "جارٍ الإنشاء...", generate: "إنشاء الوصف" }, location: { badge: "الموقع", title: "تحديث الموقع", description: "انقر على الخريطة، أو استخدم موقعك الحالي، أو الصق عنواناً أو رابط خرائط غوغل، أو ارفع صورة تحتوي على الموقع.", locating: "جارٍ تحديد الموقع...", useMyLocation: "استخدام موقعي", latitude: "خط العرض", longitude: "خط الطول", popup: "موقع العقار المحدد" }, gallery: { badge: "المعرض", title: "صور العقار", description: "احتفظ بالصور القديمة، احذف غير المرغوب بها، حمّل صوراً جديدة، واختر المعاينة الرئيسية.", totalImages: "إجمالي الصور", newImages: "صور جديدة", mainPreviewAlt: "معاينة العقار الرئيسية", mainPreview: "المعاينة الرئيسية", noImage: "لا توجد صورة", noImageText: "قم بتحميل صورة أو الاحتفاظ بصورة واحدة على الأقل.", uploadNewImages: "تحميل صور جديدة", accepted: "JPG, PNG, JPEG, WEBP • الحد الأقصى 8MB لكل صورة", propertyAlt: "عقار", newPropertyAlt: "عقار جديد", old: "قديم", new: "جديد", noImagesLeft: "لا توجد صور متبقية", noImagesLeftText: "يرجى الاحتفاظ بصورة واحدة أو تحميل صورة واحدة على الأقل." }, actions: { cancel: "إلغاء", saving: "جارٍ الحفظ...", saveChanges: "حفظ التغييرات" }, validation: { locationNotSupported: "متصفحك لا يدعم الوصول إلى الموقع.", locationFailed: "فشل الحصول على موقعك. يرجى اختياره يدوياً من الخريطة.", titleFirst: "يرجى كتابة عنوان العقار أولاً.", cityFirst: "يرجى كتابة المدينة أولاً.", priceFirst: "يرجى كتابة سعر صالح أولاً.", maxImages: "يمكنك الاحتفاظ أو تحميل {{max}} صورة كحد أقصى.", imageType: "يُسمح فقط بملفات الصور: JPG أو PNG أو JPEG أو WEBP.", imageSize: "يجب أن يكون حجم كل صورة أقل من 8MB.", titleRequired: "العنوان مطلوب.", priceRequired: "يجب أن يكون السعر أكبر من 0.", cityRequired: "المدينة مطلوبة.", addressRequired: "العنوان مطلوب.", bedroomRequired: "عدد غرف النوم مطلوب.", bathroomRequired: "عدد الحمامات مطلوب.", sizeNegative: "لا يمكن أن تكون المساحة سالبة.", descriptionRequired: "الوصف مطلوب.", imageRequired: "يرجى الاحتفاظ بصورة واحدة أو تحميل صورة واحدة على الأقل.", locationRequired: "يرجى اختيار موقع العقار على الخريطة." }, success: { aiGenerated: "تم إنشاء وصف الذكاء الاصطناعي بنجاح. يمكنك تعديله قبل الحفظ." }, errors: { notFound: "لم يتم العثور على العقار.", loadFailed: "فشل تحميل العقار.", aiFailed: "فشل إنشاء الوصف.", updateFailed: "فشل تحديث العقار." }, alerts: { notAllowedEdit: "غير مسموح لك بتعديل هذا العقار." },
      },
      agents: { hero: { badge: "وكلاء ShoufBayt", title: "تعرّف على خبراء العقارات في ShoufBayt.", description: "تصفح الوكلاء المعتمدين، تحقق من تفاصيلهم، اعرض ملفاتهم الشخصية، وتواصل مع الشخص المناسب لقرارك العقاري القادم.", exploreProperties: "استكشف العقارات", refreshing: "جارٍ التحديث...", refreshAgents: "تحديث الوكلاء" }, stats: { verifiedAgents: "وكلاء موثوقون", activeListings: "إعلانات نشطة", propertySupport: "دعم عقاري" }, states: { loadingTitle: "جارٍ تحميل الوكلاء", loadingMessage: "يرجى الانتظار بينما نقوم بتحميل وكلاء ShoufBayt المعتمدين.", errorTitle: "فشل تحميل الوكلاء", tryAgain: "حاول مرة أخرى", emptyTitle: "لم يتم العثور على وكلاء", emptyMessage: "لا توجد حسابات وكلاء معتمدة حتى الآن. يمكن للمستخدمين طلب أن يصبحوا وكلاء، ويمكن للمسؤولين الموافقة عليهم من لوحة التحكم." }, directory: { badge: "الوكلاء", title: "الوكلاء.", description: "تصفح من يعرض عقارات في لبنان.", agents: "وكلاء", searchPlaceholder: "ابحث بالاسم أو المدينة", count: "{{shown}} من {{total}}", noMatch: "لا يوجد وكلاء مطابقون لهذا البحث." }, card: { defaultName: "وكيل ShoufBayt", defaultTitle: "وكيل عقارات", defaultBio: "وكيل عقارات محترف في ShoufBayt جاهز لمساعدة المستخدمين في العثور على العقار المناسب.", verified: "موثوق", role: "الدور", listings: "الإعلانات", listingsCount: "{{count}} إعلان", location: "الموقع", phone: "الهاتف", email: "البريد الإلكتروني", notProvided: "غير متوفر", viewProfile: "عرض الملف الشخصي" }, bottom: { badge: "لماذا تستخدم وكيلاً؟", title: "اتخذ قرارات عقارية أفضل بدعم احترافي.", cardOneTitle: "إرشاد خبير", cardOneText: "يساعد الوكلاء في شرح تفاصيل العقار والأسعار والموقع والمعلومات المهمة في الإعلان.", cardTwoTitle: "تواصل أسرع", cardTwoText: "تواصل مباشرة مع وكلاء موثوقين للسؤال عن الزيارات وتوفر العقار والخطوات التالية.", cardThreeTitle: "اختيارات أفضل", cardThreeText: "قارن الخيارات بمساعدة احترافية قبل اختيار العقار المناسب." }, errors: { loadFailed: "فشل تحميل الوكلاء." } },
      agentRequest: { guest: { badge: "كن وكيلاً", title: "انضم إلى وكلاء ShoufBayt", description: "سجّل الدخول لطلب أن تصبح وكيلاً موثوقاً في ShoufBayt.", login: "سجّل الدخول أولاً" }, checking: { badge: "التحقق من الحالة", title: "جارٍ تحميل حالة الوكيل الخاصة بك...", description: "يرجى الانتظار بينما نتحقق من أحدث حالة لحسابك." }, verified: { badge: "المكتب مفتوح", title: "مكتبك مفتوح الآن", description: "يمكنك نشر الإعلانات واستقبال الفرص واستخدام مكتب الوكيل.", profile: "افتح مكتبك" }, pending: { badge: "بانتظار المراجعة", title: "طلبك لدى المسؤول", description: "تم حفظ ملفك. سيراجعه المسؤول ويرسل لك بريداً عند القبول أو الرفض.", viewProfile: "عرض الملف" }, rejected: { badge: "تم رفض الطلب", title: "تم رفض طلبك السابق", description: "يمكنك إرسال طلب جديد بمعلومات محدّثة لمراجعة المسؤول." }, default: { badge: "كن وكيلاً", title: "عرّفنا بنفسك.", description: "أكمل ملف الوكيل. يراجع المسؤول الطلب، ويفتح مكتبك بعد الموافقة.", requestAgain: "إرسال الطلب مجدداً", becomeAgent: "ابدأ ملفك" }, modal: { badge: "ملفك", title: "عرّفنا بنفسك.", description: "هذه البطاقة التي سيراجعها المسؤول. بعد الإرسال يصل الطلب إلى مكتب الإدارة." }, form: { fullName: "الاسم الكامل", agentTitle: "مسمى الوكيل", phoneNumber: "رقم الهاتف", location: "الموقع", profileImage: "صورة ملف الوكيل", bio: "نبذة مهنية", fullNamePlaceholder: "اسمك الكامل", agentTitlePlaceholder: "وكيل عقارات", locationPlaceholder: "بيروت، لبنان", agentPreview: "معاينة الوكيل", uploadImage: "تحميل صورة", remove: "إزالة", imageInfo: "JPG, PNG, WEBP • الحد الأقصى 5MB", bioPlaceholder: "اكتب نبذة مهنية قصيرة عن خبرتك في العقارات..." }, buttons: { cancel: "إلغاء", sending: "جارٍ إرسال الطلب...", submit: "حفظ الملف" }, validation: { validImage: "يرجى تحميل ملف صورة صالح.", imageSize: "يجب أن يكون حجم الصورة أقل من 5MB.", nameRequired: "الاسم الكامل مطلوب.", titleRequired: "مسمى الوكيل مطلوب.", phoneRequired: "رقم الهاتف مطلوب.", phoneInvalid: "يمكن أن يحتوي رقم الهاتف على أرقام ومسافات فقط.", locationRequired: "الموقع مطلوب.", bioRequired: "النبذة مطلوبة.", bioLength: "يجب أن تكون النبذة 20 حرفاً على الأقل." }, success: { sent: "تم حفظ الملف. سيراجع المسؤول طلبك." }, errors: { failed: "فشل إرسال طلب الوكيل.", phoneTaken: "رقم الهاتف هذا مستخدم من قبل وكيل آخر.", nameTaken: "الاسم الكامل هذا مستخدم من قبل وكيل آخر." } },
      agentUnlock: {
        pathLabel: "مسار فتح حساب الوكيل",
        steps: { profile: "الملف", review: "المراجعة", live: "أنت مباشر" },
        card: { badge: "بطاقة الوكيل", fallbackName: "وكيل ShoufBayt", fallbackTitle: "وكيل عقارات" },
        handoff: {
          badge: "أُرسل للمراجعة",
          title: "طلبك لدى المسؤول.",
          description: "سيراجع المسؤول هذه البطاقة. يفتح مكتبك بعد الموافقة.",
          continue: "تم",
          later: "البقاء في هذه الصفحة",
        },
        live: { title: "مكتبك مفتوح الآن" },
      },
      agentDetails: { states: { loadingTitle: "جارٍ تحميل الوكيل", loadingMessage: "يرجى الانتظار بينما نقوم بتحميل ملف هذا الوكيل.", errorTitle: "الوكيل غير متاح", notFoundTitle: "لم يتم العثور على الوكيل", notFoundMessage: "ملف هذا الوكيل غير موجود أو ربما تمت إزالته.", backToAgents: "العودة إلى الوكلاء" }, hero: { badge: "وكيل موثوق في ShoufBayt" }, info: { location: "الموقع", phone: "الهاتف", email: "البريد الإلكتروني", activeListings: "الإعلانات النشطة" }, listings: { badge: "الإعلانات", title: "إعلانات الوكيل", description: "عقارات حقيقية منشورة بواسطة هذا الوكيل.", emptyTitle: "لا توجد إعلانات بعد", emptyMessage: "لم يقم هذا الوكيل بنشر أي عقارات بعد." }, chat: { badge: "محادثة مباشرة", title: "تحدث مع الوكيل", description: "ابدأ محادثة مباشرة مع {{name}}.", startDescription: "افتح محادثة خاصة مع هذا الوكيل الموثوق للسؤال عن الإعلانات أو الزيارات أو الأسعار أو تفاصيل العقار.", noMessagesTitle: "لا توجد رسائل بعد", noMessagesText: "ابدأ المحادثة بإرسال رسالة.", placeholder: "اكتب رسالتك...", justNow: "الآن" }, buttons: { openingChat: "جارٍ فتح المحادثة...", contactAgent: "تواصل مع الوكيل", backToAgents: "العودة إلى الوكلاء", startChat: "بدء المحادثة", sending: "جارٍ الإرسال...", send: "إرسال" }, fallback: { agent: "وكيل", thisAgent: "هذا الوكيل", smartEstateAgent: "وكيل ShoufBayt", realEstateAgent: "وكيل عقارات", agentBio: "وكيل عقارات محترف في ShoufBayt.", noLocation: "لا يوجد موقع", noPhone: "لا يوجد هاتف", noEmail: "لا يوجد بريد إلكتروني", property: "عقار", unknownCity: "مدينة غير معروفة", na: "غير متوفر" }, values: { buy: "شراء", rent: "إيجار", apartment: "شقة", house: "منزل", land: "أرض" },         errors: { loadFailed: "فشل تحميل الوكيل.", agentNotConnected: "حساب هذا الوكيل غير متصل بشكل صحيح.", chatYourself: "لا يمكنك محادثة نفسك.", chatFailed: "فشل بدء المحادثة.", sendFailed: "فشل إرسال الرسالة." } },
      agentHub: {
        hero: { badge: "المكتب الخاص", title: "المكتب صار لك.", description: "الفرص والإعلانات وبطاقتك العامة في غرفة واحدة — قدّم، انشر، وأبقِ العملاء يتحركون." },
        links: { addListing: "إضافة إعلان", billing: "الفوترة", profile: "الملف الشخصي", messages: "الرسائل", editCard: "تعديل البطاقة العامة" },
        tabs: { overview: "نظرة عامة", leads: "الفرص", listings: "إعلاناتي", visits: "الزيارات", profile: "البطاقة العامة" },
        stats: { views: "مشاهدات العقارات", saves: "المحفوظات", inquiries: "الاستفسارات", openLeads: "فرص مفتوحة" },
        statsHint: { views: "إجمالي المشاهدات على إعلاناتك", saves: "من حفظوا إعلاناتك", inquiries: "الرسائل خلال آخر 30 يوماً", openLeads: "طلبات ملاك بانتظار عرضك" },
        subscription: {
          label: "Premium",
          trial: "تجربة Premium لمدة 30 يوماً",
          premium: "Premium مفعّل",
          grace: "فترة سماح",
          inactive: "غير نشط — جدّد للاستعادة",
          none: "لا يوجد Premium بعد",
          hasAccess: "وصول كامل للفرص والعروض. ثم ${{price}} شهرياً — بدون عمولة على البيوع.",
          locked: "يتطلب Premium استلام فرص الإدراج وإرسال العروض.",
          manage: "إدارة الفوترة",
        },
        overview: {
          desk: "اليوم على مكتبك",
          nextVisit: "الزيارة التالية",
          noVisit: "لا توجد زيارة قادمة في الجدول.",
          schedule: "جدولة زيارة",
          openLeads: "فرص بانتظارك",
          noLeads: "لا توجد طلبات ملاك مفتوحة حالياً.",
          reviewLeads: "مراجعة الفرص",
          liveListings: "إعلانات نشطة",
          noListings: "لم تنشر أي إعلان بعد.",
          addListing: "إضافة إعلان",
          pipeline: "المسار",
          stageLeads: "جاهز للعرض",
          stageProposed: "تم تقديم العرض",
          stageListings: "إعلاناتك",
          stageVisits: "زيارات قادمة",
        },
        leads: {
          filterAll: "الكل",
          filterOpen: "جاهز للعرض",
          filterProposed: "تم تقديم العرض",
          empty: "لا توجد طلبات مطابقة.",
          emptyHint: "عندما يطلب الملاك إدراج عقار، يراها وكلاء Premium هنا.",
          from: "من",
          proposals: "{{count}} / 10 عروض",
          beds: "{{count}} غرف",
          baths: "{{count}} حمامات",
          noAddress: "لا يوجد عنوان",
          propose: "كتابة عرض",
          hideForm: "إغلاق النموذج",
          pitch: "رسالتك للمالك",
          pitchPlaceholder: "سأسوّق هذا العقار في المنطقة وأنظّم الزيارات وأبقيك على اطلاع…",
          days: "الأيام المتوقعة",
          commission: "نسبة العمولة %",
          send: "إرسال العرض",
          sending: "جارٍ الإرسال…",
          yourProposal: "عرضك",
          daysShort: "{{count}} أيام",
          withdraw: "سحب",
          withdrawing: "جارٍ السحب…",
          declinedHint: "رفض المالك هذا العرض. يمكنك إرسال عرض جديد إلى أن يقبل وكيلاً.",
          proposeAgain: "أرسل عرضاً جديداً",
          statusSent: "مُرسَل",
          statusAccepted: "مقبول",
          statusDeclined: "مرفوض",
          statusWithdrawn: "مسحوب",
          viewListing: "فتح الإعلان",
          requestPreview: "معاينة",
          previewHint: "هذا العقار غير منشور بعد. هذه معاينة خاصة لطلب المالك.",
          previewNotFound: "طلب الإدراج هذا غير متاح.",
          backToLeads: "العودة إلى الفرص",
        },
        listings: {
          title: "إعلاناتك",
          count: "{{count}} عقار على مكتبك",
          empty: "لا توجد إعلانات بعد.",
          emptyHint: "اربح فرصة أو انشر عقاراً خاصاً بك.",
          emptyFilter: "لا يوجد شيء في هذا التصفية.",
          emptyFilterHint: "جرّب حالة أخرى، أو أضف إعلاناً جديداً.",
          ownerManaged: "بإدارة المالك",
          pending: "قيد المراجعة",
          available: "متاح",
          sold: "مباع",
          rented: "مؤجّر",
          markSold: "تحديد كمباع",
          markRented: "تحديد كمؤجّر",
          markAvailable: "إعادة إلى متاح",
          updating: "جارٍ التحديث…",
          view: "عرض",
          edit: "تعديل",
          filterAll: "الكل",
          filterClosed: "مغلقة",
        },
        visits: {
          scheduleTitle: "جدولة زيارة",
          scheduleText: "سجّل معاينة رتّبتها في المحادثة. المشترون يراسلونك من صفحة العقار — لا يوجد نموذج زيارة عام.",
          noListings: "أضف إعلاناً قبل جدولة الزيارات.",
          property: "العقار",
          datetime: "التاريخ والوقت",
          visitorName: "اسم الزائر",
          visitorPhone: "هاتف الزائر",
          status: "الحالة",
          notes: "ملاحظات",
          optional: "اختياري",
          notesPlaceholder: "نقطة اللقاء، المفاتيح، ملاحظات الدخول…",
          pending: "معلّق",
          confirmed: "مؤكد",
          schedule: "جدولة الزيارة",
          scheduling: "جارٍ الجدولة…",
          listTitle: "الجدول",
          filterUpcoming: "القادمة",
          filterPending: "معلّق",
          filterConfirmed: "مؤكد",
          filterCompleted: "مكتمل",
          filterCancelled: "ملغى",
          filterAll: "الكل",
          empty: "لا توجد زيارات في هذا العرض.",
          confirm: "تأكيد",
          reschedule: "إعادة جدولة",
          complete: "إكمال",
          cancel: "إلغاء",
          save: "حفظ",
          ownerManaged: "بإدارة المالك",
        },
        profile: {
          badge: "البطاقة العامة",
          title: "عدّل ملف الوكيل",
          description: "هذا ما يراه المشترون والملاك على صفحة الوكيل العامة.",
          photo: "صورة الملف",
          chooseImage: "اختيار صورة",
          reset: "إعادة تعيين",
          name: "الاسم الكامل",
          jobTitle: "المسمى",
          agency: "الوكالة",
          phone: "الهاتف",
          location: "الموقع",
          website: "الموقع الإلكتروني",
          bio: "نبذة مهنية",
          namePlaceholder: "اسمك الكامل",
          jobTitlePlaceholder: "وكيل عقارات",
          agencyPlaceholder: "اسم الوكالة أو المكتب",
          phonePlaceholder: "+961 …",
          locationPlaceholder: "بيروت، لبنان",
          websitePlaceholder: "https://",
          bioPlaceholder: "اكتب نبذة مهنية قصيرة عن خبرتك العقارية…",
          save: "حفظ البطاقة العامة",
          saving: "جارٍ الحفظ…",
          viewPublic: "عرض الصفحة العامة",
          missing: "بطاقتك العامة غير جاهزة بعد.",
          validation: {
            validImage: "يرجى اختيار ملف صورة صالح.",
            imageSize: "يجب أن يكون حجم الصورة أقل من 5MB.",
            required: "الاسم الكامل والهاتف والموقع والنبذة مطلوبة.",
            nameLength: "يجب أن يكون الاسم الكامل 3 أحرف على الأقل.",
            phone: "يمكن أن يحتوي رقم الهاتف على أرقام ومسافات و+ و- وأقواس فقط.",
            location: "الموقع مطلوب.",
            bio: "يجب أن تكون النبذة 20 حرفاً على الأقل.",
          },
        },
        states: { loading: "جارٍ تجهيز مكتبك…" },
        success: {
          proposed: "تم إرسال العرض إلى المالك.",
          withdrawn: "تم سحب العرض.",
          visitScheduled: "تم جدولة الزيارة.",
          visitUpdated: "تم تعليم الزيارة كـ {{status}}.",
          visitRescheduled: "تم إعادة جدولة الزيارة.",
          sold: "تم تعليم العقار كمباع.",
          rented: "تم تعليم العقار كمؤجّر.",
          available: "تم إعادة العقار إلى متاح.",
          cardUpdated: "تم تحديث بطاقة الوكيل العامة.",
        },
        errors: {
          load: "فشل تحميل مركز الوكيل.",
          premium: "تعذر تحميل الفرص.",
          propose: "فشل إرسال العرض.",
          withdraw: "فشل سحب العرض.",
          visit: "فشل جدولة الزيارة.",
          visitUpdate: "فشل تحديث الزيارة.",
          rescheduleMissing: "اختر تاريخاً ووقتاً جديدين لإعادة الجدولة.",
          reschedule: "فشل إعادة جدولة الزيارة.",
          listing: "فشل تحديث حالة الإعلان.",
          card: "فشل تحديث بطاقة الوكيل العامة.",
        },
      },
      requestListing: {
        hero: {
          badge: "اطلب إعلاناً",
          title: "أدرج عقارك مع وكيل موثوق.",
          description: "أرسل طلباً واحداً. يقدّم الوكلاء عروضهم، تختار وكيلاً، ويجب أن توافق الإدارة قبل نشر الإعلان. لكل إعلان رقم فريد.",
          myRequests: "العروض",
        },
        path: {
          badge: "إعلان جديد",
          title: "كيف تريد إدراج هذا العقار؟",
          description: "اختر وكيلاً واستقبل العروض مجاناً، أو أدرج عقاراً واحداً بنفسك. بعد ذلك تحتاج Premium للإدراج الذاتي مجدداً.",
          agentBadge: "موصى به",
          agentTitle: "يديره وكيل",
          agentText: "يرسل الوكلاء الموثوقون عروضهم. تقارن بينها وتختار من يمثّل العقار. هذا المسار يبقى مجانياً.",
          agentCta: "استقبل العروض",
          selfBadge: "إدراج ذاتي",
          selfTitle: "أدرجه بنفسي",
          selfText: "ترسل الإعلان بنفسك. الإعلان الأول مجاني. بعد ذلك تحتاج Premium. يبقى خاصاً حتى توافق الإدارة، ثم يظهر باسمك.",
          selfCta: "أدرجه بنفسي",
          back: "تغيير طريقة الإدراج",
        },
        stats: {
          brief: "موجزك",
          briefValue: "التفاصيل والصور والموقع",
          agents: "الوكلاء المناسبون",
          agentsValue: "موثوقون وبخطة Premium فقط",
          choice: "النشر",
          choiceValue: "بعد موافقة الإدارة",
        },
        steps: { details: "تفاصيل العقار", confirm: "تأكيد وإرسال" },
        details: {
          badge: "التفاصيل",
          title: "معلومات العقار",
          description: "الحقائق التي يحتاجها الوكلاء ليقرروا إن كان بإمكانهم تمثيل هذا الإعلان.",
        },
        form: {
          title: "العنوان",
          price: "السعر ($)",
          city: "المدينة",
          address: "العنوان",
          listingType: "نوع الإعلان",
          category: "الفئة",
          bedrooms: "غرف النوم",
          bathrooms: "الحمامات",
          garage: "كراج",
          size: "المساحة (م²)",
          phone: "هاتفك",
          description: "الوصف",
          titlePlaceholder: "شقة حديثة في زحلة",
          cityPlaceholder: "مثال: زحلة",
          addressPlaceholder: "الشارع، المبنى، المنطقة",
          descriptionPlaceholder: "صف العقار والتشطيبات والحي ونقاط البيع…",
          landLocked: "غير مستخدم للأراضي",
          buildingLocked: "غير مستخدم للمباني",
        },
        options: {
          sale: "بيع",
          rent: "إيجار",
          apartment: "شقة",
          house: "منزل",
          villa: "فيلا",
          land: "أرض",
          office: "مكتب",
          shop: "محل",
          building: "مبنى",
        },
        location: {
          badge: "الموقع",
          title: "ثبّت موقع العقار",
          description: "انقر على الخريطة، أو استخدم موقعك الحالي، أو الصق عنواناً أو رابط خرائط غوغل، أو ارفع صورة تحتوي على الموقع.",
          locating: "جارٍ تحديد الموقع…",
          useMyLocation: "استخدم موقعي",
          lat: "خط العرض",
          lng: "خط الطول",
          popup: "موقع العقار المحدد",
          pinSet: "تم تثبيت الموقع",
          clickHint: "انقر على الخريطة لوضع الدبوس.",
        },
        media: {
          badge: "الوسائط",
          title: "صور العقار",
          description: "الصور الواضحة تساعد الوكلاء على الرد. صورة واحدة على الأقل مطلوبة.",
          upload: "انقر لرفع الصور",
          hint: "JPG أو PNG أو WEBP · حتى 20 صورة · 20MB للصورة",
          remove: "إزالة",
        },
        verification: {
          badge: "التحقق",
          title: "صورتان خاصتان للإثبات",
          description: "ارفع صورة إثبات ملكية وإفادة عقارية. يراجعها المسؤول قبل ظهور الإعلان. لن تظهر في الصفحة العامة.",
          upload: "أضف إثبات ملكية وإفادة عقارية",
          hint: "JPG أو PNG أو WEBP · صورتان · ملكية + إفادة عقارية · للمسؤول فقط",
        },
        confirm: {
          badge: "جاهز",
          title: "راجع قبل الإرسال",
          description: "سيتم دعوة الوكلاء الموثوقين بخطة Premium الذين يغطون {{city}} ويتعاملون مع عقارات {{property}}. يمكنك مقارنة حتى 10 عروض.",
          yourArea: "منطقتك",
          deal: "الصفقة",
          layout: "التوزيع",
          bedsBaths: "{{beds}} غرف · {{baths}} حمامات",
        },
        done: {
          badge: "تم الإرسال",
          title: "تم إرسال الطلب",
          description: "الوكلاء المُبلَّغون: {{count}}. تابع العروض من ملفك عند وصولها.",
        },
        actions: {
          continue: "متابعة",
          cancel: "إلغاء",
          submit: "إرسال إلى الوكلاء المناسبين",
          submitting: "جارٍ الإرسال…",
          back: "العودة للتعديل",
          viewRequests: "عرض العروض",
          home: "الرئيسية",
        },
        validation: {
          requiredFields: "العنوان والعنوان التفصيلي والمدينة مطلوبة.",
          price: "أدخل سعراً صالحاً.",
          bedrooms: "أدخل عدد غرف النوم.",
          bathrooms: "أدخل عدد الحمامات.",
          garage: "أدخل عدد الكراجات.",
          description: "يجب أن يكون الوصف 20 حرفاً على الأقل.",
          location: "حدّد موقعاً على الخريطة.",
          images: "أضف صورة واحدة على الأقل.",
          verificationImages: "ارفع صورة إثبات ملكية وإفادة عقارية.",
          locationNotSupported: "تحديد الموقع غير مدعوم على هذا الجهاز.",
          locationFailed: "تعذر الحصول على موقعك.",
        },
        success: { submitted: "تم إرسال العقار. يمكن للوكلاء الموثوقين المناسبين إرسال عروض (الحد الأقصى 10)." },
        errors: {
          submit: "فشل إرسال طلب الإعلان.",
          apiOffline:
            "تعذر الوصول إلى الخادم. شغّل واجهة الـ API على المنفذ 8800 ثم أعد المحاولة.",
        },
      },
      chatPage: { hero: { badge: "الرسائل", title: "محادثات فورية.", description: "تحدث مباشرة مع وكلاء العقارات حول الإعلانات من صندوق رسائل ShoufBayt المنظم.", totalConversations: "إجمالي المحادثات", unreadChats: "محادثات غير مقروءة" }, sidebar: { badge: "صندوق الوارد", title: "المحادثات", startNewConversation: "بدء محادثة جديدة", searchPlaceholder: "ابحث في المحادثات...", noMessagesYet: "لا توجد رسائل بعد" }, userPicker: { title: "اختر وكيلاً", description: "ابحث عن الوكلاء المعتمدين حسب الاسم أو البريد الإلكتروني.", searchPlaceholder: "ابحث عن الوكلاء...", loading: "جارٍ تحميل الوكلاء...", noUsers: "لم يتم العثور على وكلاء.", opening: "جارٍ الفتح...", open: "فتح", new: "جديد" }, emptyChats: { title: "لا توجد محادثات", message: "ستظهر محادثاتك هنا عندما تراسل شخصاً ما." }, chatMain: { activeConversation: "محادثة نشطة", secureChat: "محادثة آمنة", loadingMessages: "جارٍ تحميل الرسائل...", messagePlaceholder: "اكتب رسالتك...", sending: "جارٍ الإرسال...", send: "إرسال", clearChat: "مسح المحادثة", clearing: "جارٍ المسح…", backToInbox: "الوارد", attach: "إرفاق صورة أو PDF", recordVoice: "تسجيل ملاحظة صوتية", stopRecording: "إيقاف التسجيل", recording: "جارٍ التسجيل…", deleteVoice: "حذف الملاحظة الصوتية", sendVoice: "إرسال الملاحظة الصوتية", voiceNote: "ملاحظة صوتية", downloadFile: "تنزيل الملف", deleteMessage: "خيارات الرسالة", deleteForMe: "حذف لدي", deleteForEveryone: "حذف لدى الجميع", messageDeleted: "تم حذف هذه الرسالة" }, emptyMessages: { title: "لا توجد رسائل بعد", message: "أرسل رسالة لبدء المحادثة." }, noChat: { title: "اختر أو ابدأ محادثة", message: "اختر محادثة من صندوق الوارد أو ابدأ محادثة جديدة مع مستخدم." }, fallback: { user: "المستخدم", receiver: "المستلم", noEmail: "لا يوجد بريد إلكتروني" }, confirms: { clearChat: "هل تريد مسح كل الرسائل في هذه المحادثة؟ لا يمكن التراجع عن ذلك.", deleteForEveryone: "هل تريد حذف هذه الرسالة لدى الجميع؟ سيظهر لهم أنها حُذفت." }, errors: { openChat: "فشل فتح المحادثة.", loadChats: "فشل تحميل المحادثات.", loadUsers: "فشل تحميل المستخدمين.", openSelectedChat: "فشل فتح المحادثة المحددة.", chatNotCreated: "لم يتم إنشاء المحادثة.", startConversation: "فشل بدء المحادثة.", sendMessage: "فشل إرسال الرسالة.", sendAttachment: "فشل إرسال المرفق.", clearChat: "فشل مسح المحادثة.", microphone: "يلزم الوصول إلى الميكروفون للملاحظات الصوتية.", voiceTooShort: "سجّل ثانية أخرى، ثم أرسل أو احذف الملاحظة الصوتية.", deleteMessage: "فشل حذف الرسالة." } },
      notificationsPage: { hero: { badge: "التنبيهات", title: "ابقَ على اطلاع بحسابك.", description: "الموافقات والمدفوعات وتحديثات الإعلانات ونشاط الحساب في صندوق واحد." }, stats: { total: "الإجمالي", unread: "غير مقروء" }, actions: { markAll: "تحديد الكل كمقروء", deleteAll: "حذف الكل", confirmDeleteAll: "تأكيد الحذف", cancel: "إلغاء", openChat: "فتح الوارد", open: "فتح", markRead: "تحديد كمقروء", delete: "حذف" }, empty: { title: "لا توجد تنبيهات جديدة", message: "ستظهر هنا التحديثات الجديدة عن الإعلانات والمدفوعات والمحادثات.", filteredTitle: "لا يوجد شيء في هذا العرض", filteredMessage: "جرّب تصفية أخرى لعرض بقية التنبيهات." }, states: { loading: "جارٍ تحميل الإشعارات…", deletingAll: "جارٍ الحذف..." }, errors: { load: "فشل تحميل الإشعارات", markAll: "فشل تحديد الكل كمقروء", update: "فشل تحديث الإشعار", delete: "فشل حذف الإشعار", deleteAll: "فشل حذف الإشعارات" }, inbox: { title: "الإشعارات", live: "مباشر", empty: "لا توجد إشعارات بعد", viewAll: "عرض كل الإشعارات", newAlert: "إشعار جديد" }, filters: { all: "الكل", unread: "غير مقروء", messages: "الرسائل", account: "الحساب" }, groups: { today: "اليوم", yesterday: "أمس", earlier: "سابقاً" }, types: { NEW_MESSAGE: "رسالة", CONTACT_REPLY: "الدعم", PROPERTY_APPROVED: "تمت الموافقة على الإعلان", PROPERTY_REJECTED: "تحديث الإعلان", AGENT_APPLICATION_APPROVED: "طلب الوكيل", AGENT_APPLICATION_REJECTED: "طلب الوكيل", PAYMENT_CONFIRMED: "الدفع", PAYMENT_FAILED: "الدفع", SUBSCRIPTION_EXPIRING: "الاشتراك", SUBSCRIPTION_EXPIRED: "الاشتراك", LISTING_REQUEST: "طلب إعلان", LISTING_REQUEST_ACCEPTED: "طلب إعلان", LISTING_REQUEST_REJECTED: "طلب إعلان", LISTING_LEAD: "عميل محتمل", LISTING_PROPOSAL: "عرض", LISTING_PROPOSAL_ACCEPTED: "عرض", LISTING_PROPOSAL_REJECTED: "عرض", APPOINTMENT_SCHEDULED: "زيارة", APPOINTMENT_UPDATED: "زيارة", APPOINTMENT_REQUESTED: "زيارة", APPOINTMENT_REMINDER: "زيارة", GENERAL: "تحديث" } },
      admin: { loading: { title: "جارٍ تحميل مكتب الإدارة", message: "جارٍ جلب المستخدمين والإعلانات والطلبات." }, errorState: { title: "تعذر تحميل المكتب" }, liveChat: { badge: "دردشة مباشرة", title: "محادثات المساعدة", description: "رد على من يستخدم صندوق المساعدة.", empty: "لا توجد محادثات مباشرة بعد.", pick: "اختر محادثة.", loading: "جارٍ تحميل المحادثات…", noMessage: "لا توجد رسائل بعد", error: "تعذر تحميل الدردشة المباشرة." }, header: { badge: "مكتب الإدارة", title: "راجع ما يحتاجك.", description: "فتح حسابات الوكلاء والإعلانات والدعم في طابور واحد." }, buttons: { tryAgain: "حاول مرة أخرى", refreshing: "جارٍ التحديث...", refreshData: "تحديث البيانات", view: "عرض", edit: "تعديل", delete: "حذف", generating: "جارٍ الإنشاء...", generateAIReply: "إنشاء رد بالذكاء الاصطناعي", sending: "جارٍ الإرسال...", sendReply: "إرسال الرد", markAnswered: "تحديد كـ تم الرد" }, notifications: { title: "الإشعارات", clear: "مسح", empty: "لا توجد إشعارات بعد.", now: "الآن", newSupportTitle: "رسالة دعم جديدة", newSupportMessage: "تم استلام {{count}} رسالة أو تقرير جديد.", newAgentRequestTitle: "طلب وكيل جديد", newAgentRequestMessage: "يوجد {{count}} طلب وكيل جديد بانتظار المراجعة.", pendingAgentRequests: "طلبات وكلاء معلقة", pendingAgentRequestsMessage: "يوجد {{count}} طلب بانتظار الموافقة.", pendingListings: "إعلانات بانتظار المراجعة", pendingListingsMessage: "يوجد {{count}} إعلان بانتظار الموافقة.", listingApprovedTitle: "تمت الموافقة على الإعلان", listingApprovedMessage: "أصبح {{title}} ظاهراً الآن.", listingRejectedTitle: "لم تتم الموافقة على الإعلان", listingRejectedMessage: "لم تتم الموافقة على {{title}}.", newMessagesReports: "رسائل / تقارير جديدة", newMessagesReportsMessage: "يوجد {{count}} رسالة تحتاج مراجعة الإدارة.", replySentTitle: "تم إرسال الرد", replySentMessage: "تم حفظ ردك على {{name}} بنجاح.", agentAddedTitle: "تمت إضافة وكيل", agentAddedMessage: "تم إنشاء وكيل جديد بنجاح.", agentRemovedTitle: "تمت إزالة الوكيل", agentRemovedMessage: "تمت إزالة {{name}} بنجاح." }, alertCards: { pendingAgentRequests: "طلبات وكلاء معلقة", pendingAgentRequestsText: "راجع المستخدمين المنتظرين موافقة الوكيل.", newMessagesReports: "رسائل / تقارير جديدة", newMessagesReportsText: "قم بالرد على المستخدمين وتحديث حالات الدعم." }, stats: { totalUsers: "إجمالي المستخدمين", totalAgents: "إجمالي الوكلاء", totalPosts: "إجمالي المنشورات", totalChats: "إجمالي المحادثات", totalMessages: "إجمالي الرسائل", savedPosts: "المنشورات المحفوظة", contactMessages: "رسائل التواصل", newSupport: "دعم جديد" }, tabs: { overview: "نظرة عامة", users: "المستخدمون", posts: "المنشورات", agents: "الوكلاء", agentRequests: "طلبات الوكلاء", messagesReports: "الرسائل / التقارير", payments: "المدفوعات", subscriptions: "الاشتراكات", propertyReports: "تقارير العقارات" }, overview: { latestUsers: "أحدث المستخدمين", latestPosts: "أحدث المنشورات", noLatestUsers: "لا يوجد مستخدمون حديثون.", noLatestPosts: "لا توجد منشورات حديثة." }, users: { badge: "المستخدمون", title: "إدارة المستخدمين", description: "ابحث عن المستخدمين، غيّر الأدوار، واحذف الحسابات.", count: "{{count}} مستخدم", searchPlaceholder: "ابحث باسم المستخدم أو البريد الإلكتروني...", allRoles: "كل الأدوار", usersOnly: "المستخدمون فقط", agentsOnly: "الوكلاء فقط", adminsOnly: "المسؤولون فقط", noUsers: "لم يتم العثور على مستخدمين.", table: { user: "المستخدم", email: "البريد الإلكتروني", role: "الدور", posts: "المنشورات", saved: "المحفوظات", messages: "الرسائل", actions: "الإجراءات" } }, posts: { badge: "الإعلانات", title: "الإعلانات", description: "راجع المنازل المعلقة، ثم افتح أو عدّل أو احذف الإعلانات المنشورة.", count: "{{count}} إعلان", searchPlaceholder: "ابحث بالعنوان أو المدينة أو العنوان أو المالك...", allTypes: "كل الأنواع", allProperties: "كل الفئات", allStatuses: "كل الحالات", noPosts: "لم يتم العثور على إعلانات.", status: { pending: "معلّق", published: "ظاهر", rejected: "مرفوض", sold: "مباع", rented: "مؤجّر" }, table: { property: "العقار", owner: "مدرج بواسطة", city: "المدينة", price: "السعر", type: "النوع", category: "الفئة", status: "الحالة", verification: "صور الإثبات", none: "لا يوجد", actions: "الإجراءات" }, prompts: { rejectReason: "لماذا لا توافق على \"{{title}}\"؟" }, alerts: { reasonRequired: "يرجى إضافة سبب مختصر." } }, agents: { badge: "الوكلاء", title: "إدارة الوكلاء", description: "أضف وكلاء حقيقيين من المستخدمين الحاليين وأزل صلاحية الوكيل.", count: "{{count}} وكيل", addNewAgent: "إضافة وكيل جديد يدوياً", selectExistingUser: "اختر مستخدماً موجوداً", agentFullName: "الاسم الكامل للوكيل", agentTitle: "مسمى الوكيل", phoneNumber: "رقم الهاتف", location: "الموقع", imageUrl: "رابط الصورة اختياري", agentBio: "نبذة الوكيل", addAgent: "إضافة وكيل", email: "البريد الإلكتروني", phone: "الهاتف", locationLabel: "الموقع", listings: "الإعلانات", removeAgent: "إزالة الوكيل", noAgents: "لم يتم العثور على وكلاء." }, agentRequests: { badge: "الطلبات", title: "طلبات الوكلاء", description: "راجع المستخدمين الذين طلبوا أن يصبحوا وكلاء في ShoufBayt.", pending: "{{count}} معلّق" }, messages: { badge: "الدعم", title: "الرسائل / التقارير", description: "اقرأ الملاحظات والتقارير، ورد على المستخدمين، وحدّث الحالات.", count: "{{count}} رسالة", totalMessages: "إجمالي الرسائل", new: "جديد", reports: "التقارير", messages: "الرسائل", message: "رسالة", report: "تقرير", searchPlaceholder: "ابحث بالاسم أو البريد أو الموضوع أو الرسالة أو الرد...", allTypes: "كل الأنواع", allStatus: "كل الحالات", from: "من", adminReply: "رد الإدارة", repliedOn: "تم الرد في", replyToUser: "الرد على المستخدم", replyPlaceholder: "اكتب رد الإدارة...", linkedAccount: "الحساب المرتبط", noMessages: "لم يتم العثور على رسائل." }, messageStatus: { new: "جديد", inReview: "قيد المراجعة", answered: "تم الرد" }, values: { buy: "شراء", rent: "إيجار", apartment: "شقة", house: "منزل", land: "أرض" }, fallback: { user: "المستخدم", agent: "وكيل", property: "عقار", unknown: "غير معروف", unknownDate: "تاريخ غير معروف", noEmail: "لا يوجد بريد إلكتروني", noPhone: "لا يوجد هاتف", noLocation: "لا يوجد موقع", na: "غير متوفر" }, alt: { userAvatar: "صورة المستخدم", property: "العقار" }, alerts: { cannotDeleteSelf: "لا يمكنك حذف حساب المسؤول الخاص بك.", writeReplyFirst: "يرجى كتابة رد أولاً." }, confirms: { deleteUser: "هل أنت متأكد أنك تريد حذف {{username}}؟ سيؤدي ذلك إلى حذف منشوراته ومحفوظاته ومحادثاته ورسائله.", deletePost: "هل أنت متأكد أنك تريد حذف \"{{title}}\"؟", deleteMessage: "هل أنت متأكد أنك تريد حذف هذه الرسالة من {{name}}؟", removeAgent: "هل أنت متأكد أنك تريد إزالة {{name}} من الوكلاء؟ سيبقى حساب المستخدم، لكن الدور سيصبح USER." }, errors: { loadData: "فشل تحميل بيانات لوحة الإدارة", deleteUser: "فشل حذف المستخدم", deletePost: "فشل حذف المنشور", deleteMessage: "فشل حذف الرسالة", updateRole: "فشل تحديث الدور", updateMessageStatus: "فشل تحديث حالة الرسالة", generateAIReply: "فشل إنشاء رد بالذكاء الاصطناعي", sendReply: "فشل إرسال الرد", createAgent: "فشل إنشاء الوكيل", removeAgent: "فشل إزالة الوكيل" } },
      adminAgentRequests: { header: { badge: "مراجعة الإدارة", title: "طلبات الوكلاء", description: "راجع المستخدمين الذين يريدون أن يصبحوا وكلاء موثوقين في ShoufBayt. عند الموافقة على الطلب، يتم إنشاء ملف وكيل، وتغيير دور المستخدم إلى AGENT، وإرسال بريد إلكتروني إلى المستخدم." }, stats: { total: "الإجمالي", pending: "معلّق", approved: "مقبول", rejected: "مرفوض" }, filters: { all: "الكل", pending: "معلّق", approved: "مقبول", rejected: "مرفوض" }, buttons: { clearProcessed: "مسح الطلبات المعالجة", restoreCleared: "استعادة الطلبات الممسوحة", tryAgain: "حاول مرة أخرى", working: "جارٍ المعالجة...", approve: "قبول", reject: "رفض", waitForPayment: "بانتظار الدفع" }, states: { loading: "جارٍ تحميل طلبات الوكلاء...", empty: "لم يتم العثور على طلبات وكلاء." }, labels: { title: "المسمى", payment: "الدفع", phone: "الهاتف", location: "الموقع", bio: "النبذة", message: "الرسالة", adminNote: "ملاحظة الإدارة" }, status: { pending: "معلّق", approved: "مقبول", rejected: "مرفوض", processed: "تمت المعالجة", unpaid: "غير مدفوع", paid: "مدفوع", paymentPending: "الدفع قيد المراجعة", failed: "فشل" }, fallback: { thisUser: "هذا المستخدم", unknownAgent: "وكيل غير معروف", unknown: "غير معروف", noEmail: "لا يوجد بريد إلكتروني", noTitle: "لا يوجد مسمى", noPhone: "لا يوجد هاتف", noLocation: "لا يوجد موقع", noBio: "لا توجد نبذة." }, alt: { agentRequest: "طلب وكيل" }, notes: { approvedByAdmin: "تمت الموافقة من الإدارة", rejectedByAdmin: "تم الرفض من الإدارة" }, confirms: { approve: "هل تريد قبول {{name}} كوكيل موثوق وإرسال بريد إلكتروني؟", clearProcessed: "هل تريد مسح جميع طلبات الوكلاء المقبولة والمرفوضة من هذه الصفحة؟", restoreCleared: "هل تريد استعادة طلبات الوكلاء الممسوحة في هذه الصفحة؟" }, prompts: { rejectReason: "ما سبب رفض طلب {{name}}؟" }, alerts: { noProcessed: "لا توجد طلبات معالجة لمسحها." }, success: { statusUpdated: "تم تحديث حالة الوكيل.", approvedEmailSent: "تم قبول الوكيل وإرسال البريد الإلكتروني بنجاح.", approvedEmailNotSent: "تم قبول الوكيل، لكن لم يتم إرسال البريد الإلكتروني. تحقق من نافذة الباكند.", rejectedEmailSent: "تم رفض الوكيل وإرسال البريد الإلكتروني بنجاح.", rejectedEmailNotSent: "تم رفض الوكيل، لكن لم يتم إرسال البريد الإلكتروني. تحقق من نافذة الباكند." }, errors: { loadFailed: "فشل تحميل طلبات الوكلاء", userIdMissing: "معرّف المستخدم مفقود، لم يتم استدعاء مسار البريد الإلكتروني.", approveFailed: "فشل قبول الطلب", rejectFailed: "فشل رفض الطلب", paymentRequired: "لم يكمل هذا المتقدم الدفع بعد. وافق على الدفع من تبويب المدفوعات أولاً." } },
      adminAnalytics: { header: { badge: "التحليلات", title: "رؤى المنصة", description: "راجع أداء ShoufBayt والنشاط وتوزيع العقارات وحالة الدعم من لوحة تحليلات احترافية واحدة." }, metrics: { averagePrice: "متوسط سعر العقارات", highestPrice: "أعلى سعر عقار", verifiedAgents: "الوكلاء الموثوقون", openReports: "التقارير المفتوحة" }, cards: { usersByRole: "المستخدمون حسب الدور", postsByType: "المنشورات حسب النوع", propertiesByCategory: "العقارات حسب الفئة", messagesByStatus: "الرسائل حسب الحالة" }, roles: { admins: "المسؤولون", agents: "الوكلاء", users: "المستخدمون" }, values: { buy: "شراء", rent: "إيجار", apartment: "شقة", house: "منزل", land: "أرض", villa: "فيلا", office: "مكتب", shop: "محل", warehouse: "مستودع", building: "مبنى" }, status: { open: "مفتوح", read: "مقروء", resolved: "تم الحل" }, locations: { badge: "المواقع", title: "أكثر المدن التي تحتوي على عقارات", listings: "{{count}} إعلان", empty: "لا توجد بيانات مدن متاحة." }, growth: { badge: "النمو", title: "النشاط الشهري", users: "المستخدمون", posts: "المنشورات" }, fallback: { unknown: "غير معروف" } },
    },
  },
};

const savedLanguage =
  localStorage.getItem("shoufbayt_language") ||
  localStorage.getItem("smartestate_language") ||
  "en";

const updateHtmlLanguage = (language) => {
  document.documentElement.lang = language;
  document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
};

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

updateHtmlLanguage(savedLanguage);

i18n.on("languageChanged", (language) => {
  localStorage.setItem("shoufbayt_language", language);
  updateHtmlLanguage(language);
});

export default i18n;
